(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Hull.js"] = factory();
	else
		root["Hull.js"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*************************!*\
  !*** ./src/hull.coffee ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	var Api, Channel, Client, CurrentConfig, CurrentUser, EventBus, HullRemote, Pool, Promise, Raven, _, assign, autoStartConfig, captureException, decodeHash, displayBanner, eeMethods, embeds, hull, hullReady, init, initializePlatform, logger, onEmbedComplete, onEmbedError, onInitFailure, onInitSuccess, parseHash, ready, scriptTagConfig, shimmedMethod,
	  slice = [].slice;
	
	__webpack_require__(/*! ./utils/load-polyfills */ 84);
	
	assign = __webpack_require__(/*! ./polyfills/assign */ 3);
	
	Promise = __webpack_require__(/*! ./utils/promises */ 5);
	
	_ = __webpack_require__(/*! ./utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ./utils/logger */ 4);
	
	Raven = __webpack_require__(/*! ./utils/raven */ 32);
	
	Client = __webpack_require__(/*! ./client */ 145);
	
	CurrentUser = __webpack_require__(/*! ./client/current-user */ 140);
	
	CurrentConfig = __webpack_require__(/*! ./client/current-config */ 139);
	
	Channel = __webpack_require__(/*! ./client/channel */ 79);
	
	Api = __webpack_require__(/*! ./client/api */ 78);
	
	EventBus = __webpack_require__(/*! ./utils/eventbus */ 6);
	
	Pool = __webpack_require__(/*! ./utils/pool */ 165);
	
	HullRemote = __webpack_require__(/*! ./hull-remote */ 152);
	
	embeds = __webpack_require__(/*! ./client/embeds */ 125);
	
	scriptTagConfig = __webpack_require__(/*! ./client/script-tag-config */ 148);
	
	initializePlatform = __webpack_require__(/*! ./client/initialize-platform */ 126);
	
	decodeHash = __webpack_require__(/*! ./utils/decode-hash */ 162);
	
	displayBanner = __webpack_require__(/*! ./utils/ui/display-banner */ 85);
	
	
	/**
	 * Wraps the success callback
	 *
	 * Extends the global object
	 * Reinjects events in the live app from the pool
	 * Replays the track events
	 * @param  {function} userSuccessCallback the function that will be called if everything went well
	 * @param  {object} _hull               an partial build of the Hull object
	 * @param  {object} data                config data coming from the Remote
	 * @return {object}                     the Hull object
	 */
	
	onInitSuccess = function(userSuccessCallback, hull, data) {
	  var app, check, config, hash, me, org, orgOk, orgUrl, origin, platformOk, ref, response, snippet, snippetOrgUrl;
	  userSuccessCallback = userSuccessCallback || function() {};
	  me = data.me, app = data.app, org = data.org;
	  if (app.track_page_inits) {
	    hull.track('hull.app.init');
	  }
	  embeds.initialize({
	    org: org
	  });
	  hull.embed = embeds.embed;
	  hull.onEmbed = embeds.onEmbed;
	  delete hull.initRemote;
	  Pool.run('identify', hull);
	  Pool.run('alias', hull);
	  Pool.run('traits', hull);
	  Pool.run('track', hull);
	  Pool.run('trackForm', hull);
	  ready.resolve({
	    hull: hull,
	    me: me,
	    app: app,
	    org: org
	  });
	  EventBus.emit('hull.ready', hull, me, app, org);
	  EventBus.emit('hull.init', hull, me, app, org);
	  logger.log("Hull.js version \"" + hull.version + "\" started");
	  if (hull.config().embed !== false) {
	    if (_.isArray(app != null ? app.deployments : void 0) && app.deployments.length > 0) {
	      embeds.embed(app.deployments, {}, onEmbedComplete, onEmbedError);
	    } else {
	      onEmbedComplete();
	    }
	  }
	  hash = decodeHash();
	  snippet = hash != null ? (ref = hash.hull) != null ? ref.snippet : void 0 : void 0;
	  if (snippet) {
	    config = hull.config();
	    origin = snippet.origin;
	    platformOk = snippet.platformId === config.appId;
	    snippetOrgUrl = snippet.orgUrl.replace(/^http:/, 'https:');
	    orgUrl = config.orgUrl.replace(/^http:/, 'https:');
	    orgOk = snippetOrgUrl === orgUrl;
	    check = snippet.check;
	    window.location.hash = "";
	    if (orgOk && platformOk) {
	      opener.postMessage({
	        result: check
	      }, origin);
	      EventBus.once('hull.snippet.success', function() {
	        opener.postMessage({
	          result: check
	        }, origin);
	        return window.close();
	      });
	      displayBanner('platform');
	    } else {
	      response = {
	        code: 'invalid',
	        orgUrl: orgUrl,
	        platformId: config.appId
	      };
	      opener.postMessage({
	        error: btoa(JSON.stringify(response))
	      }, origin);
	    }
	  }
	  userSuccessCallback(hull, me, app, org);
	  return hull;
	};
	
	onInitFailure = function(err) {
	  throw err;
	};
	
	onEmbedComplete = function() {
	  EventBus.emit('hull.ships.ready');
	  return logger.log("Hull Embeds Completed successfully");
	};
	
	onEmbedError = function() {
	  var err;
	  err = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return logger.error.apply(logger, ["Failed embedding Ships"].concat(slice.call(err)));
	};
	
	parseHash = function() {
	  var hash, ref, ref1;
	  if (window.location.href.match('//.+\.hullapp\.io/.+/remote.html')) {
	    return;
	  }
	  hash = decodeHash();
	  if ((hash != null) && hash.hasOwnProperty('success')) {
	    window.location.hash = '';
	    if (((typeof window !== "undefined" && window !== null ? (ref = window.opener) != null ? ref.Hull : void 0 : void 0) != null) && (typeof window !== "undefined" && window !== null ? (ref1 = window.opener) != null ? ref1.__hull_login_status__ : void 0 : void 0)) {
	      window.opener.__hull_login_status__(hash);
	      return window.close();
	    }
	  }
	};
	
	parseHash();
	
	captureException = function(err, ctx) {
	  return Raven.captureException(err, ctx);
	};
	
	
	/**
	 * Main Hull Entry Point
	 *
	 * Will only be executed once.
	 * @param  {[type]} config={}         [description]
	 * @param  {[type]} userSuccessCallback [description]
	 * @param  {[type]} userFailureCallback [description]
	 * @return {[type]}                     [description]
	 */
	
	init = function(config, userSuccessCallback, userFailureCallback) {
	  var channel, client, currentConfig, currentUser, httpsRegex, missing, throwErr;
	  if (config == null) {
	    config = {};
	  }
	  if (!!hull._initialized) {
	    throw new Error('Hull.init can be called only once');
	    return;
	  }
	  config.version = ("0.11.0");
	  config.debug = config.debug ? {
	    enabled: true,
	    verbose: config.verbose
	  } : {};
	  logger.init(config.debug);
	  config.appId = config.appId || config.platformId || config.shipId;
	  if (config.platformId != null) {
	    delete config.platformId;
	  }
	  if (config.shipId != null) {
	    delete config.shipId;
	  }
	  missing = [];
	  if (config.orgUrl == null) {
	    missing.push("orgUrl");
	  }
	  if (config.appId == null) {
	    missing.push("platformId");
	  }
	  httpsRegex = /^https:|^\/\//;
	  if (config.jsUrl && !httpsRegex.test(config.jsUrl) && httpsRegex.test(config.jsUrl)) {
	    throw new Error("[Hull.init] jsUrl NEEDS be loaded via https if orgUrl is https");
	  }
	  if (missing.length) {
	    throw new Error("[Hull.init] You forgot to pass " + (missing.join(',')) + " needed to initialize hull properly");
	  }
	  hull._initialized = true;
	  client = {};
	  channel = {};
	  currentUser = new CurrentUser();
	  currentConfig = new CurrentConfig();
	  Raven.init(config.ravenDsn, {
	    runtime: 'hull-js',
	    orgUrl: config.orgUrl,
	    appId: config.appId || config.platformId
	  });
	  throwErr = function(err) {
	    logger.error(err.stack);
	    userFailureCallback = userFailureCallback || function() {};
	    userFailureCallback(err);
	    ready.reject(err);
	    return Raven.captureException(err);
	  };
	  return currentConfig.init(config).then((function(_this) {
	    return function(currentConfig) {
	      channel = new Channel(currentUser, currentConfig);
	      return channel.promise;
	    };
	  })(this), throwErr).then((function(_this) {
	    return function(channel) {
	      return client = new Client(channel, currentUser, currentConfig);
	    };
	  })(this), onInitFailure, throwErr).then((function(_this) {
	    return function(hullClient) {
	      var data;
	      client.hull = assign(hull, client.hull);
	      data = currentConfig.getRemote('data');
	      currentUser.init(data != null ? data.me : void 0);
	      initializePlatform(data, currentConfig, client.hull);
	      return onInitSuccess(userSuccessCallback, client.hull, data);
	    };
	  })(this), throwErr)["catch"](throwErr);
	};
	
	ready = {};
	
	ready.promise = new Promise((function(_this) {
	  return function(resolve, reject) {
	    ready.reject = reject;
	    return ready.resolve = resolve;
	  };
	})(this));
	
	ready.promise["catch"](function(err) {
	  throw new Error('Hull.ready callback error', err);
	});
	
	hullReady = function(callback, errback) {
	  callback = callback || function() {};
	  errback = errback || function() {};
	  return ready.promise.then(function(res) {
	    callback(res.hull, res.me, res.app, res.org);
	    return res;
	  }, errback)["catch"](function(err) {
	    return logger.error(err.message, err.stack);
	  });
	};
	
	shimmedMethod = function(method) {
	  logger.log("Hull." + method + " is only useful when Ships are sandboxed. This method does nothing here");
	  return false;
	};
	
	hull = {
	  _initialized: false,
	  initRemote: HullRemote,
	  init: init,
	  ready: hullReady,
	  version: ("0.11.0"),
	  revision: ("97bf77a6da8cdc61570c42f63e861e47c41c848c"),
	  trackForm: Pool.create('trackForm'),
	  track: Pool.create('track'),
	  traits: Pool.create('traits'),
	  identify: Pool.create('identify'),
	  alias: Pool.create('alias'),
	  captureException: captureException
	};
	
	eeMethods = ['on', 'onAny', 'offAny', 'once', 'many', 'off', 'emit'];
	
	_.map(eeMethods, function(m) {
	  return hull[m] = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return EventBus[m].apply(EventBus, args);
	  };
	});
	
	if (window.Hull == null) {
	  autoStartConfig = scriptTagConfig();
	  if (autoStartConfig && autoStartConfig.autoStart) {
	    if (!hull._initialized) {
	      autoStartConfig && autoStartConfig.autoStart && init(autoStartConfig);
	    }
	  }
	  window.Hull = hull;
	  setTimeout(function() {
	    if ((typeof window !== "undefined" && window !== null ? window.hullAsyncInit : void 0) && _.isFunction(window.hullAsyncInit)) {
	      return window.hullAsyncInit(hull);
	    }
	  }, 0);
	} else {
	  logger.error("Hull Snippet found more than once (or you already have a global variable named window.Hull). Either way, we can't launch Hull more than once. We only use the first one in the page");
	}
	
	module.exports = hull;


/***/ }),
/* 1 */
/*!*****************************!*\
  !*** ./src/utils/lodash.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* global require */
	
	module.exports = {
	  compact: __webpack_require__(/*! lodash/compact */ 288),
	  uniq: __webpack_require__(/*! lodash/uniq */ 325),
	  size: __webpack_require__(/*! lodash/size */ 318),
	  includes: __webpack_require__(/*! lodash/includes */ 301),
	  reject: __webpack_require__(/*! lodash/reject */ 317),
	  toArray: __webpack_require__(/*! lodash/toArray */ 322),
	  defaults: __webpack_require__(/*! lodash/defaults */ 291),
	  isElement: __webpack_require__(/*! lodash/isElement */ 303),
	  each: __webpack_require__(/*! lodash/each */ 292),
	  partition: __webpack_require__(/*! lodash/partition */ 313),
	  every: __webpack_require__(/*! lodash/every */ 293),
	  indexOf: __webpack_require__(/*! lodash/indexOf */ 302),
	  isEmpty: __webpack_require__(/*! lodash/isEmpty */ 304),
	  throttle: __webpack_require__(/*! lodash/throttle */ 321),
	  isArray: __webpack_require__(/*! lodash/isArray */ 2),
	  isEqual: __webpack_require__(/*! lodash/isEqual */ 305),
	  isFunction: __webpack_require__(/*! lodash/isFunction */ 68),
	  isObject: __webpack_require__(/*! lodash/isObject */ 7),
	  isString: __webpack_require__(/*! lodash/isString */ 45),
	  isUndefined: __webpack_require__(/*! lodash/isObject */ 7),
	  keys: __webpack_require__(/*! lodash/keys */ 13),
	  map: __webpack_require__(/*! lodash/map */ 307),
	  find: __webpack_require__(/*! lodash/find */ 295),
	  filter: __webpack_require__(/*! lodash/filter */ 294),
	  values: __webpack_require__(/*! lodash/values */ 73),
	  omit: __webpack_require__(/*! lodash/omit */ 312),
	  pick: __webpack_require__(/*! lodash/pick */ 314),
	  reduce: __webpack_require__(/*! lodash/reduce */ 316),
	  some: __webpack_require__(/*! lodash/some */ 319),
	  fromPairs: __webpack_require__(/*! lodash/fromPairs */ 299)
	};

/***/ }),
/* 2 */
/*!*****************************!*\
  !*** ./~/lodash/isArray.js ***!
  \*****************************/
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 3 */
/*!*********************************!*\
  !*** ./src/polyfills/assign.js ***!
  \*********************************/
/***/ (function(module, exports) {

	"use strict";
	
	Object.assign = Object.assign || function assign(target, source) {
	  for (var index = 1, key; index in arguments; ++index) {
	    source = arguments[index];
	
	    for (key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};
	module.exports = Object.assign;

/***/ }),
/* 4 */
/*!*********************************!*\
  !*** ./src/utils/logger.coffee ***!
  \*********************************/
/***/ (function(module, exports) {

	var enabled, error, log, verbose,
	  slice = [].slice;
	
	enabled = false;
	
	verbose = false;
	
	log = function() {
	  var args;
	  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return console.log.apply(console, args);
	};
	
	error = function() {
	  var args;
	  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return console.error.apply(console, args);
	};
	
	module.exports = {
	  enabled: function() {
	    return !!enabled;
	  },
	  init: function(debug) {
	    enabled = !!debug.enabled;
	    return verbose = !!debug.verbose;
	  },
	  log: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled) {
	      return log.apply(null, args);
	    }
	  },
	  info: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled) {
	      return log.apply(null, args);
	    }
	  },
	  verbose: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled && verbose) {
	      return log.apply(null, args);
	    }
	  },
	  warn: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return console.warn.apply(console, args);
	  },
	  error: error
	};


/***/ }),
/* 5 */
/*!***********************************!*\
  !*** ./src/utils/promises.coffee ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Promise;
	
	Promise = __webpack_require__(/*! bluebird/js/browser/bluebird.core */ 136);
	
	Promise.config({
	  warnings: false,
	  longStackTraces: true,
	  cancellation: true,
	  monitoring: true
	});
	
	Promise.deferred = Promise.deferred || function() {
	  var dfd;
	  dfd = {};
	  dfd.promise = new Promise((function(_this) {
	    return function(resolve, reject) {
	      dfd.resolve = resolve;
	      return dfd.reject = reject;
	    };
	  })(this));
	  return dfd;
	};
	
	module.exports = Promise;


/***/ }),
/* 6 */
/*!*******************************!*\
  !*** ./src/utils/eventbus.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _eventemitter = __webpack_require__(/*! eventemitter2 */ 87);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var emitter = new _eventemitter2['default']({
	  wildcard: true,
	  maxListeners: 200,
	  newListener: false,
	  delimiter: '.'
	});
	module.exports = emitter;

/***/ }),
/* 7 */
/*!******************************!*\
  !*** ./~/lodash/isObject.js ***!
  \******************************/
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 8 */
/*!***************************!*\
  !*** ./~/lodash/_root.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ 106);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 9 */
/*!*********************************!*\
  !*** ./~/lodash/isArrayLike.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(/*! ./isFunction */ 68),
	    isLength = __webpack_require__(/*! ./isLength */ 69);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 10 */
/*!***********************************!*\
  !*** ./~/lodash/_baseIteratee.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(/*! ./_baseMatches */ 204),
	    baseMatchesProperty = __webpack_require__(/*! ./_baseMatchesProperty */ 205),
	    identity = __webpack_require__(/*! ./identity */ 42),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    property = __webpack_require__(/*! ./property */ 315);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 11 */
/*!****************************!*\
  !*** ./src/utils/clone.js ***!
  \****************************/
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (obj) {
	  if (obj === undefined) {
	    return obj;
	  }
	  return JSON.parse(JSON.stringify(obj));
	};

/***/ }),
/* 12 */
/*!**********************************!*\
  !*** ./~/lodash/isObjectLike.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 13 */
/*!**************************!*\
  !*** ./~/lodash/keys.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ 93),
	    baseKeys = __webpack_require__(/*! ./_baseKeys */ 61),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 14 */
/*!***********************************************!*\
  !*** ./src/flux/constants/RemoteConstants.js ***!
  \***********************************************/
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  UPDATE_CLIENT_CONFIG: 'UPDATE_CLIENT_CONFIG',
	  UPDATE_REMOTE_CONFIG: 'UPDATE_REMOTE_CONFIG',
	  UPDATE_SERVICES: 'UPDATE_SERVICES',
	
	  SET_HEADER: 'SET_HEADER',
	
	  LOGOUT_USER: 'LOGOUT_USER',
	  UPDATE_USER: 'UPDATE_USER'
	};

/***/ }),
/* 15 */
/*!*****************************!*\
  !*** ./src/utils/base64.js ***!
  \*****************************/
/***/ (function(module, exports) {

	'use strict';
	
	// https://code.google.com/p/stringencoders/source/browse/trunk/javascript/base64.js?r=230
	
	var PADCHAR = '=';
	var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	function makeDOMException() {
	  // sadly in FF,Safari,Chrome you can't make a DOMException
	  var e, tmp;
	
	  try {
	    return new DOMException(DOMException.INVALID_CHARACTER_ERR);
	  } catch (tmp) {
	    // not available, just passback a duck-typed equiv
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
	    var ex = new Error("DOM Exception 5");
	
	    // ex.number and ex.description is IE-specific.
	    ex.code = ex.number = 5;
	    ex.name = ex.description = "INVALID_CHARACTER_ERR";
	
	    // Safari/Chrome output format
	    ex.toString = function () {
	      return 'Error: ' + ex.name + ': ' + ex.message;
	    };
	    return ex;
	  }
	}
	
	function getbyte64(s, i) {
	  // This is oddly fast, except on Chrome/V8.
	  // Minimal or no improvement in performance by using a
	  // object with properties mapping chars to value (eg. 'A': 0)
	  var idx = ALPHA.indexOf(s.charAt(i));
	  if (idx === -1) {
	    throw makeDOMException();
	  }
	  return idx;
	}
	
	function getbyte(s, i) {
	  var x = s.charCodeAt(i);
	  if (x > 255) {
	    throw makeDOMException();
	  }
	  return x;
	}
	
	function encode(s) {
	  if (arguments.length !== 1) {
	    throw new SyntaxError("Not enough arguments");
	  }
	  var padchar = PADCHAR;
	  var alpha = ALPHA;
	
	  var i, b10;
	  var x = [];
	
	  // convert to string
	  s = '' + s;
	
	  var imax = s.length - s.length % 3;
	
	  if (s.length === 0) {
	    return s;
	  }
	  for (i = 0; i < imax; i += 3) {
	    b10 = getbyte(s, i) << 16 | getbyte(s, i + 1) << 8 | getbyte(s, i + 2);
	    x.push(alpha.charAt(b10 >> 18));
	    x.push(alpha.charAt(b10 >> 12 & 0x3F));
	    x.push(alpha.charAt(b10 >> 6 & 0x3f));
	    x.push(alpha.charAt(b10 & 0x3f));
	  }
	  switch (s.length - imax) {
	    case 1:
	      b10 = getbyte(s, i) << 16;
	      x.push(alpha.charAt(b10 >> 18) + alpha.charAt(b10 >> 12 & 0x3F) + padchar + padchar);
	      break;
	    case 2:
	      b10 = getbyte(s, i) << 16 | getbyte(s, i + 1) << 8;
	      x.push(alpha.charAt(b10 >> 18) + alpha.charAt(b10 >> 12 & 0x3F) + alpha.charAt(b10 >> 6 & 0x3f) + padchar);
	      break;
	  }
	  return x.join('');
	}
	
	function decode(s) {
	  // convert to string
	  s = '' + s;
	  var pads, i, b10;
	  var imax = s.length;
	  if (imax === 0) {
	    return s;
	  }
	
	  if (imax % 4 !== 0) {
	    throw makeDOMException();
	  }
	
	  pads = 0;
	  if (s.charAt(imax - 1) === PADCHAR) {
	    pads = 1;
	    if (s.charAt(imax - 2) === PADCHAR) {
	      pads = 2;
	    }
	    // either way, we want to ignore this last block
	    imax -= 4;
	  }
	
	  var x = [];
	  for (i = 0; i < imax; i += 4) {
	    b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12 | getbyte64(s, i + 2) << 6 | getbyte64(s, i + 3);
	    x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff, b10 & 0xff));
	  }
	
	  switch (pads) {
	    case 1:
	      b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12 | getbyte64(s, i + 2) << 6;
	      x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff));
	      break;
	    case 2:
	      b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12;
	      x.push(String.fromCharCode(b10 >> 16));
	      break;
	  }
	  return x.join('');
	}
	
	function encodeURL(input) {
	  return encodeURIComponent(encode(input).replace(/\+/g, '-').replace(/\//g, '_'));
	}
	
	function decodeURL(input) {
	  return decode(decodeURIComponent(input).replace(/-/g, '+').replace(/_/g, '/'));
	}
	
	module.exports = { encode: encode, decode: decode, encodeURL: encodeURL, decodeURL: decodeURL };

/***/ }),
/* 16 */
/*!*****************************!*\
  !*** ./~/lodash/_Symbol.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(/*! ./_root */ 8);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 17 */
/*!*******************************!*\
  !*** ./~/lodash/_baseEach.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(/*! ./_baseForOwn */ 194),
	    createBaseEach = __webpack_require__(/*! ./_createBaseEach */ 233);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 18 */
/*!*********************************!*\
  !*** ./~/lodash/_baseGetTag.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16),
	    getRawTag = __webpack_require__(/*! ./_getRawTag */ 242),
	    objectToString = __webpack_require__(/*! ./_objectToString */ 271);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 19 */
/*!********************************!*\
  !*** ./~/lodash/_getNative.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(/*! ./_baseIsNative */ 200),
	    getValue = __webpack_require__(/*! ./_getValue */ 243);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 20 */
/*!***********************************************!*\
  !*** ./src/utils/query-string-encoder.coffee ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Qs, decoder, keywords;
	
	Qs = __webpack_require__(/*! qs */ 327);
	
	keywords = {
	  "true": true,
	  "false": false,
	  "null": null,
	  undefined: void 0
	};
	
	decoder = function(value) {
	  if (/^(\d+|\d*\.\d+)$/.test(value)) {
	    return parseFloat(value);
	  }
	  if (value in keywords) {
	    return keywords[value];
	  }
	  return value;
	};
	
	module.exports = {
	  encode: function(data) {
	    return Qs.stringify(data);
	  },
	  decode: function(search) {
	    if (!search) {
	      return Qs.parse(window.location.search.slice(1), {
	        decoder: decoder
	      });
	    }
	    return Qs.parse(search);
	  }
	};


/***/ }),
/* 21 */
/*!*******************************!*\
  !*** ./~/lodash/_castPath.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(/*! ./isArray */ 2),
	    isKey = __webpack_require__(/*! ./_isKey */ 66),
	    stringToPath = __webpack_require__(/*! ./_stringToPath */ 284),
	    toString = __webpack_require__(/*! ./toString */ 324);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 22 */
/*!*********************************!*\
  !*** ./~/lodash/_copyObject.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(/*! ./_assignValue */ 58),
	    baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 95);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 23 */
/*!****************************!*\
  !*** ./~/lodash/_toKey.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(/*! ./isSymbol */ 46);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 24 */
/*!*************************************************!*\
  !*** ./src/flux/dispatcher/RemoteDispatcher.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flux = __webpack_require__(/*! flux */ 170);
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	var RemoteDispatcher = assign(new flux.Dispatcher(), {
	  handleAction: function handleAction(action) {
	    this.dispatch({ action: action });
	  }
	});
	
	module.exports = RemoteDispatcher;

/***/ }),
/* 25 */
/*!********************************************!*\
  !*** ./src/flux/stores/RemoteUserStore.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 33).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 24);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 14);
	
	var CHANGE_EVENT = 'change';
	
	var state = {
	  user: null
	};
	
	var isSameId = function isSameId(value) {
	  return value === (state.user && state.user.id);
	};
	
	var isUpToDate = function isUpToDate(user) {
	  if (!user && !state.user) {
	    return true;
	  }
	  return user && state.user && user.updated_at === state.user.updated_at;
	};
	
	var RemoteUserStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(changeEvent) {
	    this.emit(CHANGE_EVENT, changeEvent);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state;
	  },
	  isSameId: isSameId,
	  isUpToDate: isUpToDate,
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.LOGOUT_USER:
	        state.user = null;
	        if (!action.options.silent === true) {
	          RemoteUserStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        if (!isUpToDate(action.user)) {
	          state.user = action.user;
	          if (!action.options.silent === true) {
	            RemoteUserStore.emitChange(action.actionType);
	          }
	        }
	        break;
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteUserStore;

/***/ }),
/* 26 */
/*!********************************!*\
  !*** ./src/utils/throw.coffee ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Raven, logger;
	
	logger = __webpack_require__(/*! ./logger */ 4);
	
	Raven = __webpack_require__(/*! ./raven */ 32);
	
	module.exports = function(err) {
	  Raven.captureException(err);
	  return logger.error(err.message, err.stack);
	};


/***/ }),
/* 27 */
/*!*****************************!*\
  !*** ./~/lodash/_getTag.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(/*! ./_DataView */ 174),
	    Map = __webpack_require__(/*! ./_Map */ 52),
	    Promise = __webpack_require__(/*! ./_Promise */ 176),
	    Set = __webpack_require__(/*! ./_Set */ 88),
	    WeakMap = __webpack_require__(/*! ./_WeakMap */ 177),
	    baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    toSource = __webpack_require__(/*! ./_toSource */ 116);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 28 */
/*!*********************************!*\
  !*** ./~/lodash/_setToArray.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 29 */
/*!************************!*\
  !*** ./~/lodash/eq.js ***!
  \************************/
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 30 */
/*!**********************************************!*\
  !*** ./src/flux/stores/RemoteConfigStore.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 33).EventEmitter;
	var _ = __webpack_require__(/*! ../../utils/lodash */ 1);
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 24);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 14);
	
	var CHANGE_EVENT = 'change';
	
	var state = {};
	
	var RemoteConfigStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(changeEvent) {
	    this.emit(CHANGE_EVENT, changeEvent);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getAuth: function getAuth(provider) {
	    if (state && state.services && state.services.auth && state.services.auth[provider]) {
	      return state.services.auth[provider];
	    }
	    return undefined;
	  },
	  getHullToken: function getHullToken() {
	    return state.access_token;
	  },
	  getState: function getState() {
	    return state;
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.UPDATE_REMOTE_CONFIG:
	        state = action.config;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_SERVICES:
	        state.services = action.services;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        state.access_token = action.user.access_token;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.LOGOUT_USER:
	        delete state.access_token;
	        if (state.services && state.services.auth) {
	          _.map(state.services, function (services, type) {
	            _.map(services, function (service, key) {
	              delete service.credentials;
	              // Since Hull Storage doesnt have the same format as the others :(
	              if (type === 'storage') {
	                delete service.params;
	              }
	            });
	          });
	        }
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteConfigStore;

/***/ }),
/* 31 */
/*!**********************************!*\
  !*** ./src/utils/cookies.coffee ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var COOKIES_ENABLED, Cookies;
	
	Cookies = __webpack_require__(/*! cookies-js */ 86);
	
	COOKIES_ENABLED = '_ce';
	
	module.exports = {
	  set: Cookies.set,
	  get: Cookies.get,
	  remove: Cookies.expire,
	  enabled: function() {
	    return Cookies._areEnabled();
	  }
	};


/***/ }),
/* 32 */
/*!********************************!*\
  !*** ./src/utils/raven.coffee ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, pending, script, userContext;
	
	script = __webpack_require__(/*! ./script-loader */ 51);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	pending = [];
	
	userContext = {};
	
	module.exports = {
	  init: function(dsn, context) {
	    if (dsn && !window.Raven) {
	      return script({
	        src: 'https://cdn.ravenjs.com/2.1.1/raven.min.js'
	      }).then(function() {
	        window.Raven.config(dsn, {
	          release: ("97bf77a6da8cdc61570c42f63e861e47c41c848c"),
	          whitelistUrls: [/hull/]
	        }).install();
	        window.Raven.setExtraContext(context);
	        window.Raven.setUserContext(userContext);
	        return _.map(pending.splice(0), function(e) {
	          return window.Raven.captureException(e.err, e.ctx);
	        });
	      });
	    }
	  },
	  setUserContext: function(ctx) {
	    if (window.Raven && window.Raven.setUserContext) {
	      return window.Raven.setUserContext(ctx);
	    } else {
	      return userContext = ctx;
	    }
	  },
	  captureException: function(err, ctx) {
	    if (window.Raven && window.Raven.captureException) {
	      return window.Raven.captureException(err, ctx);
	    } else {
	      return pending.push({
	        err: err,
	        ctx: ctx
	      });
	    }
	  }
	};


/***/ }),
/* 33 */
/*!****************************!*\
  !*** ./~/events/events.js ***!
  \****************************/
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 34 */
/*!********************************!*\
  !*** ./~/lodash/_ListCache.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(/*! ./_listCacheClear */ 257),
	    listCacheDelete = __webpack_require__(/*! ./_listCacheDelete */ 258),
	    listCacheGet = __webpack_require__(/*! ./_listCacheGet */ 259),
	    listCacheHas = __webpack_require__(/*! ./_listCacheHas */ 260),
	    listCacheSet = __webpack_require__(/*! ./_listCacheSet */ 261);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 35 */
/*!*******************************!*\
  !*** ./~/lodash/_arrayMap.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 36 */
/*!***********************************!*\
  !*** ./~/lodash/_assocIndexOf.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(/*! ./eq */ 29);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 37 */
/*!******************************!*\
  !*** ./~/lodash/_baseGet.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(/*! ./_castPath */ 21),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 38 */
/*!*********************************!*\
  !*** ./~/lodash/_getMapData.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(/*! ./_isKeyable */ 254);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 39 */
/*!******************************!*\
  !*** ./~/lodash/_isIndex.js ***!
  \******************************/
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 40 */
/*!**********************************!*\
  !*** ./~/lodash/_isPrototype.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 41 */
/*!***********************************!*\
  !*** ./~/lodash/_nativeCreate.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 42 */
/*!******************************!*\
  !*** ./~/lodash/identity.js ***!
  \******************************/
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 43 */
/*!*********************************!*\
  !*** ./~/lodash/isArguments.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(/*! ./_baseIsArguments */ 196),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 44 */
/*!******************************!*\
  !*** ./~/lodash/isBuffer.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ 8),
	    stubFalse = __webpack_require__(/*! ./stubFalse */ 320);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 48)(module)))

/***/ }),
/* 45 */
/*!******************************!*\
  !*** ./~/lodash/isString.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 46 */
/*!******************************!*\
  !*** ./~/lodash/isSymbol.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 47 */
/*!************************************!*\
  !*** ./~/superagent/lib/client.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(/*! emitter */ 167);
	var reduce = __webpack_require__(/*! reduce */ 331);
	var requestBase = __webpack_require__(/*! ./request-base */ 333);
	var isObject = __webpack_require__(/*! ./is-object */ 124);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(/*! ./request */ 334).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr && this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 48 */
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 49 */
/*!**********************************************!*\
  !*** ./src/flux/stores/RemoteHeaderStore.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 33).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 24);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 14);
	var RemoteUserStore = __webpack_require__(/*! ../stores/RemoteUserStore */ 25);
	
	var CHANGE_EVENT = 'change';
	var ACCESS_TOKEN_HEADER = 'Hull-Access-Token';
	var USER_ID_HEADER = 'Hull-User-Id';
	var APP_ID_HEADER = 'Hull-App-Id';
	
	var state = {
	  headers: {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json'
	  }
	};
	function getHeader(header) {
	  return state.headers[header];
	}
	function setHeader(header, value) {
	  state.headers[header] = value;
	}
	function destroyHeader(header) {
	  delete state.headers[header];
	}
	
	var RemoteHeaderStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(change) {
	    this.emit(CHANGE_EVENT, change);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state.headers;
	  },
	  getHeader: function getHeader(h) {
	    return state.headers[h];
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	    switch (action.actionType) {
	
	      case RemoteConstants.UPDATE_REMOTE_CONFIG:
	        if (action) {
	          if (action.config && action.config.appId) {
	            setHeader(APP_ID_HEADER, action.config.appId);
	          }
	        }
	        break;
	
	      case RemoteConstants.UPDATE_SETTINGS:
	        if (action && action.services && action.services.auth && action.services.auth.hull && action.services.auth.hull.credentials) {
	          setHeader(ACCESS_TOKEN_HEADER, action.services.auth.hull.credentials.access_token);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        if (action.user.id != getHeader(USER_ID_HEADER) || action.user.access_token != getHeader(ACCESS_TOKEN_HEADER)) {
	          if (action.user && action.user.access_token) {
	            setHeader(USER_ID_HEADER, action.user.id);
	            setHeader(ACCESS_TOKEN_HEADER, action.user.access_token);
	          } else {
	            destroyHeader(ACCESS_TOKEN_HEADER);
	            destroyHeader(USER_ID_HEADER);
	          }
	          RemoteHeaderStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.LOGOUT_USER:
	        destroyHeader(ACCESS_TOKEN_HEADER);
	        destroyHeader(USER_ID_HEADER);
	        if (!action.options.silent === true) {
	          RemoteHeaderStore.emitChange(action.actionType);
	        }
	        break;
	
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteHeaderStore;

/***/ }),
/* 50 */
/*!***********************************!*\
  !*** ./src/utils/find-url.coffee ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, domWalker, getDOMUrl, getOGUrl, getPageUrl;
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	domWalker = __webpack_require__(/*! ./dom-walker */ 81);
	
	getDOMUrl = function(sourceNode) {
	  var body, link, matchingNode, node;
	  if (!domWalker.isNode(sourceNode)) {
	    return;
	  }
	  body = document.body;
	  node = sourceNode;
	  while (node && node !== body) {
	    link = domWalker.getLinkValue(node);
	    if (!link) {
	      matchingNode = _.find(domWalker.getSiblings(node), domWalker.getLinkValue);
	      link = domWalker.getLinkValue(matchingNode);
	    }
	    if (link != null) {
	      return link;
	    }
	    node = node.parentNode;
	  }
	};
	
	getPageUrl = function() {
	  return window.location.href;
	};
	
	getOGUrl = function() {
	  return domWalker.getMetaValue('og:url');
	};
	
	module.exports = function(node) {
	  var u;
	  u = getDOMUrl(node) || getOGUrl() || getPageUrl();
	  return u.replace(/[#\/]*$/, '');
	};


/***/ }),
/* 51 */
/*!****************************************!*\
  !*** ./src/utils/script-loader.coffee ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Promise, _, logger;
	
	Promise = __webpack_require__(/*! ./promises */ 5);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	logger = __webpack_require__(/*! ./logger */ 4);
	
	module.exports = function(opts) {
	  var doc, sc;
	  if (opts == null) {
	    opts = {};
	  }
	  doc = opts.document || window.document;
	  sc = document.createElement("script");
	  return new Promise(function(resolve, reject) {
	    var done, errorTimeout, ref;
	    errorTimeout = setTimeout(function() {
	      var error;
	      error = new Error("Error loading " + opts.src + ".\nConnectivity issue?");
	      logger.error(error, error.message, error.stack);
	      return reject(error);
	    }, 60000);
	    if (opts.attributes) {
	      _.map(opts.attributes, function(value, key) {
	        return sc.setAttribute(key, value);
	      });
	    }
	    if (opts.id) {
	      sc.id = opts.id;
	    }
	    sc.src = opts.src;
	    done = false;
	    sc.onload = sc.onreadystatechange = function() {
	      if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
	        clearTimeout(errorTimeout);
	        done = true;
	        resolve(sc);
	        return sc.onload = sc.onreadystatechange = null;
	      }
	    };
	    return (ref = doc.getElementsByTagName('head')[0]) != null ? ref.appendChild(sc) : void 0;
	  });
	};


/***/ }),
/* 52 */
/*!**************************!*\
  !*** ./~/lodash/_Map.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19),
	    root = __webpack_require__(/*! ./_root */ 8);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 53 */
/*!*******************************!*\
  !*** ./~/lodash/_MapCache.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(/*! ./_mapCacheClear */ 262),
	    mapCacheDelete = __webpack_require__(/*! ./_mapCacheDelete */ 263),
	    mapCacheGet = __webpack_require__(/*! ./_mapCacheGet */ 264),
	    mapCacheHas = __webpack_require__(/*! ./_mapCacheHas */ 265),
	    mapCacheSet = __webpack_require__(/*! ./_mapCacheSet */ 266);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 54 */
/*!****************************!*\
  !*** ./~/lodash/_Stack.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(/*! ./_ListCache */ 34),
	    stackClear = __webpack_require__(/*! ./_stackClear */ 276),
	    stackDelete = __webpack_require__(/*! ./_stackDelete */ 277),
	    stackGet = __webpack_require__(/*! ./_stackGet */ 278),
	    stackHas = __webpack_require__(/*! ./_stackHas */ 279),
	    stackSet = __webpack_require__(/*! ./_stackSet */ 280);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 55 */
/*!**********************************!*\
  !*** ./~/lodash/_arrayFilter.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 56 */
/*!********************************!*\
  !*** ./~/lodash/_arrayPush.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 57 */
/*!**********************************!*\
  !*** ./~/lodash/_arrayReduce.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 58 */
/*!**********************************!*\
  !*** ./~/lodash/_assignValue.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 95),
	    eq = __webpack_require__(/*! ./eq */ 29);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 59 */
/*!**********************************!*\
  !*** ./~/lodash/_baseIndexOf.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ 97),
	    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ 199),
	    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ 281);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 60 */
/*!**********************************!*\
  !*** ./~/lodash/_baseIsEqual.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(/*! ./_baseIsEqualDeep */ 197),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 61 */
/*!*******************************!*\
  !*** ./~/lodash/_baseKeys.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(/*! ./_isPrototype */ 40),
	    nativeKeys = __webpack_require__(/*! ./_nativeKeys */ 268);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 62 */
/*!***************************************!*\
  !*** ./~/lodash/_cloneArrayBuffer.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(/*! ./_Uint8Array */ 90);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 63 */
/*!***********************************!*\
  !*** ./~/lodash/_getPrototype.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(/*! ./_overArg */ 113);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 64 */
/*!*********************************!*\
  !*** ./~/lodash/_getSymbols.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ 55),
	    stubArray = __webpack_require__(/*! ./stubArray */ 119);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 65 */
/*!*************************************!*\
  !*** ./~/lodash/_isIterateeCall.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(/*! ./eq */ 29),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    isIndex = __webpack_require__(/*! ./_isIndex */ 39),
	    isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 66 */
/*!****************************!*\
  !*** ./~/lodash/_isKey.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(/*! ./isArray */ 2),
	    isSymbol = __webpack_require__(/*! ./isSymbol */ 46);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 67 */
/*!*********************************!*\
  !*** ./~/lodash/_mapToArray.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 68 */
/*!********************************!*\
  !*** ./~/lodash/isFunction.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 69 */
/*!******************************!*\
  !*** ./~/lodash/isLength.js ***!
  \******************************/
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 70 */
/*!**********************************!*\
  !*** ./~/lodash/isTypedArray.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(/*! ./_baseIsTypedArray */ 201),
	    baseUnary = __webpack_require__(/*! ./_baseUnary */ 216),
	    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ 270);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 71 */
/*!****************************!*\
  !*** ./~/lodash/keysIn.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ 93),
	    baseKeysIn = __webpack_require__(/*! ./_baseKeysIn */ 202),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 72 */
/*!*******************************!*\
  !*** ./~/lodash/toInteger.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(/*! ./toFinite */ 323);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 73 */
/*!****************************!*\
  !*** ./~/lodash/values.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(/*! ./_baseValues */ 219),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 74 */
/*!*******************************************!*\
  !*** ./src/flux/actions/RemoteActions.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 24);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 14);
	var RemoteUserStore = __webpack_require__(/*! ../stores/RemoteUserStore */ 25);
	
	var RemoteSettingsActions = {
	  updateClientConfig: function updateClientConfig(config) {
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_CLIENT_CONFIG,
	      config: config
	    });
	  },
	  updateRemoteConfig: function updateRemoteConfig(config) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_REMOTE_CONFIG,
	      config: config,
	      options: options
	    });
	  },
	  updateServices: function updateServices(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_SERVICES,
	      services: services,
	      options: options
	    });
	  },
	  logoutUser: function logoutUser() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.LOGOUT_USER,
	      options: options
	    });
	  },
	  updateUser: function updateUser(user) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_USER,
	      user: user,
	      options: options
	    });
	  },
	  updateUserIfMe: function updateUserIfMe(data) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // We don't know if it's a Me object. for now it's just a bundle of data from the API.
	    if (data.body && RemoteUserStore.isSameId(data.body.id)) {
	      RemoteDispatcher.handleAction({
	        actionType: RemoteConstants.UPDATE_USER,
	        user: data.body,
	        options: options
	      });
	    }
	  }
	};
	
	module.exports = RemoteSettingsActions;

/***/ }),
/* 75 */
/*!***************************************!*\
  !*** ./src/remote/wrapped-request.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _lodash = __webpack_require__(/*! ../utils/lodash */ 1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var wrappedRequest = function wrappedRequest(service, gateway) {
	  var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return function query(request, callback, errback) {
	    if (!callback) {
	      callback = function callback() {};
	    }
	    if (!errback) {
	      errback = function errback() {};
	    }
	
	    var path = request.path;
	
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    path = service.name !== "hull" ? "services/#{service.path}/#{path}" : path;
	
	    if (service.name !== "hull") {
	      request.params = request.method.toLowerCase() === "delete" ? JSON.stringify(request.params || {}) : request.params;
	    }
	
	    var req = (0, _assign2["default"])({}, request, { path: path });
	    var handle = gateway.handle(req);
	    _lodash2["default"].each(middlewares, function (m) {
	      handle = handle.then(m, m);
	    });
	
	    handle = handle.then(function (response) {
	      response = (0, _assign2["default"])({}, response, { provider: service.name });
	
	      if (response.status >= 200 && response.status < 300) {
	        return response;
	      } else {
	        throw response.body || response;
	      }
	    });
	
	    handle.then(callback, errback);
	
	    return handle;
	  };
	};
	
	module.exports = wrappedRequest;

/***/ }),
/* 76 */
/*!*******************************!*\
  !*** ./src/utils/domready.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  * domready (c) Dustin Diaz 2012 - License MIT
	  */
	!function (name, definition) {
	  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
	}('domready', function (ready, scope) {
	
	  var fns = [],
	      _fn2,
	      f = false,
	      doc = scope || document,
	      testEl = doc.documentElement,
	      hack = testEl.doScroll,
	      domContentLoaded = 'DOMContentLoaded',
	      addEventListener = 'addEventListener',
	      onreadystatechange = 'onreadystatechange',
	      readyState = 'readyState',
	      loadedRgx = hack ? /^loaded|^c/ : /^loaded|^i|^c/,
	      loaded = loadedRgx.test(doc[readyState]);
	
	  function flush(f) {
	    loaded = 1;
	    while (f = fns.shift()) {
	      f();
	    }
	  }
	
	  doc[addEventListener] && doc[addEventListener](domContentLoaded, _fn2 = function fn() {
	    doc.removeEventListener(domContentLoaded, _fn2, f);
	    flush();
	  }, f);
	
	  hack && doc.attachEvent(onreadystatechange, _fn2 = function _fn() {
	    if (/^c/.test(doc[readyState])) {
	      doc.detachEvent(onreadystatechange, _fn2);
	      flush();
	    }
	  });
	
	  return ready = hack ? function (fn) {
	    self != top ? loaded ? fn() : fns.push(fn) : function () {
	      try {
	        testEl.doScroll('left');
	      } catch (e) {
	        return setTimeout(function () {
	          ready(fn);
	        }, 50);
	      }
	      fn();
	    }();
	  } : function (fn) {
	    loaded ? fn() : fns.push(fn);
	  };
	});

/***/ }),
/* 77 */
/*!**************************!*\
  !*** ./src/utils/xdm.js ***!
  \**************************/
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * xdm.js – Nicolas Gallagher – MIT License
	 * easyXDM – Copyright(c) 2009-2011, Øyvind Sean Kinsey, oyvind@kinsey.no – MIT License
	 */
	
	// stores namespace under which the 'xdm' object is stored on the page
	// (empty if object is global)
	var namespace = "";
	var xdm = {};
	// map over global xdm in case of overwrite
	var _xdm = window.xdm;
	var IFRAME_PREFIX = 'xdm_';
	
	var iframe = document.createElement('IFRAME');
	// randomize the initial id in case multiple closures are loaded
	var channelId = Math.floor(Math.random() * 10000);
	var emptyFn = Function.prototype;
	// returns groups for protocol (2), domain (3) and port (4)
	var reURI = /^((http.?:)\/\/([^:\/\s]+)(:\d+)*)/;
	// matches a foo/../ expression
	var reParent = /[\-\w]+\/\.\.\//;
	// matches `//` anywhere but in the protocol
	var reDoubleSlash = /([^:])\/\//g;
	
	/**
	 * Helper for adding and removing cross-browser event listeners
	 */
	
	var addEvent = function () {
	    if (window.addEventListener) {
	        return function (target, type, listener) {
	            target.addEventListener(type, listener, false);
	        };
	    }
	    return function (target, type, listener) {
	        target.attachEvent('on' + type, listener);
	    };
	}();
	
	var removeEvent = function () {
	    if (window.removeEventListener) {
	        return function (target, type, listener) {
	            target.removeEventListener(type, listener, false);
	        };
	    }
	    return function (target, type, listener) {
	        target.detachEvent('on' + type, listener);
	    };
	}();
	
	/**
	 * Build the query object from location.hash
	 */
	
	var query = function (input) {
	    input = input.substring(1, input.length).split('&');
	    var data = {},
	        pair,
	        i = input.length;
	    while (i--) {
	        pair = input[i].split('=');
	        data[pair[0]] = decodeURIComponent(pair[1]);
	    }
	    return data;
	}(location.hash);
	
	// -------------------------------------------------------------------------
	
	/**
	 * xdm object setup
	 */
	
	xdm.version = "1.0.1";
	xdm.stack = {};
	xdm.query = query;
	xdm.checkAcl = checkAcl;
	
	/**
	 * Removes the `xdm` variable from the global scope. It also returns control
	 * of the `xdm` variable to the code that used it before.
	 *
	 * @param {String} ns A string representation of an object that will hold
	 *   an instance of xdm.
	 * @return {xdm}
	 */
	
	xdm.noConflict = function (ns) {
	    window.xdm = _xdm;
	    namespace = ns;
	    if (namespace) {
	        IFRAME_PREFIX = 'xdm_' + namespace.replace('.', '_') + '_';
	    }
	    return xdm;
	};
	
	// -------------------------------------------------------------------------
	
	/**
	 * Helper for testing if an object is an array
	 *
	 * @param {Object} obj The object to test
	 * @return {Boolean}
	 */
	
	function isArray(obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	}
	
	/**
	 * Helper for testing if a variable/property is undefined
	 *
	 * @param {Object} variable The variable to test
	 * @return {Boolean}
	 */
	
	function undef(variable) {
	    return typeof variable === 'undefined';
	}
	
	/**
	 * Returns a string containing the schema, domain and if present the port
	 *
	 * @param {String} url The url to extract the location from
	 * @return {String} The location part of the url
	 */
	
	function getLocation(url) {
	    if (!url) {
	        throw new Error('url is undefined or empty');
	    }
	    var m = url.toLowerCase().match(reURI);
	    if (m) {
	        var proto = m[2],
	            domain = m[3],
	            port = m[4] || '';
	        if (proto === 'http:' && port === ':80' || proto === 'https:' && port === ':443') {
	            port = '';
	        }
	        return proto + '//' + domain + port;
	    }
	
	    return url;
	}
	
	/**
	 * Resolves a relative url into an absolute one.
	 *
	 * @param {String} url The path to resolve.
	 * @return {String} The resolved url.
	 */
	function resolveUrl(url) {
	    if (!url) {
	        throw new Error('url is undefined or empty');
	    }
	
	    // replace all `//` except the one in proto with `/`
	    url = url.replace(reDoubleSlash, '$1/');
	
	    // if the url is a valid url we do nothing
	    if (!url.match(/^(http||https):\/\//)) {
	        // If this is a relative path
	        var path = url.substring(0, 1) === '/' ? '' : location.pathname;
	        if (path.substring(path.length - 1) !== '/') {
	            path = path.substring(0, path.lastIndexOf('/') + 1);
	        }
	
	        url = location.protocol + '//' + location.host + path + url;
	    }
	
	    // reduce all 'xyz/../' to just ''
	    while (reParent.test(url)) {
	        url = url.replace(reParent, '');
	    }
	
	    return url;
	}
	
	/**
	 * Applies properties from the source object to the target object.
	 *
	 * @param {Object} destination The target of the properties.
	 * @param {Object} source The source of the properties.
	 * @param {Boolean} noOverwrite Set to True to only set non-existing properties.
	 */
	
	function merge(destination, source, noOverwrite) {
	    var member;
	    for (var prop in source) {
	        if (source.hasOwnProperty(prop)) {
	            if (prop in destination) {
	                member = source[prop];
	                if ((typeof member === 'undefined' ? 'undefined' : _typeof(member)) === 'object') {
	                    merge(destination[prop], member, noOverwrite);
	                } else if (!noOverwrite) {
	                    destination[prop] = source[prop];
	                }
	            } else {
	                destination[prop] = source[prop];
	            }
	        }
	    }
	    return destination;
	}
	
	/**
	 * GUEST ONLY
	 * Check whether a host domain is allowed using an Access Control List.
	 * The ACL can contain `*` and `?` as wildcards, or can be regular expressions.
	 * If regular expressions they need to begin with `^` and end with `$`.
	 *
	 * @param {Array/String} acl The list of allowed domains
	 * @param {String} domain The domain to test.
	 * @return {Boolean} True if the domain is allowed, false if not.
	 */
	
	function checkAcl(acl, domain) {
	    // normalize into an array
	    if (typeof acl === 'string') {
	        acl = [acl];
	    }
	    var re;
	    var i = acl.length;
	    while (i--) {
	        re = acl[i];
	        re = new RegExp(re.substr(0, 1) === '^' ? re : '^' + re.replace(/(\*)/g, '.$1').replace(/\?/g, '.') + '$');
	        if (re.test(domain)) {
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * HOST ONLY
	 * Appends the parameters to the given url.
	 * The base url can contain existing query parameters.
	 *
	 * @param {String} url The base url.
	 * @param {Object} parameters The parameters to add.
	 * @return {String} A new valid url with the parameters appended.
	 */
	
	function appendQueryParameters(url, parameters) {
	    if (!parameters) {
	        throw new Error('parameters is undefined or null');
	    }
	
	    var indexOf = url.indexOf('#');
	    var q = [];
	    for (var key in parameters) {
	        if (parameters.hasOwnProperty(key)) {
	            q.push(key + '=' + encodeURIComponent(parameters[key]));
	        }
	    }
	
	    return url + (indexOf === -1 ? '#' : '&') + q.join('&');
	}
	
	/**
	 * HOST ONLY
	 * Creates an iframe and appends it to the DOM.
	 *
	 * @param {Object} config This iframe configuration object
	 * @return {Element} The frames DOM Element
	 */
	
	function createFrame(config) {
	    var frame = iframe.cloneNode(false);
	
	    // merge the defaults with the configuration properties
	    merge(config.props, {
	        frameBorder: 0,
	        allowTransparency: true,
	        scrolling: 'no',
	        width: '100%',
	        src: appendQueryParameters(config.remote, {
	            xdm_e: getLocation(location.href),
	            xdm_c: config.channel,
	            xdm_p: 1
	        }),
	        name: IFRAME_PREFIX + config.channel + '_provider',
	        style: {
	            margin: 0,
	            padding: 0,
	            border: 0
	        }
	    });
	
	    frame.id = config.props.name;
	    delete config.props.name;
	
	    // if no container, then we cannot proceed
	    if (!config.container) {
	        throw new Error('xdm.Rpc() configuration object missing a DOM "container" property');
	    }
	
	    // merge config properties into the frame
	    merge(frame, config.props);
	
	    config.container.appendChild(frame);
	
	    if (config.onLoad) {
	        addEvent(frame, 'load', config.onLoad);
	    }
	
	    // if we're injecting HTML directly into the iframe
	    if (config.html) {
	        frame.contentWindow.document.open();
	        frame.contentWindow.document.write(config.html);
	        frame.contentWindow.document.close();
	    }
	
	    // pass a reference to the frame around so that it can be exposed on the
	    // rpc object
	    config.iframe = frame;
	
	    return frame;
	}
	
	/**
	 * Prepares an array of stack-elements suitable for the current configuration
	 *
	 * @param {Object} config The Transports configuration.
	 * @return {Array} An array of stack-elements with the TransportElement at index 0.
	 */
	
	function prepareTransportStack(config) {
	    var stackEls;
	
	    config.isHost = config.isHost || undef(query.xdm_p);
	    config.props = config.props || {};
	
	    if (!config.isHost) {
	        config.channel = query.xdm_c.replace(/["'<>\\]/g, '');
	        config.remote = query.xdm_e.replace(/["'<>\\]/g, '');
	
	        if (config.acl && !checkAcl(config.acl, config.remote)) {
	            throw new Error('Access denied for ' + config.remote);
	        }
	    } else {
	        config.remote = resolveUrl(config.remote);
	        config.channel = config.channel || 'default' + channelId++;
	    }
	
	    stackEls = [new xdm.stack.PostMessageTransport(config)];
	    // this behavior is responsible for buffering outgoing messages
	    stackEls.push(new xdm.stack.QueueBehavior(true));
	
	    return stackEls;
	}
	
	/**
	 * Chains all the separate stack elements into a single usable stack.
	 * If an element is missing a necessary method then it will have a pass-through method applied.
	 *
	 * @param {Array} stackElements An array of stack elements to be linked.
	 * @return {xdm.stack.StackElement} The last element in the chain.
	 */
	
	function chainStack(stackElements) {
	    var stackEl;
	    var i;
	    var len = stackElements.length;
	
	    var defaults = {
	        incoming: function incoming(message, origin) {
	            this.up.incoming(message, origin);
	        },
	        outgoing: function outgoing(message, recipient) {
	            this.down.outgoing(message, recipient);
	        },
	        callback: function callback(success) {
	            this.up.callback(success);
	        },
	        init: function init() {
	            this.down.init();
	        },
	        destroy: function destroy() {
	            this.down.destroy();
	        }
	    };
	
	    for (i = 0; i < len; i++) {
	        stackEl = stackElements[i];
	        merge(stackEl, defaults, true);
	
	        if (i !== 0) {
	            stackEl.down = stackElements[i - 1];
	        }
	
	        if (i !== len - 1) {
	            stackEl.up = stackElements[i + 1];
	        }
	    }
	
	    return stackEl;
	}
	
	/**
	 * This will remove a stackelement from its stack while leaving the stack functional.
	 *
	 * @param {Object} element The elment to remove from the stack.
	 */
	
	function removeFromStack(element) {
	    element.up.down = element.down;
	    element.down.up = element.up;
	    element.up = element.down = null;
	}
	
	/**
	 * xdm.Rpc
	 *
	 * Creates a proxy object that can be used to call methods implemented on the
	 * remote end of the channel, and also to provide the implementation of methods
	 * to be called from the remote end.
	 *
	 * The instantiated object will have methods matching those specified in
	 * `config.remote`.
	 *
	 * @param {Object} config The underlying transport configuration.
	 *   remote: The remote window's location
	 *   html: HTML to inject into a sourceless iframe
	 *   container: The iframe's container DOM element
	 *   props: Object of the properties that should be set on the frame
	 *   acl: An array of domains to add to the Access Control List
	 *   onReady: A function to call when communication has been established
	 *   onLoad: A function to called – with the iframe's `contentWindow` as
	 *     the argument – when the frame is fully loaded
	 * @param {Object} jsonRpcConfig The description of the interface to implement.
	 */
	
	xdm.Rpc = function (config, jsonRpcConfig) {
	    var member;
	
	    // expand shorthand notation
	    if (jsonRpcConfig.local) {
	        for (var method in jsonRpcConfig.local) {
	            if (jsonRpcConfig.local.hasOwnProperty(method)) {
	                member = jsonRpcConfig.local[method];
	                if (typeof member === 'function') {
	                    jsonRpcConfig.local[method] = {
	                        method: member
	                    };
	                }
	            }
	        }
	    }
	
	    // create the stack
	    var stack = chainStack(prepareTransportStack(config).concat([new xdm.stack.RpcBehavior(this, jsonRpcConfig), {
	        callback: function callback(success) {
	            if (config.onReady) config.onReady(success);
	        }
	    }]));
	
	    // set the origin
	    this.origin = getLocation(config.remote);
	
	    // initiates the destruction of the stack.
	    this.destroy = function () {
	        stack.destroy();
	    };
	
	    stack.init();
	
	    // store a reference to the iframe that is created
	    this.iframe = config.iframe;
	};
	
	/**
	 * xdm.stack.PostMessageTransport
	 *
	 * PostMessageTransport uses HTML5 postMessage for communication.
	 *
	 * @param {Object} config The transports configuration.
	 */
	
	xdm.stack.PostMessageTransport = function (config) {
	    var pub;
	    var frame;
	    var callerWindow;
	    var targetOrigin;
	
	    /**
	     * This is the main implementation for the onMessage event.
	     * It checks the validity of the origin and passes the message on if appropriate.
	     *
	     * @param {Object} event The message event
	     */
	
	    function checkOrigin(origin, target) {
	        return origin === targetOrigin || /^file/.test(targetOrigin);
	    }
	
	    function _windowOnMessage(event) {
	        var origin = getLocation(event.origin);
	        var dataIsString = typeof event.data === 'string';
	        if (checkOrigin(origin, targetOrigin) && dataIsString && event.data.substring(0, config.channel.length + 1) === config.channel + ' ') {
	            pub.up.incoming(event.data.substring(config.channel.length + 1), origin);
	        }
	    }
	
	    pub = {
	        outgoing: function outgoing(message, domain, fn) {
	            callerWindow.postMessage(config.channel + ' ' + message, domain || targetOrigin);
	            if (fn) {
	                fn();
	            }
	        },
	
	        destroy: function destroy() {
	            removeEvent(window, 'message', _windowOnMessage);
	            if (frame) {
	                callerWindow = null;
	                frame.parentNode.removeChild(frame);
	                frame = null;
	            }
	        },
	
	        init: function init() {
	            targetOrigin = getLocation(config.remote);
	            if (config.isHost) {
	                // add the event handler for listening
	                var waitForReady = function waitForReady(event) {
	                    if (frame && event.data === config.channel + '-ready') {
	                        if ('postMessage' in frame.contentWindow) {
	                            callerWindow = frame.contentWindow;
	                        } else {
	                            callerWindow = frame.contentWindow.document;
	                        }
	
	                        // replace the eventlistener
	                        removeEvent(window, 'message', waitForReady);
	                        addEvent(window, 'message', _windowOnMessage);
	
	                        setTimeout(function () {
	                            pub.up.callback(true);
	                        }, 0);
	                    }
	                };
	
	                addEvent(window, 'message', waitForReady);
	                frame = createFrame(config);
	            } else {
	                // add the event handler for listening
	                addEvent(window, 'message', _windowOnMessage);
	                if ('postMessage' in window.parent) {
	                    callerWindow = window.parent;
	                } else {
	                    callerWindow = window.parent.document;
	                }
	
	                callerWindow.postMessage(config.channel + '-ready', targetOrigin);
	
	                setTimeout(function () {
	                    pub.up.callback(true);
	                }, 0);
	            }
	        }
	    };
	
	    return pub;
	};
	
	/**
	 * xdm.stack.QueueBehavior
	 *
	 * This is a behavior that enables queueing of messages.
	 * It will buffer incoming messages and dispach these as fast as the underlying transport allows.
	 *
	 * @param {Boolean} remove If true, it will remove from the stack
	 */
	
	xdm.stack.QueueBehavior = function (remove) {
	    var pub;
	    var queue = [];
	    var waiting = true;
	    var incoming = '';
	    var destroying;
	
	    function dispatch() {
	        var message;
	
	        if (remove === true && queue.length === 0) {
	            removeFromStack(pub);
	            return;
	        }
	        if (waiting || queue.length === 0 || destroying) {
	            return;
	        }
	
	        waiting = true;
	        message = queue.shift();
	
	        pub.down.outgoing(message.data, message.origin, function (success) {
	            waiting = false;
	            if (message.callback) {
	                setTimeout(function () {
	                    message.callback(success);
	                }, 0);
	            }
	            dispatch();
	        });
	    }
	
	    pub = {
	        init: function init() {
	            pub.down.init();
	        },
	
	        callback: function callback(success) {
	            waiting = false;
	            // in case dispatch calls removeFromStack
	            var up = pub.up;
	            dispatch();
	            up.callback(success);
	        },
	
	        incoming: function incoming(message, origin) {
	            pub.up.incoming(message, origin);
	        },
	
	        outgoing: function outgoing(message, origin, fn) {
	            queue.push({
	                data: message,
	                origin: origin,
	                callback: fn
	            });
	
	            dispatch();
	        },
	
	        destroy: function destroy() {
	            destroying = true;
	            pub.down.destroy();
	        }
	    };
	
	    return pub;
	};
	
	/**
	 * xdm.stack.RpcBehavior
	 *
	 * This uses JSON-RPC 2.0 to expose local methods and to invoke remote methods
	 * and have responses returned over the the string based transport stack.
	 *
	 * Exposed methods can return values synchronously, asynchronously, or not at all.
	 *
	 * @param {Object} proxy The object to apply the methods to.
	 * @param {Object} config The definition of the local and remote interface to implement.
	 *   local: The local interface to expose.
	 *   remote: The remote methods to expose through the proxy.
	 */
	
	xdm.stack.RpcBehavior = function (proxy, config) {
	    var pub;
	    var _callbackCounter = 0;
	    var _callbacks = {};
	
	    /**
	     * Serializes and sends the message
	     *
	     * @param {Object} data The JSON-RPC message to be sent. The jsonrpc property will be added.
	     */
	
	    function _send(data) {
	        data.jsonrpc = '2.0';
	        pub.down.outgoing(JSON.stringify(data));
	    }
	
	    /**
	     * Creates a method that implements the given definition
	     *
	     * @param {Object} definition The method configuration
	     * @param {String} method The name of the method
	     * @return {Function} A stub capable of proxying the requested method call
	     */
	
	    function _createMethod(definition, method) {
	        var slice = Array.prototype.slice;
	
	        return function () {
	            var l = arguments.length;
	            var callback;
	            var message = {
	                method: method
	            };
	
	            if (l > 0 && typeof arguments[l - 1] === 'function') {
	                // one callback, procedure
	                if (l > 1 && typeof arguments[l - 2] === 'function') {
	                    // two callbacks, success and error
	                    callback = {
	                        success: arguments[l - 2],
	                        error: arguments[l - 1]
	                    };
	                    message.params = slice.call(arguments, 0, l - 2);
	                } else {
	                    // single callback, success
	                    callback = {
	                        success: arguments[l - 1]
	                    };
	                    message.params = slice.call(arguments, 0, l - 1);
	                }
	                _callbacks['' + ++_callbackCounter] = callback;
	                message.id = _callbackCounter;
	            } else {
	                // no callbacks, a notification
	                message.params = slice.call(arguments, 0);
	            }
	
	            if (definition.namedParams && message.params.length === 1) {
	                message.params = message.params[0];
	            }
	            // Send the method request
	            _send(message);
	        };
	    }
	
	    /**
	     * Executes the exposed method
	     *
	     * @param {String} method The name of the method
	     * @param {Number} id The callback id to use
	     * @param {Function} fn The exposed implementation
	     * @param {Array} params The parameters supplied by the remote end
	     */
	
	    function _executeMethod(method, id, fn, params) {
	        if (!fn) {
	            if (id) {
	                _send({
	                    id: id,
	                    error: {
	                        code: -32601,
	                        message: 'Procedure not found.'
	                    }
	                });
	            }
	            return;
	        }
	
	        var _success;
	        var _error;
	
	        if (id) {
	            _success = function success(result) {
	                _success = emptyFn;
	                _send({
	                    id: id,
	                    result: result
	                });
	            };
	
	            _error = function error(message, data) {
	                _error = emptyFn;
	                var msg = {
	                    id: id,
	                    error: {
	                        code: -32099,
	                        message: message
	                    }
	                };
	
	                if (data) {
	                    msg.error.data = data;
	                }
	                _send(msg);
	            };
	        } else {
	            _success = _error = emptyFn;
	        }
	
	        // call local method
	        if (!isArray(params)) {
	            params = [params];
	        }
	
	        try {
	            var result = fn.method.apply(fn.scope, params.concat([_success, _error]));
	            if (!undef(result)) {
	                _success(result);
	            }
	        } catch (ex1) {
	            _error(ex1.message);
	        }
	    }
	
	    pub = {
	        incoming: function incoming(message, origin) {
	            var data = JSON.parse(message);
	            var callback;
	
	            if (data.method) {
	                // a method call from the remote end
	                if (config.handle) {
	                    config.handle(data, _send);
	                } else {
	                    _executeMethod(data.method, data.id, config.local[data.method], data.params);
	                }
	            } else {
	                // a method response from the other end
	                callback = _callbacks[data.id];
	                if (data.error && callback.error) {
	                    callback.error(data.error);
	                } else if (callback.success) {
	                    callback.success(data.result);
	                }
	                delete _callbacks[data.id];
	            }
	        },
	
	        init: function init() {
	            if (config.remote) {
	                // implement the remote sides exposed methods
	                for (var method in config.remote) {
	                    if (config.remote.hasOwnProperty(method)) {
	                        proxy[method] = _createMethod(config.remote[method], method);
	                    }
	                }
	            }
	            pub.down.init();
	        },
	
	        destroy: function destroy() {
	            for (var method in config.remote) {
	                if (config.remote.hasOwnProperty(method) && proxy.hasOwnProperty(method)) {
	                    delete proxy[method];
	                }
	            }
	            pub.down.destroy();
	        }
	    };
	
	    return pub;
	};
	
	module.exports = xdm;

/***/ }),
/* 78 */
/*!*******************************!*\
  !*** ./src/client/api.coffee ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var Api, EventBus, Promise, channel, logger, parseOpts,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	parseOpts = __webpack_require__(/*! ./parse-opts */ 146);
	
	channel = __webpack_require__(/*! ./channel */ 79);
	
	Api = (function() {
	  function Api(channel, currentUser, currentConfig) {
	    this.updateCurrentUserCookies = bind(this.updateCurrentUserCookies, this);
	    this._updateCurrentUser = bind(this._updateCurrentUser, this);
	    this.updateCurrentUser = bind(this.updateCurrentUser, this);
	    this.refreshUser = bind(this.refreshUser, this);
	    this.message = bind(this.message, this);
	    var authScope, data, ref;
	    this.channel = channel;
	    this.currentConfig = currentConfig;
	    this.currentUser = currentUser;
	    EventBus.on('hull.settings.update', function(settings) {
	      return currentConfig.setRemote(settings, 'settings');
	    });
	    data = this.currentConfig.getRemote('data');
	    authScope = ((ref = data.headers) != null ? ref['Hull-Auth-Scope'] : void 0) ? data.headers['Hull-Auth-Scope'].split(":")[0] : '';
	    if ((data.headers != null)) {
	      this.currentUser.setCookies(data.headers, currentConfig.get('appId'));
	    }
	    this._message = (function(_this) {
	      return function(params, userSuccessCallback, userErrorCallback) {};
	    })(this);
	  }
	
	
	  /*
	   * Sends the message described by @params to xdm
	   * @param {Object} contains the provider, uri and parameters for the message
	   * @param {Function} optional a success callback
	   * @param {Function} optional an error callback
	   * @return {Promise}
	   */
	
	  Api.prototype.message = function() {
	    var callback, errback, opts, ref;
	    if (!this.channel.rpc) {
	      return logger.error("Hull Api is not initialized yet. You should run your app from the callback of Hull.ready()");
	    }
	    ref = parseOpts(Array.prototype.slice.call(arguments)), opts = ref.opts, callback = ref.callback, errback = ref.errback;
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var onError, onSuccess;
	        onSuccess = function(res) {
	          if (res == null) {
	            res = {};
	          }
	          return _this.updateCurrentUser(res).then(function() {
	            _this.updateCurrentUserCookies(res.headers, res.provider);
	            callback(res.body);
	            return resolve(res.body);
	          });
	        };
	        onError = function(response, error) {
	          errback(response.message, error);
	          return reject(response.message, error);
	        };
	        return _this.channel.rpc.message(opts, onSuccess, onError);
	      };
	    })(this));
	  };
	
	  Api.prototype.refreshUser = function() {
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var onError, onSuccess;
	        onSuccess = function(response) {
	          if (response == null) {
	            response = {};
	          }
	          _this.currentUser.set(response.me);
	          _this.currentConfig.setRemote(response.services, 'services');
	          _this.updateCurrentUserCookies(response.headers, 'hull');
	          return resolve(response.me);
	        };
	        onError = function(err) {
	          if (err == null) {
	            err = {};
	          }
	          return reject(err);
	        };
	        return _this.channel.rpc.refreshUser(onSuccess, onError);
	      };
	    })(this));
	  };
	
	  Api.prototype.updateCurrentUser = function(response) {
	    var header, p, ref, ref1, u;
	    header = (ref = response.headers) != null ? ref['Hull-User-Id'] : void 0;
	    p = Promise.resolve();
	    if (header == null) {
	      return p;
	    }
	    if (((ref1 = response.body) != null ? ref1.id : void 0) === header) {
	      this.currentUser.set(response.body);
	    } else {
	      u = this.currentUser.get();
	      if (!u || u.id !== header) {
	        p = this.refreshUser();
	      }
	    }
	    return p;
	  };
	
	  Api.prototype._updateCurrentUser = function(user, headers) {
	    var header;
	    if (user == null) {
	      user = {};
	    }
	    if (headers == null) {
	      headers = {};
	    }
	    header = headers != null ? headers['Hull-User-Id'] : void 0;
	    if (header && (user != null ? user.id : void 0) === header) {
	      return this.currentUser.set(user);
	    }
	  };
	
	  Api.prototype.updateCurrentUserCookies = function(headers, provider) {
	    if ((headers != null) && provider === 'hull') {
	      return this.currentUser.setCookies(headers, this.currentConfig.get('appId'));
	    }
	  };
	
	  return Api;
	
	})();
	
	module.exports = Api;


/***/ }),
/* 79 */
/*!***********************************!*\
  !*** ./src/client/channel.coffee ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Channel, EventBus, Promise, _, domready, hiddenFrameStyle, logger, rpcFrameInitStyle, shownFrameStyle, xdm,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	xdm = __webpack_require__(/*! ../utils/xdm */ 77);
	
	domready = __webpack_require__(/*! ../utils/domready */ 76);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	hiddenFrameStyle = {
	  top: '-20px',
	  left: '-20px',
	  bottom: 'auto',
	  right: 'auto',
	  width: '1px',
	  height: '1px',
	  display: 'block',
	  position: 'fixed',
	  zIndex: void 0,
	  overflow: 'hidden'
	};
	
	shownFrameStyle = {
	  top: '0px',
	  left: '0px',
	  right: '0px',
	  bottom: '0px',
	  width: '100%',
	  height: '100%',
	  display: 'block',
	  position: 'fixed',
	  zIndex: 10000,
	  overflow: 'auto'
	};
	
	rpcFrameInitStyle = {
	  tabIndex: -1,
	  height: "0",
	  width: "1px",
	  style: {
	    position: 'fixed',
	    width: "1px",
	    height: "1px",
	    top: '-20px',
	    left: '-20px',
	    overflow: 'hidden'
	  }
	};
	
	Channel = (function() {
	  function Channel(currentUser, currentConfig) {
	    this.applyFrameStyle = bind(this.applyFrameStyle, this);
	    this.userUpdate = bind(this.userUpdate, this);
	    this.configUpdate = bind(this.configUpdate, this);
	    this.emitTrackEvent = bind(this.emitTrackEvent, this);
	    this.hideIframe = bind(this.hideIframe, this);
	    this.showIframe = bind(this.showIframe, this);
	    this.getClientConfig = bind(this.getClientConfig, this);
	    this.ready = bind(this.ready, this);
	    this.loadingFailed = bind(this.loadingFailed, this);
	    this.loadError = bind(this.loadError, this);
	    this.startRpc = bind(this.startRpc, this);
	    this.allowRetry = true;
	    this.retryCount = 0;
	    this.currentConfig = currentConfig;
	    this.currentUser = currentUser;
	    this.timeout = null;
	    this.rpc = null;
	    this._ready = {};
	    this.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._ready.resolve = resolve;
	        return _this._ready.reject = reject;
	      };
	    })(this));
	    domready(this.startRpc);
	  }
	
	  Channel.prototype.startRpc = function() {
	    this.retryCount += 1;
	    this.timeout = setTimeout(this.loadingFailed, this.retryCount * 10000);
	    this.rpc = new xdm.Rpc({
	      remote: this.currentConfig.getRemoteUrl(),
	      container: document.body,
	      channel: [this.currentConfig.get('appId'), this.retryCount].join("-"),
	      props: rpcFrameInitStyle
	    }, {
	      remote: {
	        message: {},
	        ready: {},
	        refreshUser: {},
	        resetIdentify: {}
	      },
	      local: {
	        message: this.onMessage,
	        ready: this.ready,
	        loadError: this.loadError,
	        userUpdate: this.userUpdate,
	        configUpdate: this.configUpdate,
	        show: this.showIframe,
	        hide: this.hideIframe,
	        track: this.emitTrackEvent,
	        getClientConfig: this.getClientConfig
	      }
	    });
	    return this.rpc;
	  };
	
	  Channel.prototype.loadError = function(err) {
	    window.clearTimeout(this.timeout);
	    this.allowRetry = false;
	    return this._ready.reject(new Error(err));
	  };
	
	  Channel.prototype.loadingFailed = function(err) {
	    this.rpc && this.rpc.destroy();
	    if (this.allowRetry && this.retryCount < 4) {
	      return this.startRpc();
	    } else {
	      return this._ready.reject(new Error('Remote loading has failed. Please check "orgUrl" and "appId" in your configuration. This may also be about connectivity.'));
	    }
	  };
	
	  Channel.prototype.onMessage = function(e) {
	    if (e.error) {
	      return this._ready.reject(e.error);
	    } else {
	      return logger.log("RPC Message", arguments);
	    }
	  };
	
	  Channel.prototype.ready = function(remoteConfig) {
	    var err;
	    try {
	      window.clearTimeout(this.timeout);
	      this.currentConfig.initRemote(remoteConfig);
	      return this._ready.resolve(this);
	    } catch (error) {
	      err = error;
	      return this._ready.reject(err);
	    }
	  };
	
	  Channel.prototype.getClientConfig = function() {
	    return this.currentConfig.get();
	  };
	
	  Channel.prototype.showIframe = function() {
	    return this.applyFrameStyle(shownFrameStyle);
	  };
	
	  Channel.prototype.hideIframe = function() {
	    return this.applyFrameStyle(hiddenFrameStyle);
	  };
	
	  Channel.prototype.emitTrackEvent = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return EventBus.emit.apply(EventBus, ['hull.track'].concat(slice.call(args)));
	  };
	
	  Channel.prototype.configUpdate = function(config) {
	    return this.currentConfig.setRemote(config);
	  };
	
	  Channel.prototype.userUpdate = function(me) {
	    return this.currentUser.set(me);
	  };
	
	  Channel.prototype.applyFrameStyle = function(styles) {
	    return _.map(styles, (function(_this) {
	      return function(v, k) {
	        return _this.rpc.iframe.style[k] = v;
	      };
	    })(this));
	  };
	
	  return Channel;
	
	})();
	
	module.exports = Channel;


/***/ }),
/* 80 */
/*!****************************************************!*\
  !*** ./src/remote/services/generic-service.coffee ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var GenericService, RemoteConfigStore, getWrappedRequest, jsonp,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	RemoteConfigStore = __webpack_require__(/*! ../../flux/stores/RemoteConfigStore */ 30);
	
	getWrappedRequest = __webpack_require__(/*! ../wrapped-request */ 75);
	
	jsonp = __webpack_require__(/*! browser-jsonp */ 137);
	
	GenericService = (function() {
	  GenericService.prototype.name = null;
	
	  GenericService.prototype.path = null;
	
	  function GenericService(config, gateway) {
	    this.request_jsonp = bind(this.request_jsonp, this);
	    this.config = config;
	    this.gateway = gateway;
	    this.wrappedRequest = getWrappedRequest({
	      name: this.name,
	      path: this.path
	    }, gateway);
	  }
	
	  GenericService.prototype.getSettings = function(provider) {
	    return RemoteConfigStore.getAuth(this.name || provider);
	  };
	
	  GenericService.prototype.request_jsonp = function(request) {
	    return jsonp(request);
	  };
	
	  return GenericService;
	
	})();
	
	module.exports = GenericService;


/***/ }),
/* 81 */
/*!*************************************!*\
  !*** ./src/utils/dom-walker.coffee ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, getChildren, getLinkValue, getMetaValue, getSiblings, isNode;
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	getLinkValue = function(node) {
	  var ref;
	  if (node == null) {
	    return;
	  }
	  return ((ref = node.dataset) != null ? ref.hullLink : void 0) || (node.nodeName === 'A' && node.href);
	};
	
	getMetaValue = function(name) {
	  var meta, metas;
	  metas = document.getElementsByTagName('meta');
	  meta = _.find(metas, function(meta) {
	    return meta.getAttribute('property') === name || meta.getAttribute('name') === name;
	  });
	  if (meta == null) {
	    return;
	  }
	  return meta.content;
	};
	
	isNode = function(o) {
	  if (typeof Node === "object") {
	    return o instanceof Node;
	  } else {
	    return o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string";
	  }
	};
	
	getChildren = function(n, skipMe) {
	  var r;
	  r = [];
	  while (n && (n = n.nextSibling)) {
	    if (n.nodeType === 1 && n !== skipMe) {
	      r.push(n);
	    }
	  }
	  return r;
	};
	
	getSiblings = function(n) {
	  return getChildren(n.parentNode.firstChild, n);
	};
	
	module.exports = {
	  getSiblings: getSiblings,
	  getChildren: getChildren,
	  getMetaValue: getMetaValue,
	  getLinkValue: getLinkValue,
	  isNode: isNode
	};


/***/ }),
/* 82 */
/*!**********************************!*\
  !*** ./src/utils/get-key.coffee ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, clone;
	
	clone = __webpack_require__(/*! ./clone */ 11);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	module.exports = function(hash, key) {
	  if (!(key && _.isObject(hash))) {
	    return hash;
	  }
	  _.each(key.split('.'), function(k) {
	    if (hash === void 0) {
	      return hash;
	    }
	    if (_.includes(_.keys(hash), k)) {
	      return hash = hash[k];
	    } else {
	      return hash = void 0;
	    }
	  });
	  return clone(hash);
	};


/***/ }),
/* 83 */
/*!************************************!*\
  !*** ./src/utils/is-mobile.coffee ***!
  \************************************/
/***/ (function(module, exports) {

	var isMobile;
	
	isMobile = function() {
	  var n;
	  n = navigator.userAgent || navigator.vendor || window.opera;
	  return !!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(n) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(n.substr(0, 4));
	};
	
	module.exports = isMobile;


/***/ }),
/* 84 */
/*!*****************************************!*\
  !*** ./src/utils/load-polyfills.coffee ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(/*! ../polyfills/xhr-xdr */ 128);
	
	__webpack_require__(/*! ../utils/console-shim */ 161);


/***/ }),
/* 85 */
/*!********************************************!*\
  !*** ./src/utils/ui/display-banner.coffee ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, banners, captcha, platform, platformCss;
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	platform = __webpack_require__(/*! html!./platform.html */ 173);
	
	captcha = __webpack_require__(/*! html!./captcha.html */ 172);
	
	platformCss = __webpack_require__(/*! raw!inline-style!./platform.css */ 330);
	
	banners = {
	  platform: {
	    html: platform,
	    css: platformCss
	  },
	  captcha: {
	    html: captcha,
	    css: platformCss
	  }
	};
	
	module.exports = function(banner, root) {
	  var a, css, element, elements, html, i, len, node, ref, ref1, selector, style;
	  if (root == null) {
	    root = document.body;
	  }
	  node = document.createElement('div');
	  html = (ref = banners[banner]) != null ? ref.html : void 0;
	  css = (ref1 = banners[banner]) != null ? ref1.css : void 0;
	  node.innerHTML = html;
	  for (selector in css) {
	    style = css[selector];
	    elements = node.querySelectorAll(selector);
	    for (i = 0, len = elements.length; i < len; i++) {
	      element = elements[i];
	      element.setAttribute('style', style);
	    }
	  }
	  a = node.getElementsByTagName('a');
	  _.each(a, function(element) {
	    var intent;
	    intent = element.getAttribute('data-hull-intent');
	    return element.addEventListener('click', function(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      return Hull.emit(intent);
	    });
	  });
	  if (root) {
	    root.appendChild(node);
	  }
	  return node;
	};


/***/ }),
/* 86 */
/*!**************************************!*\
  !*** ./~/cookies-js/dist/cookies.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Cookies.js - 1.2.3
	 * https://github.com/ScottHamper/Cookies
	 *
	 * This is free and unencumbered software released into the public domain.
	 */
	(function (global, undefined) {
	    'use strict';
	
	    var factory = function (window) {
	        if (typeof window.document !== 'object') {
	            throw new Error('Cookies.js requires a `window` with a `document` object');
	        }
	
	        var Cookies = function (key, value, options) {
	            return arguments.length === 1 ?
	                Cookies.get(key) : Cookies.set(key, value, options);
	        };
	
	        // Allows for setter injection in unit tests
	        Cookies._document = window.document;
	
	        // Used to ensure cookie keys do not collide with
	        // built-in `Object` properties
	        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
	        
	        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
	
	        Cookies.defaults = {
	            path: '/',
	            secure: false
	        };
	
	        Cookies.get = function (key) {
	            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
	                Cookies._renewCache();
	            }
	            
	            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];
	
	            return value === undefined ? undefined : decodeURIComponent(value);
	        };
	
	        Cookies.set = function (key, value, options) {
	            options = Cookies._getExtendedOptions(options);
	            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);
	
	            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);
	
	            return Cookies;
	        };
	
	        Cookies.expire = function (key, options) {
	            return Cookies.set(key, undefined, options);
	        };
	
	        Cookies._getExtendedOptions = function (options) {
	            return {
	                path: options && options.path || Cookies.defaults.path,
	                domain: options && options.domain || Cookies.defaults.domain,
	                expires: options && options.expires || Cookies.defaults.expires,
	                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
	            };
	        };
	
	        Cookies._isValidDate = function (date) {
	            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
	        };
	
	        Cookies._getExpiresDate = function (expires, now) {
	            now = now || new Date();
	
	            if (typeof expires === 'number') {
	                expires = expires === Infinity ?
	                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
	            } else if (typeof expires === 'string') {
	                expires = new Date(expires);
	            }
	
	            if (expires && !Cookies._isValidDate(expires)) {
	                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
	            }
	
	            return expires;
	        };
	
	        Cookies._generateCookieString = function (key, value, options) {
	            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
	            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
	            options = options || {};
	
	            var cookieString = key + '=' + value;
	            cookieString += options.path ? ';path=' + options.path : '';
	            cookieString += options.domain ? ';domain=' + options.domain : '';
	            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
	            cookieString += options.secure ? ';secure' : '';
	
	            return cookieString;
	        };
	
	        Cookies._getCacheFromString = function (documentCookie) {
	            var cookieCache = {};
	            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];
	
	            for (var i = 0; i < cookiesArray.length; i++) {
	                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);
	
	                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
	                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
	                }
	            }
	
	            return cookieCache;
	        };
	
	        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
	            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
	            var separatorIndex = cookieString.indexOf('=');
	
	            // IE omits the "=" when the cookie value is an empty string
	            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
	
	            var key = cookieString.substr(0, separatorIndex);
	            var decodedKey;
	            try {
	                decodedKey = decodeURIComponent(key);
	            } catch (e) {
	                if (console && typeof console.error === 'function') {
	                    console.error('Could not decode cookie with key "' + key + '"', e);
	                }
	            }
	            
	            return {
	                key: decodedKey,
	                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
	            };
	        };
	
	        Cookies._renewCache = function () {
	            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
	            Cookies._cachedDocumentCookie = Cookies._document.cookie;
	        };
	
	        Cookies._areEnabled = function () {
	            var testKey = 'cookies.js';
	            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
	            Cookies.expire(testKey);
	            return areEnabled;
	        };
	
	        Cookies.enabled = Cookies._areEnabled();
	
	        return Cookies;
	    };
	    var cookiesExport = (global && typeof global.document === 'object') ? factory(global) : factory;
	
	    // AMD support
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    // CommonJS/Node.js support
	    } else if (typeof exports === 'object') {
	        // Support Node.js specific `module.exports` (which can be a function)
	        if (typeof module === 'object' && typeof module.exports === 'object') {
	            exports = module.exports = cookiesExport;
	        }
	        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	        exports.Cookies = cookiesExport;
	    } else {
	        global.Cookies = cookiesExport;
	    }
	})(typeof window === 'undefined' ? this : window);

/***/ }),
/* 87 */
/*!**********************************************!*\
  !*** ./~/eventemitter2/lib/eventemitter2.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter2
	 * https://github.com/hij1nx/EventEmitter2
	 *
	 * Copyright (c) 2013 hij1nx
	 * Licensed under the MIT license.
	 */
	;!function(undefined) {
	
	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;
	
	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }
	
	  function configure(conf) {
	    if (conf) {
	
	      this._conf = conf;
	
	      conf.delimiter && (this.delimiter = conf.delimiter);
	      conf.maxListeners && (this._events.maxListeners = conf.maxListeners);
	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this.newListener = conf.newListener);
	
	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    }
	  }
	
	  function EventEmitter(conf) {
	    this._events = {};
	    this.newListener = false;
	    configure.call(this, conf);
	  }
	  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
	
	  //
	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i) {
	    if (!tree) {
	      return [];
	    }
	    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
	        typeLength = type.length, currentType = type[i], nextType = type[i+1];
	    if (i === typeLength && tree._listeners) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //
	      if (typeof tree._listeners === 'function') {
	        handlers && handlers.push(tree._listeners);
	        return [tree];
	      } else {
	        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
	          handlers && handlers.push(tree._listeners[leaf]);
	        }
	        return [tree];
	      }
	    }
	
	    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
	      //
	      // If the event emitted is '*' at this part
	      // or there is a concrete match at this patch
	      //
	      if (currentType === '*') {
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
	          }
	        }
	        return listeners;
	      } else if(currentType === '**') {
	        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
	        if(endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
	        }
	
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            if(branch === '*' || branch === '**') {
	              if(tree[branch]._listeners && !endReached) {
	                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
	              }
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            } else if(branch === nextType) {
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            }
	          }
	        }
	        return listeners;
	      }
	
	      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
	    }
	
	    xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i+1);
	    }
	
	    xxTree = tree['**'];
	    if(xxTree) {
	      if(i < typeLength) {
	        if(xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength);
	        }
	
	        // Build arrays of matching next branches and others.
	        for(branch in xxTree) {
	          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
	            if(branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i+2);
	            } else if(branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i+1);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
	            }
	          }
	        }
	      } else if(xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength);
	      } else if(xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength);
	      }
	    }
	
	    return listeners;
	  }
	
	  function growListenerTree(type, listener) {
	
	    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	
	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    for(var i = 0, len = type.length; i+1 < len; i++) {
	      if(type[i] === '**' && type[i+1] === '**') {
	        return;
	      }
	    }
	
	    var tree = this.listenerTree;
	    var name = type.shift();
	
	    while (name) {
	
	      if (!tree[name]) {
	        tree[name] = {};
	      }
	
	      tree = tree[name];
	
	      if (type.length === 0) {
	
	        if (!tree._listeners) {
	          tree._listeners = listener;
	        }
	        else if(typeof tree._listeners === 'function') {
	          tree._listeners = [tree._listeners, listener];
	        }
	        else if (isArray(tree._listeners)) {
	
	          tree._listeners.push(listener);
	
	          if (!tree._listeners.warned) {
	
	            var m = defaultMaxListeners;
	
	            if (typeof this._events.maxListeners !== 'undefined') {
	              m = this._events.maxListeners;
	            }
	
	            if (m > 0 && tree._listeners.length > m) {
	
	              tree._listeners.warned = true;
	              console.error('(node) warning: possible EventEmitter memory ' +
	                            'leak detected. %d listeners added. ' +
	                            'Use emitter.setMaxListeners() to increase limit.',
	                            tree._listeners.length);
	              if(console.trace){
	                console.trace();
	              }
	            }
	          }
	        }
	        return true;
	      }
	      name = type.shift();
	    }
	    return true;
	  }
	
	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.
	
	  EventEmitter.prototype.delimiter = '.';
	
	  EventEmitter.prototype.setMaxListeners = function(n) {
	    this._events || init.call(this);
	    this._events.maxListeners = n;
	    if (!this._conf) this._conf = {};
	    this._conf.maxListeners = n;
	  };
	
	  EventEmitter.prototype.event = '';
	
	  EventEmitter.prototype.once = function(event, fn) {
	    this.many(event, 1, fn);
	    return this;
	  };
	
	  EventEmitter.prototype.many = function(event, ttl, fn) {
	    var self = this;
	
	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }
	
	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      fn.apply(this, arguments);
	    }
	
	    listener._origin = fn;
	
	    this.on(event, listener);
	
	    return self;
	  };
	
	  EventEmitter.prototype.emit = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	      if (!this._events.newListener) {
	        return false;
	      }
	    }
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all && this._all.length) {
	      handler = this._all.slice();
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 1; j < al; j++) args[j] = arguments[j];
	      }
	
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this, type);
	          break;
	        case 2:
	          handler[i].call(this, type, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, type, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	      if (typeof handler === 'function') {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler.call(this);
	          break;
	        case 2:
	          handler.call(this, arguments[1]);
	          break;
	        case 3:
	          handler.call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          args = new Array(al - 1);
	          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	          handler.apply(this, args);
	        }
	        return true;
	      } else if (handler) {
	        // need to make copy of handlers because list can change in the middle
	        // of emit call
	        handler = handler.slice();
	      }
	    }
	
	    if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this);
	          break;
	        case 2:
	          handler[i].call(this, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	      return true;
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        throw arguments[1]; // Unhandled 'error' event
	      } else {
	        throw new Error("Uncaught, unspecified 'error' event.");
	      }
	      return false;
	    }
	
	    return !!this._all;
	  };
	
	  EventEmitter.prototype.emitAsync = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	        if (!this._events.newListener) { return Promise.resolve([false]); }
	    }
	
	    var promises= [];
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all) {
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 1; j < al; j++) args[j] = arguments[j];
	      }
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(this._all[i].call(this, type));
	          break;
	        case 2:
	          promises.push(this._all[i].call(this, type, arguments[1]));
	          break;
	        case 3:
	          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(this._all[i].apply(this, args));
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	    }
	
	    if (typeof handler === 'function') {
	      this.event = type;
	      switch (al) {
	      case 1:
	        promises.push(handler.call(this));
	        break;
	      case 2:
	        promises.push(handler.call(this, arguments[1]));
	        break;
	      case 3:
	        promises.push(handler.call(this, arguments[1], arguments[2]));
	        break;
	      default:
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	        promises.push(handler.apply(this, args));
	      }
	    } else if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(handler[i].call(this));
	          break;
	        case 2:
	          promises.push(handler[i].call(this, arguments[1]));
	          break;
	        case 3:
	          promises.push(handler[i].call(this, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(handler[i].apply(this, args));
	        }
	      }
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        return Promise.reject(arguments[1]); // Unhandled 'error' event
	      } else {
	        return Promise.reject("Uncaught, unspecified 'error' event.");
	      }
	    }
	
	    return Promise.all(promises);
	  };
	
	  EventEmitter.prototype.on = function(type, listener) {
	
	    if (typeof type === 'function') {
	      this.onAny(type);
	      return this;
	    }
	
	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);
	
	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    this.emit('newListener', type, listener);
	
	    if(this.wildcard) {
	      growListenerTree.call(this, type, listener);
	      return this;
	    }
	
	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    }
	    else if(typeof this._events[type] === 'function') {
	      // Adding the second element, need to change to array.
	      this._events[type] = [this._events[type], listener];
	    }
	    else if (isArray(this._events[type])) {
	      // If we've already got an array, just append.
	      this._events[type].push(listener);
	
	      // Check for listener leak
	      if (!this._events[type].warned) {
	
	        var m = defaultMaxListeners;
	
	        if (typeof this._events.maxListeners !== 'undefined') {
	          m = this._events.maxListeners;
	        }
	
	        if (m > 0 && this._events[type].length > m) {
	
	          this._events[type].warned = true;
	          console.error('(node) warning: possible EventEmitter memory ' +
	                        'leak detected. %d listeners added. ' +
	                        'Use emitter.setMaxListeners() to increase limit.',
	                        this._events[type].length);
	          if(console.trace){
	            console.trace();
	          }
	        }
	      }
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.onAny = function(fn) {
	
	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }
	
	    if(!this._all) {
	      this._all = [];
	    }
	
	    // Add the function to the event listener collection.
	    this._all.push(fn);
	    return this;
	  };
	
	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }
	
	    var handlers,leafs=[];
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	    }
	    else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }
	
	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {
	
	        var position = -1;
	
	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0) {
	          continue;
	        }
	
	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }
	
	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	
	        this.emit("removeListener", type, listener);
	
	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	
	        this.emit("removeListener", type, listener);
	      }
	    }
	
	    function recursivelyGarbageCollect(root) {
	      if (root === undefined) {
	        return;
	      }
	      var keys = Object.keys(root);
	      for (var i in keys) {
	        var key = keys[i];
	        var obj = root[key];
	        if ((obj instanceof Function) || (typeof obj !== "object"))
	          continue;
	        if (Object.keys(obj).length > 0) {
	          recursivelyGarbageCollect(root[key]);
	        }
	        if (Object.keys(obj).length === 0) {
	          delete root[key];
	        }
	      }
	    }
	    recursivelyGarbageCollect(this.listenerTree);
	
	    return this;
	  };
	
	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          this.emit("removeListenerAny", fn);
	          return this;
	        }
	      }
	    } else {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++)
	        this.emit("removeListenerAny", fns[i]);
	      this._all = [];
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
	
	  EventEmitter.prototype.removeAllListeners = function(type) {
	    if (arguments.length === 0) {
	      !this._events || init.call(this);
	      return this;
	    }
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	
	      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	        var leaf = leafs[iLeaf];
	        leaf._listeners = null;
	      }
	    }
	    else {
	      if (!this._events || !this._events[type]) return this;
	      this._events[type] = null;
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.listeners = function(type) {
	    if(this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers;
	    }
	
	    this._events || init.call(this);
	
	    if (!this._events[type]) this._events[type] = [];
	    if (!isArray(this._events[type])) {
	      this._events[type] = [this._events[type]];
	    }
	    return this._events[type];
	  };
	
	  EventEmitter.prototype.listenersAny = function() {
	
	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }
	
	  };
	
	  if (true) {
	     // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return EventEmitter;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    module.exports = EventEmitter;
	  }
	  else {
	    // Browser global.
	    window.EventEmitter2 = EventEmitter;
	  }
	}();


/***/ }),
/* 88 */
/*!**************************!*\
  !*** ./~/lodash/_Set.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19),
	    root = __webpack_require__(/*! ./_root */ 8);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 89 */
/*!*******************************!*\
  !*** ./~/lodash/_SetCache.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(/*! ./_MapCache */ 53),
	    setCacheAdd = __webpack_require__(/*! ./_setCacheAdd */ 273),
	    setCacheHas = __webpack_require__(/*! ./_setCacheHas */ 274);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 90 */
/*!*********************************!*\
  !*** ./~/lodash/_Uint8Array.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(/*! ./_root */ 8);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 91 */
/*!****************************!*\
  !*** ./~/lodash/_apply.js ***!
  \****************************/
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 92 */
/*!********************************!*\
  !*** ./~/lodash/_arrayEach.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 93 */
/*!************************************!*\
  !*** ./~/lodash/_arrayLikeKeys.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(/*! ./_baseTimes */ 214),
	    isArguments = __webpack_require__(/*! ./isArguments */ 43),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isBuffer = __webpack_require__(/*! ./isBuffer */ 44),
	    isIndex = __webpack_require__(/*! ./_isIndex */ 39),
	    isTypedArray = __webpack_require__(/*! ./isTypedArray */ 70);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 94 */
/*!********************************!*\
  !*** ./~/lodash/_arraySome.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 95 */
/*!**************************************!*\
  !*** ./~/lodash/_baseAssignValue.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(/*! ./_defineProperty */ 103);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 96 */
/*!*********************************!*\
  !*** ./~/lodash/_baseFilter.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./_baseEach */ 17);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 97 */
/*!************************************!*\
  !*** ./~/lodash/_baseFindIndex.js ***!
  \************************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 98 */
/*!*************************************!*\
  !*** ./~/lodash/_baseGetAllKeys.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(/*! ./_arrayPush */ 56),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 99 */
/*!***********************************!*\
  !*** ./~/lodash/_baseProperty.js ***!
  \***********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 100 */
/*!*******************************!*\
  !*** ./~/lodash/_baseRest.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(/*! ./identity */ 42),
	    overRest = __webpack_require__(/*! ./_overRest */ 114),
	    setToString = __webpack_require__(/*! ./_setToString */ 115);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 101 */
/*!*******************************!*\
  !*** ./~/lodash/_cacheHas.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 102 */
/*!********************************!*\
  !*** ./~/lodash/_copyArray.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 103 */
/*!*************************************!*\
  !*** ./~/lodash/_defineProperty.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 104 */
/*!**********************************!*\
  !*** ./~/lodash/_equalArrays.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(/*! ./_SetCache */ 89),
	    arraySome = __webpack_require__(/*! ./_arraySome */ 94),
	    cacheHas = __webpack_require__(/*! ./_cacheHas */ 101);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 105 */
/*!*******************************!*\
  !*** ./~/lodash/_flatRest.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(/*! ./flatten */ 297),
	    overRest = __webpack_require__(/*! ./_overRest */ 114),
	    setToString = __webpack_require__(/*! ./_setToString */ 115);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 106 */
/*!*********************************!*\
  !*** ./~/lodash/_freeGlobal.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 107 */
/*!*********************************!*\
  !*** ./~/lodash/_getAllKeys.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ 98),
	    getSymbols = __webpack_require__(/*! ./_getSymbols */ 64),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 108 */
/*!***********************************!*\
  !*** ./~/lodash/_getAllKeysIn.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ 98),
	    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 109),
	    keysIn = __webpack_require__(/*! ./keysIn */ 71);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 109 */
/*!***********************************!*\
  !*** ./~/lodash/_getSymbolsIn.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(/*! ./_arrayPush */ 56),
	    getPrototype = __webpack_require__(/*! ./_getPrototype */ 63),
	    getSymbols = __webpack_require__(/*! ./_getSymbols */ 64),
	    stubArray = __webpack_require__(/*! ./stubArray */ 119);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 110 */
/*!*********************************!*\
  !*** ./~/lodash/_hasUnicode.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 111 */
/*!*****************************************!*\
  !*** ./~/lodash/_isStrictComparable.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 112 */
/*!**********************************************!*\
  !*** ./~/lodash/_matchesStrictComparable.js ***!
  \**********************************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 113 */
/*!******************************!*\
  !*** ./~/lodash/_overArg.js ***!
  \******************************/
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 114 */
/*!*******************************!*\
  !*** ./~/lodash/_overRest.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(/*! ./_apply */ 91);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 115 */
/*!**********************************!*\
  !*** ./~/lodash/_setToString.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(/*! ./_baseSetToString */ 211),
	    shortOut = __webpack_require__(/*! ./_shortOut */ 275);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 116 */
/*!*******************************!*\
  !*** ./~/lodash/_toSource.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 117 */
/*!***************************!*\
  !*** ./~/lodash/hasIn.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(/*! ./_baseHasIn */ 195),
	    hasPath = __webpack_require__(/*! ./_hasPath */ 244);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 118 */
/*!***********************************!*\
  !*** ./~/lodash/isPlainObject.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    getPrototype = __webpack_require__(/*! ./_getPrototype */ 63),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 119 */
/*!*******************************!*\
  !*** ./~/lodash/stubArray.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 120 */
/*!******************************!*\
  !*** ./~/lodash/toNumber.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7),
	    isSymbol = __webpack_require__(/*! ./isSymbol */ 46);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 121 */
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 122 */
/*!*****************************!*\
  !*** ./~/qs/lib/formats.js ***!
  \*****************************/
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 123 */
/*!***************************!*\
  !*** ./~/qs/lib/utils.js ***!
  \***************************/
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	exports.arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	exports.isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 124 */
/*!***************************************!*\
  !*** ./~/superagent/lib/is-object.js ***!
  \***************************************/
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 125 */
/*!************************************!*\
  !*** ./src/client/embeds/index.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/*global require, module*/
	
	var _lodash = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _throw = __webpack_require__(/*! ../../utils/throw */ 26);
	
	var _throw2 = _interopRequireDefault(_throw);
	
	var _logger = __webpack_require__(/*! ../../utils/logger */ 4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _promises = __webpack_require__(/*! ../../utils/promises */ 5);
	
	var _promises2 = _interopRequireDefault(_promises);
	
	var _getCurrentScript = __webpack_require__(/*! ../../utils/get-current-script */ 132);
	
	var _getCurrentScript2 = _interopRequireDefault(_getCurrentScript);
	
	var _currentscript = __webpack_require__(/*! currentscript */ 168);
	
	var _currentscript2 = _interopRequireDefault(_currentscript);
	
	var _deployment = __webpack_require__(/*! ./deployment */ 141);
	
	var _deployment2 = _interopRequireDefault(_deployment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _initialized = false;
	var _context = {};
	
	module.exports = {
	  initialize: function initialize(context) {
	    _initialized = true;
	    _context = context;
	  },
	
	  embed: function embed(deployments, opts, callback, errback) {
	    if (!deployments || !deployments.length) {
	      return;
	    }
	    if (opts && opts.reset !== false) {
	      _deployment2['default'].resetDeployments();
	    }
	
	    var embeds = [];
	    var promises = [];
	
	    _logger2['default'].log('Embedding Deployments', deployments);
	    for (var d = 0, l = deployments.length; d < l; d++) {
	      var dpl = new _deployment2['default'](deployments[d], _context);
	      promises.push(dpl.embed({ refresh: true }));
	    }
	
	    _promises2['default'].all(promises).then(function (deployments) {
	      _logger2['default'].log('Deployments resolved', deployments);
	      if (_lodash2['default'].isFunction(callback)) {
	        callback(_lodash2['default'].map(deployments, 'value'));
	      }
	    }, errback)['catch'](_throw2['default']);
	  },
	
	  onEmbed: function onEmbed() {
	    var args = Array.prototype.slice.call(arguments);
	    var callback = void 0;
	
	    while (args.length > 0 && !_lodash2['default'].isFunction(callback)) {
	      callback = args.shift();
	    }
	
	    if (!_lodash2['default'].isFunction(callback)) return false;
	
	    var currentScript = document.currentScript || (0, _getCurrentScript2['default'])() || document._currentScript;
	
	    _logger2['default'].verbose('currentScript', currentScript);
	
	    // detectedScript is null on Chrome. Use this to use either the polyfill or the native implementation.
	    // Fallback to script detection (how will this work ?)
	
	    // Detect JS embed mode first.
	    var shipId = currentScript.getAttribute('data-hull-ship-script');
	    var deployments = _deployment2['default'].getDeployments(shipId);
	    // In JS-mode, callbacks are passed down to the DeploymentStrategy,
	    // In theother modes, they are ignored because we retreive the callbacks from the import document.
	    if (deployments && deployments.length) {
	      for (var i = deployments.length - 1; i >= 0; i--) {
	        if (deployments[i]) {
	          deployments[i].onEmbed(callback);
	        }
	      };
	    }
	  }
	};

/***/ }),
/* 126 */
/*!*******************************************!*\
  !*** ./src/client/initialize-platform.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _emptyFunction = __webpack_require__(/*! ../utils/empty-function */ 130);
	
	var _emptyFunction2 = _interopRequireDefault(_emptyFunction);
	
	var _superagent = __webpack_require__(/*! superagent */ 47);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function initializeShopifyPlatform(context, currentConfig, hull) {
	  var _currentConfig$get = currentConfig.get(),
	      customerId = _currentConfig$get.customerId,
	      accessToken = _currentConfig$get.accessToken,
	      callbackUrl = _currentConfig$get.callbackUrl;
	
	  try {
	    var _document$location = document.location,
	        pathname = _document$location.pathname,
	        search = _document$location.search,
	        hash = _document$location.hash;
	
	    var _ref = context.app && context.app.settings || {},
	        domain = _ref.domain,
	        domain_redirect = _ref.domain_redirect,
	        ssl_enabled = _ref.ssl_enabled,
	        alias_cart_enabled = _ref.alias_cart_enabled;
	
	    if (domain_redirect && domain && pathname.match(/^\/account\/login/) && domain !== document.location.host) {
	
	      var protocol = ssl_enabled ? 'https:' : 'http:';
	      document.location.href = [protocol, '//', domain, pathname, search, hash].join('');
	    }
	  } catch (err) {}
	
	  var currentUser = hull.currentUser();
	
	  if (!customerId && currentUser) {
	    hull.api('services/shopify/login', { return_to: document.location.href }).then(function (r) {
	      // If the platform has multipass enabled and we are NOT inside the customizer
	      // we can log the customer in without knowing his password.
	
	      var _ref2 = currentConfig.identifySession() || {},
	          inits_count = _ref2.inits_count;
	
	      if (r.auth === 'multipass' && inits_count < 2) {
	        if (!(callbackUrl || '').match('__hull_proxy__')) {
	          var l = 'https://' + document.location.host + '/account/login/multipass/' + r.token;
	          window.location = l;
	        }
	      } else {
	        hull.logout();
	      }
	    });
	  } else if (/^[0-9]+$/.test(customerId) && (!accessToken || !currentUser)) {
	    hull.api('services/shopify/customers/' + customerId, 'put');
	  }
	
	  if (customerId) {
	    Hull.on('hull.user.logout', function () {
	      document.location = '/account/logout';
	    });
	  }
	
	  function aliasCart() {
	    var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (cart && cart.token) {
	      var CART_ALIAS_KEY = 'cartAliasToken';
	      var aliasToken = [cart.token, customerId].join('-');
	      if (aliasToken !== currentConfig.storageGet(CART_ALIAS_KEY)) {
	        hull.api('services/shopify/cart', { cart: cart }, 'post').then(function () {
	          currentConfig.storageSet(CART_ALIAS_KEY, aliasToken);
	        });
	      }
	    }
	  }
	
	  // if (window.HullShopify && window.HullShopify.cart && window.HullShopify.cart.token) {
	  //   aliasCart(window.HullShopify.cart);
	  // } else if (window.HullShopify && window.HullShopify.template) {
	  //   let browser = {};
	  //   try {
	  //     browser = currentConfig.identifyBrowser();
	  //   } catch (err) {
	  //     browser = {}
	  //   }
	  //   request.post('/cart.js')
	  //          .send({})
	  //          .set('Accept', 'application/json')
	  //          .end((err, res={}) => {
	  //             aliasCart(res.body);
	  //           })
	  // }    
	}
	
	function getPlatformInitializer(platform) {
	  if (platform.type === 'platforms/shopify_shop') {
	    return initializeShopifyPlatform;
	  } else {
	    return _emptyFunction2['default'];
	  }
	}
	
	function initializePlatform(context, currentConfig, hull) {
	  var initializer = getPlatformInitializer(context.app);
	  return initializer(context, currentConfig, hull);
	}
	
	module.exports = initializePlatform;

/***/ }),
/* 127 */
/*!**********************************************!*\
  !*** ./src/flux/stores/ClientConfigStore.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 33).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 24);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 14);
	
	var CHANGE_EVENT = 'change';
	
	var state = {};
	
	var ClientConfigStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange() {
	    this.emit(CHANGE_EVENT);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state;
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.UPDATE_CLIENT_CONFIG:
	        state = action.config;
	        ClientConfigStore.emitChange();
	        break;
	    }
	    return true;
	  })
	
	});
	
	module.exports = ClientConfigStore;

/***/ }),
/* 128 */
/*!**********************************!*\
  !*** ./src/polyfills/xhr-xdr.js ***!
  \**********************************/
/***/ (function(module, exports) {

	'use strict';
	
	/*
	
	 xhr-xdr-adapter
	
	 Use XDomainRequest on IE 8 and IE 9 for cross-origin requests only.
	 Default to standard XMLHttpRequest otherwise.
	
	 Include this file on IE 8 & 9 before making cross-origin ajax requests
	 using libraries or frameworks such as jQuery or AngularJS.  This will allow
	 you to do things like AJAX GET templates/assets from a CDN at run time using
	 the standard XMLHttpRequest API on IE 8/9, or do simple cross-domain POSTs.
	
	 But it doesn't get around the basic limitations of IE 8 & 9's XDomainRequest:
	 * No authentication or cookies can be sent
	 * POST or GET only
	 * No custom headers can be sent
	 * text/plain contentType only
	
	
	 The MIT License (MIT)
	
	 Copyright (c) 2014 Intuit Inc.
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in all
	 copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 SOFTWARE.
	 */
	
	(function () {
	    "use strict";
	    // Ignore everything below if not on IE 8 or IE 9.
	
	    if (!window.XDomainRequest) {
	        // typeof XDomainRequest is 'object' in IE 8, 'function' in IE 9
	        return;
	    }
	    if ('withCredentials' in new window.XMLHttpRequest()) {
	        return;
	    }
	    if (window.XMLHttpRequest.supportsXDR === true) {
	        // already set up
	        return;
	    }
	
	    var OriginalXMLHttpRequest = window.XMLHttpRequest;
	    var urlRegEx = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
	    var httpRegEx = /^https?:\/\//i;
	    var getOrPostRegEx = /^get|post$/i;
	    var sameSchemeRegEx = new RegExp('^' + location.protocol, 'i');
	
	    // Determine whether XDomainRequest should be used for a given request
	    var useXDR = function useXDR(method, url, async) {
	        var remoteUrl = url;
	        var baseHref;
	        var myLocationParts;
	        var remoteLocationParts;
	        var crossDomain;
	
	        try {
	            // account for the possibility of a <base href="..."> setting, which could make a URL that looks relative actually be cross-domain
	            if (remoteUrl && remoteUrl.indexOf("://") < 0 && document.getElementsByTagName('base').length > 0) {
	                baseHref = document.getElementsByTagName('base')[0].href;
	                if (baseHref) {
	                    remoteUrl = baseHref + remoteUrl;
	                }
	            }
	
	            myLocationParts = urlRegEx.exec(location.href);
	            remoteLocationParts = urlRegEx.exec(remoteUrl);
	            crossDomain = myLocationParts[2].toLowerCase() !== remoteLocationParts[2].toLowerCase();
	
	            // XDomainRequest can only be used for async get/post requests across same scheme, which must be http: or https:
	            return crossDomain && async && getOrPostRegEx.test(method) && httpRegEx.test(remoteUrl) && sameSchemeRegEx.test(remoteUrl);
	        } catch (ex) {
	            return false;
	        }
	    };
	
	    window.XMLHttpRequest = function () {
	        var self = this;
	        this._setReadyState = function (readyState) {
	            if (self.readyState !== readyState) {
	                self.readyState = readyState;
	                if (typeof self.onreadystatechange === "function") {
	                    self.onreadystatechange();
	                }
	                self._runCallbacks('readystatechange');
	            }
	        };
	        this._callbacks = {};
	        this.readyState = 0;
	        this.responseText = "";
	        this.status = 0;
	        this.statusText = "";
	        this.withCredentials = false;
	    };
	
	    window.XMLHttpRequest.prototype._runCallbacks = function (event, args) {
	        var self = this;
	        var callbacks = (self._callbacks[event] || []).slice();
	        var cb = callbacks.pop();
	        while (cb) {
	            cb.apply(self, args);
	            cb = callbacks.pop();
	        }
	    };
	
	    window.XMLHttpRequest.prototype.addEventListener = function (event, callback) {
	        var self = this;
	        this._callbacks[event] = this._callbacks[event] || [];
	        this._callbacks[event].push(callback);
	    };
	
	    window.XMLHttpRequest.prototype.open = function (method, url, async) {
	        var self = this;
	        var request;
	
	        if (useXDR(method, url, async)) {
	
	            // Use XDR
	            request = new XDomainRequest();
	            request._xdr = true;
	            request.onerror = function () {
	                self.status = 400;
	                self.statusText = "Error";
	                self._setReadyState(4);
	                if (self.onerror) {
	                    self.onerror();
	                    self._runCallbacks('error');
	                }
	            };
	            request.ontimeout = function () {
	                self.status = 408;
	                self.statusText = "Timeout";
	                self._setReadyState(2);
	                if (self.ontimeout) {
	                    self.ontimeout();
	                }
	                self._runCallbacks('timeout');
	            };
	            request.onload = function () {
	                self.responseText = request.responseText;
	                self.status = 200;
	                self.statusText = "OK";
	                self._setReadyState(4);
	                if (self.onload) {
	                    self.onload();
	                }
	                self._runCallbacks('load', [].slice.call(arguments));
	            };
	            request.onprogress = function () {
	                if (self.onprogress) {
	                    self.onprogress.apply(self, arguments);
	                }
	                self._runCallbacks('progress', [].slice.call(arguments));
	            };
	        } else {
	
	            // Use standard XHR
	            request = new OriginalXMLHttpRequest();
	            request.withCredentials = this.withCredentials;
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    try {
	                        self.status = request.status;
	                        self.statusText = request.statusText;
	                        self.responseText = request.responseText;
	                        self.responseXML = request.responseXML;
	                    } catch (e) {}
	                }
	                self._setReadyState(request.readyState);
	            };
	            request.onabort = function () {
	                if (self.onabort) {
	                    self.onabort.apply(self, arguments);
	                }
	            };
	            request.onerror = function () {
	                if (self.onerror) {
	                    self.onerror.apply(self, arguments);
	                }
	            };
	            request.onload = function () {
	                if (self.onload) {
	                    self.onload.apply(self, arguments);
	                }
	            };
	            request.onloadend = function () {
	                if (self.onloadend) {
	                    self.onloadend.apply(self, arguments);
	                }
	            };
	            request.onloadstart = function () {
	                if (self.onloadstart) {
	                    self.onloadstart.apply(self, arguments);
	                }
	            };
	            request.onprogress = function () {
	                if (self.onprogress) {
	                    self.onprogress.apply(self, arguments);
	                }
	            };
	        }
	
	        this._request = request;
	        request.open.apply(request, arguments);
	        this._setReadyState(1);
	    };
	
	    window.XMLHttpRequest.prototype.abort = function () {
	        this._request.abort();
	        this._setReadyState(0);
	        this.onreadystatechange = null;
	    };
	
	    window.XMLHttpRequest.prototype.send = function (body) {
	        var self = this;
	        this._request.withCredentials = this.withCredentials;
	
	        if (this._request._xdr) {
	            setTimeout(function () {
	                self._request.send(body);
	            }, 0);
	        } else {
	            this._request.send(body);
	        }
	
	        if (this._request.readyState === 4) {
	            // when async==false the browser is blocked until the transfer is complete and readyState becomes 4
	            // onreadystatechange should not get called in this case
	            this.status = this._request.status;
	            this.statusText = this._request.statusText;
	            this.responseText = this._request.responseText;
	            this.readyState = this._request.readyState;
	        } else {
	            this._setReadyState(2);
	        }
	    };
	
	    window.XMLHttpRequest.prototype.setRequestHeader = function () {
	        if (this._request.setRequestHeader) {
	            this._request.setRequestHeader.apply(this._request, arguments);
	        }
	    };
	
	    window.XMLHttpRequest.prototype.getAllResponseHeaders = function () {
	        if (this._request.getAllResponseHeaders) {
	            return this._request.getAllResponseHeaders();
	        } else {
	            return "Content-Length: " + this.responseText.length + "\r\nContent-Type:" + this._request.contentType;
	        }
	    };
	
	    window.XMLHttpRequest.prototype.getResponseHeader = function (header) {
	        if (this._request.getResponseHeader) {
	            return this._request.getResponseHeader.apply(this._request, arguments);
	        }
	        if (typeof header !== "string") {
	            return;
	        }
	        header = header.toLowerCase();
	        if (header === "content-type") {
	            return this._request.contentType;
	        } else if (header === "content-length") {
	            return this.responseText.length;
	        }
	    };
	
	    window.XMLHttpRequest.supportsXDR = true;
	})();

/***/ }),
/* 129 */
/*!*********************************!*\
  !*** ./src/utils/dom-events.js ***!
  \*********************************/
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	function addEvent(node, eventName, handler) {
	  if (node.attachEvent) {
	    node.attachEvent('on' + eventName, handler);
	  } else {
	    node.addEventListener(eventName, handler, false);
	  }
	}
	
	function removeEvent(node, eventName, handler) {
	  if (node.detachEvent) {
	    node.detachEvent('on' + eventName, handler);
	  } else {
	    node.removeEventListener(eventName, handler, false);
	  }
	}

/***/ }),
/* 130 */
/*!*************************************!*\
  !*** ./src/utils/empty-function.js ***!
  \*************************************/
/***/ (function(module, exports) {

	'use strict';
	
	function emptyFunction() {}
	
	module.exports = emptyFunction;

/***/ }),
/* 131 */
/*!*************************************!*\
  !*** ./src/utils/form-serialize.js ***!
  \*************************************/
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Taken from https://github.com/defunctzombie/form-serialize#readme
	// MIT License here: https://github.com/defunctzombie/form-serialize/blob/master/LICENSE
	//
	// The MIT License (MIT)
	//
	// Copyright (c) 2013 Roman Shtylman
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy of
	// this software and associated documentation files (the "Software"), to deal in
	// the Software without restriction, including without limitation the rights to
	// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	// the Software, and to permit persons to whom the Software is furnished to do so,
	// subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all
	// copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	// © 2020 GitHub, Inc.
	//
	// get successful control from form and assemble into object
	// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2
	
	// types which indicate a submit action and are not successful controls
	// these will be ignored
	var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
	
	// node names which could be successful controls
	var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
	
	// Matches bracket notation.
	var brackets = /(\[[^\[\]]*\])/g;
	
	// serializes form fields
	// @param form MUST be an HTMLForm element
	// @param options is an optional argument to configure the serialization. Default output
	// with no options specified is a url encoded string
	//    - hash: [true | false] Configure the output type. If true, the output will
	//    be a js object.
	//    - serializer: [function] Optional serializer function to override the default one.
	//    The function takes 3 arguments (result, key, value) and should return new result
	//    hash and url encoded str serializers are provided with this module
	//    - disabled: [true | false]. If true serialize disabled fields.
	//    - empty: [true | false]. If true serialize empty fields
	function serialize(form, options) {
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) != 'object') {
	        options = { hash: !!options };
	    } else if (options.hash === undefined) {
	        options.hash = true;
	    }
	
	    var result = options.hash ? {} : '';
	    var serializer = options.serializer || (options.hash ? hash_serializer : str_serialize);
	
	    var elements = form && form.elements ? form.elements : [];
	
	    //Object store each radio and set if it's empty or not
	    var radio_store = Object.create(null);
	
	    for (var i = 0; i < elements.length; ++i) {
	        var element = elements[i];
	
	        // ingore disabled fields
	        if (!options.disabled && element.disabled || !element.name) {
	            continue;
	        }
	        // ignore anyhting that is not considered a success field
	        if (!k_r_success_contrls.test(element.nodeName) || k_r_submitter.test(element.type)) {
	            continue;
	        }
	
	        var key = element.name;
	        var val = element.value;
	
	        // we can't just use element.value for checkboxes cause some browsers lie to us
	        // they say "on" for value when the box isn't checked
	        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
	            val = undefined;
	        }
	
	        // If we want empty elements
	        if (options.empty) {
	            // for checkbox
	            if (element.type === 'checkbox' && !element.checked) {
	                val = '';
	            }
	
	            // for radio
	            if (element.type === 'radio') {
	                if (!radio_store[element.name] && !element.checked) {
	                    radio_store[element.name] = false;
	                } else if (element.checked) {
	                    radio_store[element.name] = true;
	                }
	            }
	
	            // if options empty is true, continue only if its radio
	            if (val == undefined && element.type == 'radio') {
	                continue;
	            }
	        } else {
	            // value-less fields are ignored unless options.empty is true
	            if (!val) {
	                continue;
	            }
	        }
	
	        // multi select boxes
	        if (element.type === 'select-multiple') {
	            val = [];
	
	            var selectOptions = element.options;
	            var isSelectedOptions = false;
	            for (var j = 0; j < selectOptions.length; ++j) {
	                var option = selectOptions[j];
	                var allowedEmpty = options.empty && !option.value;
	                var hasValue = option.value || allowedEmpty;
	                if (option.selected && hasValue) {
	                    isSelectedOptions = true;
	
	                    // If using a hash serializer be sure to add the
	                    // correct notation for an array in the multi-select
	                    // context. Here the name attribute on the select element
	                    // might be missing the trailing bracket pair. Both names
	                    // "foo" and "foo[]" should be arrays.
	                    if (options.hash && key.slice(key.length - 2) !== '[]') {
	                        result = serializer(result, key + '[]', option.value);
	                    } else {
	                        result = serializer(result, key, option.value);
	                    }
	                }
	            }
	
	            // Serialize if no selected options and options.empty is true
	            if (!isSelectedOptions && options.empty) {
	                result = serializer(result, key, '');
	            }
	
	            continue;
	        }
	
	        result = serializer(result, key, val);
	    }
	
	    // Check for all empty radio buttons and serialize them with key=""
	    if (options.empty) {
	        for (var key in radio_store) {
	            if (!radio_store[key]) {
	                result = serializer(result, key, '');
	            }
	        }
	    }
	
	    return result;
	}
	
	function parse_keys(string) {
	    var keys = [];
	    var prefix = /^([^\[\]]*)/;
	    var children = new RegExp(brackets);
	    var match = prefix.exec(string);
	
	    if (match[1]) {
	        keys.push(match[1]);
	    }
	
	    while ((match = children.exec(string)) !== null) {
	        keys.push(match[1]);
	    }
	
	    return keys;
	}
	
	function hash_assign(result, keys, value) {
	    if (keys.length === 0) {
	        result = value;
	        return result;
	    }
	
	    var key = keys.shift();
	    var between = key.match(/^\[(.+?)\]$/);
	
	    if (key === '[]') {
	        result = result || [];
	
	        if (Array.isArray(result)) {
	            result.push(hash_assign(null, keys, value));
	        } else {
	            // This might be the result of bad name attributes like "[][foo]",
	            // in this case the original `result` object will already be
	            // assigned to an object literal. Rather than coerce the object to
	            // an array, or cause an exception the attribute "_values" is
	            // assigned as an array.
	            result._values = result._values || [];
	            result._values.push(hash_assign(null, keys, value));
	        }
	
	        return result;
	    }
	
	    // Key is an attribute name and can be assigned directly.
	    if (!between) {
	        result[key] = hash_assign(result[key], keys, value);
	    } else {
	        var string = between[1];
	        // +var converts the variable into a number
	        // better than parseInt because it doesn't truncate away trailing
	        // letters and actually fails if whole thing is not a number
	        var index = +string;
	
	        // If the characters between the brackets is not a number it is an
	        // attribute name and can be assigned directly.
	        if (isNaN(index)) {
	            result = result || {};
	            result[string] = hash_assign(result[string], keys, value);
	        } else {
	            result = result || [];
	            result[index] = hash_assign(result[index], keys, value);
	        }
	    }
	
	    return result;
	}
	
	// Object/hash encoding serializer.
	function hash_serializer(result, key, value) {
	    var matches = key.match(brackets);
	
	    // Has brackets? Use the recursive assignment function to walk the keys,
	    // construct any missing objects in the result tree and make the assignment
	    // at the end of the chain.
	    if (matches) {
	        var keys = parse_keys(key);
	        hash_assign(result, keys, value);
	    } else {
	        // Non bracket notation can make assignments directly.
	        var existing = result[key];
	
	        // If the value has been assigned already (for instance when a radio and
	        // a checkbox have the same name attribute) convert the previous value
	        // into an array before pushing into it.
	        //
	        // NOTE: If this requirement were removed all hash creation and
	        // assignment could go through `hash_assign`.
	        if (existing) {
	            if (!Array.isArray(existing)) {
	                result[key] = [existing];
	            }
	
	            result[key].push(value);
	        } else {
	            result[key] = value;
	        }
	    }
	
	    return result;
	}
	
	// urlform encoding serializer
	function str_serialize(result, key, value) {
	    // encode newlines as \r\n cause the html spec says so
	    value = value.replace(/(\r)?\n/g, '\r\n');
	    value = encodeURIComponent(value);
	
	    // spaces should be '+' rather than '%20'.
	    value = value.replace(/%20/g, '+');
	    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
	}
	
	module.exports = serialize;

/***/ }),
/* 132 */
/*!*****************************************!*\
  !*** ./src/utils/get-current-script.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(/*! ./lodash */ 1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var URL_REGEX = /(data:text\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\/\/[\/]?.+?\/[^:\)]*?)(?::\d+)(?::\d+)?/;
	
	function getErrorStack() {
	  var e = new Error();
	  var stack = e.stack;
	  if (typeof stack !== 'string' || !stack) {
	    try {
	      throw e;
	    } catch (err) {
	      stack = err.stack;
	    }
	  }
	  return stack;
	}
	function getUrlFromStack() {
	  var stack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var lines = stack.split('\n');
	  var urls = _lodash2['default'].reduce(lines, function (u, line) {
	    var t = line.match(URL_REGEX);
	    if (t) {
	      u.push(t[1]);
	    }
	    return u;
	  }, []);
	  // Eliminate Hull.js from the stack, get next closest URL
	  return _lodash2['default'].uniq(urls)[1];
	}
	
	function getCurrentScriptFromUrl(url, scripts) {
	  var i,
	      script = null;
	
	  if (typeof url === 'string' && url) {
	    for (i = scripts.length; i--;) {
	      if (scripts[i].src === url) {
	        script = scripts[i];
	        break;
	      }
	    }
	  }
	  return script;
	}
	
	function getCurrentScript() {
	  var scripts = document.getElementsByTagName('script');
	  var stack = getErrorStack();
	  var url = getUrlFromStack(stack);
	  return getCurrentScriptFromUrl(url, scripts);
	}
	
	module.exports = getCurrentScript;

/***/ }),
/* 133 */
/*!***********************************!*\
  !*** ./src/utils/leaky-bucket.js ***!
  \***********************************/
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Origin: https://github.com/linaGirl/leaky-bucket
	// Version: 3.0.4
	// License: MIT
	
	
	var LeakyBucket = function () {
	
	    /**
	    * Sets up the leaky bucket. The bucket is designed so that it can 
	    * burst by the capacity it is given. after that items can be queued
	    * until a timeout of n seonds is reached.
	    *
	    * example: throttle 10 actions per minute that have each a cost of 1, reject 
	    * everything theat is overflowing. there will no more than 10 items queued 
	    * at any time
	    *   capacity: 10
	    *   interval: 60
	    *   timeout: 60
	    *
	    * example: throttle 100 actions per minute that have a cost of 1, reject 
	    * items that have to wait more thatn 2 minutes. there will be no more thatn 
	    * 200 items queued at any time. of those 200 items 100 will be bursted within
	    * a minute, the rest will be executed evenly spread over a mintue.
	    *   capacity: 100
	    *   interval: 60
	    *   timeout: 120
	    *
	    * @param {number} capacity the capacity the bucket has per interval
	    * @param {number} timeout the total time items are allowed to wait for execution
	    * @param {number} interval the interval for the capacity in seconds
	    */
	    function LeakyBucket() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$capacity = _ref.capacity,
	            capacity = _ref$capacity === undefined ? 60 : _ref$capacity,
	            timeout = _ref.timeout,
	            _ref$interval = _ref.interval,
	            interval = _ref$interval === undefined ? 60000 : _ref$interval;
	
	        _classCallCheck(this, LeakyBucket);
	
	        // set the timeout to the interval if not set, so that the bucket overflows as soon
	        // the capacity is reached
	        if (isNaN(timeout)) timeout = interval;
	
	        // queue containing all items to execute
	        this.queue = [];
	
	        // the value f all items currently enqueued
	        this.totalCost = 0;
	
	        // the capacity, which can be used at this moment
	        // to execute items
	        this.currentCapacity = capacity;
	
	        // time when the last refill occured
	        this.lastRefill = null;
	
	        this.setCapacity(capacity);
	        this.setTimeout(timeout);
	        this.setInterval(interval);
	    }
	
	    /**
	    * dthe throttle method is used to throttle things. it is async and will resolve either 
	    * immediatelly, if there is space in the bucket, than can be bursted, or it will wait
	    * until there is enough capacity left to execute the item with the given cost. if the 
	    * bucket is overflowing, and the item cannot be executed within the timeout of the bucket,
	    * the call will be rejected with an error.
	    *
	    * @param {number} cost=1 the cost of the item to be throttled. is the cost is unknown, 
	    *                        the cost can be payed after execution using the pay method.
	    *                        defaults to 1.
	    * @param {boolean} append = true set to false if the item needs ot be added to the 
	    *                                beginning of the queue
	    * @param {boolean} isPause = false defines if the element is a pause elemtn, if yes, it 
	    *                                  will not be cleaned off of the queue when checking
	    *                                  for overflowing elements
	    * @returns {promise} resolves when the item can be executed, rejects if the item cannot
	    *                    be executed in time
	    */
	
	
	    _createClass(LeakyBucket, [{
	        key: "throttle",
	        value: function throttle() {
	            var cost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	            var _this = this;
	
	            var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var isPause = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var maxCurrentCapacity = this.getCurrentMaxCapacity();
	
	            // if items are added at the beginning, the excess items will be remove
	            // later on
	            if (append && this.totalCost + cost > maxCurrentCapacity) {
	                throw new Error("Cannot throttle item, bucket is overflowing: the maximum capacity is " + maxCurrentCapacity + ", the current total capacity is " + this.totalCost + "!");
	            }
	
	            return new Promise(function (resolve, reject) {
	                var item = {
	                    resolve: resolve,
	                    reject: reject,
	                    cost: cost,
	                    isPause: isPause
	                };
	
	                _this.totalCost += cost;
	
	                if (append) {
	                    _this.queue.push(item);
	                } else {
	                    _this.queue.unshift(item);
	                    _this.cleanQueue();
	                }
	
	                _this.startTimer();
	            });
	        }
	
	        /**
	        * either executes directly when enough capacity is present or delays the
	        * execution until enough capacity is available.
	        *
	        * @private
	        */
	
	    }, {
	        key: "startTimer",
	        value: function startTimer() {
	            var _this2 = this;
	
	            if (!this.timer && this.queue.length > 0) {
	                var item = this.getFirstItem();
	
	                this.refill();
	
	                if (this.currentCapacity >= item.cost) {
	                    item.resolve();
	
	                    // remove the item from the queue
	                    this.shiftQueue();
	
	                    // pay it's cost
	                    this.pay(item.cost);
	
	                    // go to the next item
	                    this.startTimer();
	                } else {
	                    var requiredDelta = item.cost + this.currentCapacity * -1;
	                    var timeToDelta = requiredDelta / this.refillRate * 1000;
	
	                    // wait until the next item can be handled
	                    this.timer = setTimeout(function () {
	                        _this2.timer = 0;
	                        _this2.startTimer();
	                    }, timeToDelta);
	                }
	            }
	        }
	
	        /**
	        * removes the first item in the queue, resolves the promise that indicated
	        * that the bucket is empty and no more items are waiting
	        *
	        * @private
	        */
	
	    }, {
	        key: "shiftQueue",
	        value: function shiftQueue() {
	            this.queue.shift();
	
	            if (this.queue.length === 0 && this.emptyPromiseResolver) {
	                this.emptyPromiseResolver();
	            }
	        }
	
	        /**
	        * is resolved as soon as the bucket is empty. is basically an event
	        * that is emitted
	        */
	
	    }, {
	        key: "isEmpty",
	        value: function isEmpty() {
	            var _this3 = this;
	
	            if (!this.emptyPromiseResolver) {
	                this.emptyPromise = new Promise(function (resolve) {
	                    _this3.emptyPromiseResolver = function () {
	                        _this3.emptyPromiseResolver = null;
	                        _this3.emptyPromise = null;
	                        resolve();
	                    };
	                });
	            }
	
	            return this.emptyPromise;
	        }
	
	        /**
	        * ends the bucket. The bucket may be recycled after this call
	        */
	
	    }, {
	        key: "end",
	        value: function end() {
	            this.stopTimer();
	            this.clear();
	        }
	
	        /**
	        * removes all items from the queue, does not stop the timer though
	        *
	        * @privae
	        */
	
	    }, {
	        key: "clear",
	        value: function clear() {
	            this.queue = [];
	        }
	
	        /**
	        * can be used to pay costs for items where the cost is clear after exection
	        * this will devcrease the current capacity availabe on the bucket.
	        *
	        * @param {number} cost the ost to pay
	        */
	
	    }, {
	        key: "pay",
	        value: function pay(cost) {
	
	            // reduce the current capacity, so that bursts
	            // as calculated correctly
	            this.currentCapacity -= cost;
	
	            // keep track of the total cost for the bucket
	            // so that we know when we're overflowing
	            this.totalCost -= cost;
	
	            // store the date the leky bucket was starting to leak
	            // so that it can be refilled correctly
	            if (this.lastRefill === null) {
	                this.lastRefill = Date.now();
	            }
	        }
	
	        /**
	        * stops the running times
	        * 
	        * @private
	        */
	
	    }, {
	        key: "stopTimer",
	        value: function stopTimer() {
	            if (this.timer) {
	                clearTimeout(this.timer);
	                this.timer = null;
	            }
	        }
	
	        /**
	        * refills the bucket with capacity which has become available since the
	        * last refill. starts to refill after a call has started using capacity
	        *
	        * @private
	        */
	
	    }, {
	        key: "refill",
	        value: function refill() {
	
	            // don't do refills, if we're already full
	            if (this.currentCapacity < this.capacity) {
	
	                // refill the currently avilable capacity
	                var refillAmount = (Date.now() - this.lastRefill) / 1000 * this.refillRate;
	                this.currentCapacity += refillAmount;
	
	                // make sure, that no more capacity is added than is the maximum
	                if (this.currentCapacity >= this.capacity) {
	                    this.currentCapacity = this.capacity;
	                    this.lastRefill = null;
	                } else {
	                    // date of last refill, ued for the next refill
	                    this.lastRefill = Date.now();
	                }
	            }
	        }
	
	        /**
	        * gets the currenlty avilable max capacity, respecintg
	        * the capacity that is already used in the moment
	        *
	        * @private
	        */
	
	    }, {
	        key: "getCurrentMaxCapacity",
	        value: function getCurrentMaxCapacity() {
	            this.refill();
	            return this.maxCapacity - (this.capacity - this.currentCapacity);
	        }
	
	        /**
	        * removes all items that cannot be executed in time due to items
	        * that were added in front of them in the queue (mostly pause items)
	        *
	        * @private
	        */
	
	    }, {
	        key: "cleanQueue",
	        value: function cleanQueue() {
	            var _this4 = this;
	
	            var maxCapacity = this.getCurrentMaxCapacity();
	            var currentCapacity = 0;
	
	            // find the first item, that goes over the thoretical maximal
	            // capacity that is available
	            var index = this.queue.findIndex(function (item) {
	                currentCapacity += item.cost;
	                return currentCapacity > maxCapacity;
	            });
	
	            // reject all items that cannot be enqueued
	            if (index >= 0) {
	                this.queue.splice(index).forEach(function (item) {
	                    if (!item.isPause) {
	                        item.reject(new Error("Cannot throttle item because an item was added in front of it which caused the queue to overflow!"));
	                        _this4.totalCost -= item.cost;
	                    }
	                });
	            }
	        }
	
	        /**
	        * returns the first item from the queue
	        *
	        * @private
	        */
	
	    }, {
	        key: "getFirstItem",
	        value: function getFirstItem() {
	            if (this.queue.length > 0) {
	                return this.queue[0];
	            } else {
	                return null;
	            }
	        }
	
	        /**
	        * pasue the bucket for the given cost. means that an item is added in the 
	        * front of the queue with the cost passed to this method
	        *
	        * @param {number} cost the cost to pasue by
	        */
	
	    }, {
	        key: "pauseByCost",
	        value: function pauseByCost(cost) {
	            this.stopTimer();
	            this.throttle(cost, false, true);
	        }
	
	        /**
	        * pause the bucket for n seconds. means that an item with the cost for one
	        * second is added at the beginning of the queue
	        * 
	        * @param {number} seconds the number of seconds to pause the bucket by
	        */
	
	    }, {
	        key: "pause",
	        value: function pause() {
	            var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	            this.drain();
	            this.stopTimer();
	            var cost = this.refillRate * seconds;
	            this.pauseByCost(cost);
	        }
	
	        /**
	        * drains the bucket, so that nothing can be exuted at the moment
	        *
	        * @private
	        */
	
	    }, {
	        key: "drain",
	        value: function drain() {
	            this.currentCapacity = 0;
	            this.lastRefill = Date.now();
	        }
	
	        /**
	        * set the timeout value for the bucket. this is the amount of time no item 
	        * may longer wait for.
	        *
	        * @param {number} timeout in seonds
	        */
	
	    }, {
	        key: "setTimeout",
	        value: function setTimeout(timeout) {
	            this.timeout = timeout;
	            this.updateVariables();
	            return this;
	        }
	
	        /**
	        * set the interval within whch the capacity can be used
	        *
	        * @param {number} interval in seonds
	        */
	
	    }, {
	        key: "setInterval",
	        value: function setInterval(interval) {
	            this.interval = interval;
	            this.updateVariables();
	            return this;
	        }
	
	        /**
	        * set the capacity of the bucket. this si the capacity that can be used per interval
	        *
	        * @param {number} capacity
	        */
	
	    }, {
	        key: "setCapacity",
	        value: function setCapacity(capacity) {
	            this.capacity = capacity;
	            this.updateVariables();
	            return this;
	        }
	
	        /**
	        * claculates the values of some frequently used variables on the bucket
	        *
	        * @private
	        */
	
	    }, {
	        key: "updateVariables",
	        value: function updateVariables() {
	            // take one as default for each variable since this method may be called
	            // before every variable was set
	            this.maxCapacity = (this.timeout || 1) / (this.interval || 1) * (this.capacity || 1);
	
	            // the rate, at which the leaky bucket is filled per second
	            this.refillRate = (this.capacity || 1) / (this.interval || 1);
	        }
	    }]);
	
	    return LeakyBucket;
	}();
	
	module.exports = LeakyBucket;

/***/ }),
/* 134 */
/*!****************************!*\
  !*** ./src/utils/utils.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	  cookies: __webpack_require__(/*! cookies-js */ 86),
	  eventemitter2: __webpack_require__(/*! eventemitter2 */ 87),
	  assign: __webpack_require__(/*! ../polyfills/assign */ 3),
	  _: __webpack_require__(/*! ./lodash */ 1),
	  isMobile: __webpack_require__(/*! ./is-mobile */ 83),
	  uuid: __webpack_require__(/*! ./uuid */ 135),
	  domready: __webpack_require__(/*! ./domready */ 76),
	  Promise: __webpack_require__(/*! ./promises */ 5),
	  superagent: __webpack_require__(/*! superagent */ 47)
	};

/***/ }),
/* 135 */
/*!***************************!*\
  !*** ./src/utils/uuid.js ***!
  \***************************/
/***/ (function(module, exports) {

	"use strict";
	/*global module*/
	
	// Private array of chars to use
	
	var CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	
	var uuid = function uuid(len, radix) {
	  var chars = CHARS,
	      uu = [],
	      i;
	  radix = radix || chars.length;
	
	  if (len) {
	    // Compact form
	    for (i = 0; i < len; i++) {
	      uu[i] = chars[0 | Math.random() * radix];
	    }
	  } else {
	    // rfc4122, version 4 form
	    var r;
	
	    // rfc4122 requires these characters
	    uu[8] = uu[13] = uu[18] = uu[23] = "-";
	    uu[14] = "4";
	
	    // Fill in random data.  At i==19 set the high bits of clock sequence as
	    // per rfc4122, sec. 4.1.5
	    for (i = 0; i < 36; i++) {
	      if (!uu[i]) {
	        r = 0 | Math.random() * 16;
	        uu[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
	      }
	    }
	  }
	
	  return uu.join("");
	};
	
	// A more performant, but slightly bulkier, RFC4122v4 solution.  We boost performance
	// by minimizing calls to random()
	var uuidFast = function uuidFast() {
	  var chars = CHARS,
	      uu = new Array(36),
	      rnd = 0,
	      r;
	  for (var i = 0; i < 36; i++) {
	    if (i === 8 || i === 13 || i === 18 || i === 23) {
	      uu[i] = "-";
	    } else if (i === 14) {
	      uu[i] = "4";
	    } else {
	      if (rnd <= 0x02) {
	        rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
	      }
	      r = rnd & 0xf;
	      rnd = rnd >> 4;
	      uu[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
	    }
	  }
	  return uu.join("");
	};
	
	// A more compact, but less performant, RFC4122v4 solution:
	var uuidCompact = function uuidCompact() {
	  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0,
	        v = c === "x" ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};
	
	module.exports = { uuid: uuid, uuidFast: uuidFast, uuidCompact: uuidCompact };

/***/ }),
/* 136 */
/*!************************************************!*\
  !*** ./~/bluebird/js/browser/bluebird.core.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2017 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 3.5.1
	 * Features enabled: core
	 * Features disabled: race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule");
	var Queue = _dereq_("./queue");
	var util = _dereq_("./util");
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	},{"./queue":17,"./schedule":18,"./util":21}],2:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};
	
	},{}],3:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise":15}],4:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};
	
	},{"./util":21}],5:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util");
	var getKeys = _dereq_("./es5").keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};
	
	},{"./es5":10,"./util":21}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};
	
	},{}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = _dereq_("./errors").Warning;
	var util = _dereq_("./util");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (true ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	},{"./errors":9,"./util":21}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};
	
	},{}],9:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5":10,"./util":21}],10:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],11:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = _dereq_("./util");
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};
	
	},{"./catch_filter":5,"./util":21}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = _dereq_("./util");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var args = [].slice.call(arguments);;
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util":21}],13:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util":21}],14:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors");
	var OperationalError = errors.OperationalError;
	var es5 = _dereq_("./es5");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var args = [].slice.call(arguments, 1);;
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;
	
	},{"./errors":9,"./es5":10,"./util":21}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = _dereq_("./util");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = _dereq_("./es5");
	var Async = _dereq_("./async");
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = _dereq_("./errors");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array")(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = _dereq_("./context")(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = _dereq_("./debuggability")(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
	var nodebackForPromise = _dereq_("./nodeback");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
	_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
	_dereq_("./direct_resolve")(Promise);
	_dereq_("./synchronous_inspection")(Promise);
	_dereq_("./join")(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.1";
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	},{"./async":1,"./bind":2,"./cancel":4,"./catch_filter":5,"./context":6,"./debuggability":7,"./direct_resolve":8,"./errors":9,"./es5":10,"./finally":11,"./join":12,"./method":13,"./nodeback":14,"./promise_array":16,"./synchronous_inspection":19,"./thenables":20,"./util":21}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = _dereq_("./util");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util":21}],17:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],18:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":21}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util":21}],21:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"NODE_ENV":"production"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5":10}]},{},[3])(3)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../process/browser.js */ 121), (function() { return this; }()), __webpack_require__(/*! ./../../../timers-browserify/main.js */ 335).setImmediate))

/***/ }),
/* 137 */
/*!**************************************!*\
  !*** ./~/browser-jsonp/lib/jsonp.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	  var JSONP, computedUrl, createElement, encode, noop, objectToURI, random, randomString;
	
	  createElement = function(tag) {
	    return window.document.createElement(tag);
	  };
	
	  encode = window.encodeURIComponent;
	
	  random = Math.random;
	
	  JSONP = function(options) {
	    var callback, callbackFunc, callbackName, done, head, params, script;
	    if (options == null) {
	      options = {};
	    }
	    params = {
	      data: options.data || {},
	      error: options.error || noop,
	      success: options.success || noop,
	      beforeSend: options.beforeSend || noop,
	      complete: options.complete || noop,
	      url: options.url || ''
	    };
	    params.computedUrl = computedUrl(params);
	    if (params.url.length === 0) {
	      throw new Error('MissingUrl');
	    }
	    done = false;
	    if (params.beforeSend({}, params) !== false) {
	      callbackName = options.callbackName || 'callback';
	      callbackFunc = options.callbackFunc || 'jsonp_' + randomString(15);
	      callback = params.data[callbackName] = callbackFunc;
	      window[callback] = function(data) {
	        window[callback] = null;
	        params.success(data, params);
	        return params.complete(data, params);
	      };
	      script = createElement('script');
	      script.src = computedUrl(params);
	      script.async = true;
	      script.onerror = function(evt) {
	        params.error({
	          url: script.src,
	          event: evt
	        });
	        return params.complete({
	          url: script.src,
	          event: evt
	        }, params);
	      };
	      script.onload = script.onreadystatechange = function() {
	        var ref, ref1;
	        if (done || ((ref = this.readyState) !== 'loaded' && ref !== 'complete')) {
	          return;
	        }
	        done = true;
	        if (script) {
	          script.onload = script.onreadystatechange = null;
	          if ((ref1 = script.parentNode) != null) {
	            ref1.removeChild(script);
	          }
	          return script = null;
	        }
	      };
	      head = window.document.getElementsByTagName('head')[0] || window.document.documentElement;
	      head.insertBefore(script, head.firstChild);
	    }
	    return {
	      abort: function() {
	        window[callback] = function() {
	          return window[callback] = null;
	        };
	        done = true;
	        if (script != null ? script.parentNode : void 0) {
	          script.onload = script.onreadystatechange = null;
	          script.parentNode.removeChild(script);
	          return script = null;
	        }
	      }
	    };
	  };
	
	  noop = function() {
	    return void 0;
	  };
	
	  computedUrl = function(params) {
	    var url;
	    url = params.url;
	    url += params.url.indexOf('?') < 0 ? '?' : '&';
	    url += objectToURI(params.data);
	    return url;
	  };
	
	  randomString = function(length) {
	    var str;
	    str = '';
	    while (str.length < length) {
	      str += random().toString(36).slice(2, 3);
	    }
	    return str;
	  };
	
	  objectToURI = function(obj) {
	    var data, key, value;
	    data = (function() {
	      var results;
	      results = [];
	      for (key in obj) {
	        value = obj[key];
	        results.push(encode(key) + '=' + encode(value));
	      }
	      return results;
	    })();
	    return data.join('&');
	  };
	
	  if ("function" !== "undefined" && __webpack_require__(/*! !webpack amd define */ 336) !== null ? __webpack_require__(/*! !webpack amd options */ 337) : void 0) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return JSONP;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
	    module.exports = JSONP;
	  } else {
	    this.JSONP = JSONP;
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../webpack/buildin/module.js */ 48)(module)))

/***/ }),
/* 138 */
/*!********************************!*\
  !*** ./src/client/auth.coffee ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Auth, EventBus, Promise, _, assign, getNoUserPromise, getUser, isMobile, logger, parseParams, postForm,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	isMobile = __webpack_require__(/*! ../utils/is-mobile */ 83);
	
	getNoUserPromise = function() {
	  return Promise.reject({
	    reason: 'no_current_user',
	    message: 'User must be logged in to perform this action'
	  });
	};
	
	getUser = function() {
	  var user;
	  user = Hull.currentUser();
	  return !!user && (user.id != null);
	};
	
	parseParams = function(argsArray) {
	  var base, base1, callback, errback, login, next, opts, password;
	  opts = {};
	  while ((next = argsArray.shift())) {
	    if (_.isString(next)) {
	      if (!login) {
	        login = next;
	      } else {
	        password = next;
	      }
	    } else if (_.isFunction(next)) {
	      if (!callback) {
	        callback = next;
	      } else {
	        errback = next;
	      }
	    } else if (_.isObject(next) && !_.isEmpty(next)) {
	      if (!login && !password) {
	        opts = next;
	      } else {
	        opts.params = assign(next, opts.params || {});
	      }
	    }
	  }
	  if (login) {
	    opts = password ? assign(opts, {
	      login: login,
	      password: password
	    }) : assign(opts, {
	      provider: login
	    });
	  }
	  opts.params = opts.params || {};
	  callback = callback || function() {};
	  errback = errback || function() {};
	  if (isMobile()) {
	    (base = opts.params).display || (base.display = 'touch');
	  }
	  if (opts.provider === 'facebook') {
	    (base1 = opts.params).display || (base1.display = opts.strategy === 'redirect' ? 'page' : 'popup');
	  }
	  if (opts.password != null) {
	    delete opts.params;
	  }
	  return {
	    options: opts,
	    callback: callback,
	    errback: errback
	  };
	};
	
	postForm = function(path, method, params) {
	  var form, hiddenField, key;
	  if (method == null) {
	    method = 'post';
	  }
	  if (params == null) {
	    params = {};
	  }
	  form = document.createElement("form");
	  form.setAttribute("method", method);
	  form.setAttribute("action", path);
	  for (key in params) {
	    if (params.hasOwnProperty(key)) {
	      hiddenField = document.createElement("input");
	      hiddenField.setAttribute("type", "hidden");
	      hiddenField.setAttribute("name", key);
	      hiddenField.setAttribute("value", params[key]);
	      form.appendChild(hiddenField);
	    }
	  }
	  document.body.appendChild(form);
	  return form.submit();
	};
	
	Auth = (function() {
	  function Auth(api, currentUser, currentConfig) {
	    this.completeLoginPromiseChain = bind(this.completeLoginPromiseChain, this);
	    this.unlinkIdentity = bind(this.unlinkIdentity, this);
	    this.linkIdentity = bind(this.linkIdentity, this);
	    this.signup = bind(this.signup, this);
	    this.confirmEmail = bind(this.confirmEmail, this);
	    this.resetPassword = bind(this.resetPassword, this);
	    this.logout = bind(this.logout, this);
	    this.login = bind(this.login, this);
	    this.loginWithProvider = bind(this.loginWithProvider, this);
	    this.onAuthComplete = bind(this.onAuthComplete, this);
	    this.createAuthCallback = bind(this.createAuthCallback, this);
	    this.api = api;
	    this.currentUser = currentUser;
	    this.currentConfig = currentConfig;
	    this._popupInterval = null;
	    this._authenticating = null;
	    this.authServices = _.keys(this.currentConfig.get('services.auth'));
	  }
	
	  Auth.prototype.isAuthenticating = function() {
	    return this._authenticating != null;
	  };
	
	  Auth.prototype.generateAuthUrl = function(opts) {
	    var params, querystring;
	    if (opts == null) {
	      opts = {};
	    }
	    this.createAuthCallback();
	    params = opts.params || {};
	    params.app_id = this.currentConfig.get('appId');
	    params.callback_url = opts.redirect_url || params.callback_url || this.currentConfig.get('callback_url') || this.currentConfig.get('callbackUrl') || document.location.toString();
	    params.auth_referer = document.location.toString();
	    params.version = this.currentConfig.get('version');
	    params._bid = this.currentConfig.identifyBrowser().id;
	    params._sid = this.currentConfig.identifySession().id;
	    querystring = _.map(params, function(v, k) {
	      return encodeURIComponent(k) + '=' + encodeURIComponent(v);
	    }).join('&');
	    return (this.currentConfig.get('orgUrl')) + "/auth/" + opts.provider + "?" + querystring;
	  };
	
	  Auth.prototype.createAuthCallback = function() {
	    return window.__hull_login_status__ = (function(_this) {
	      return function(hash) {
	        window.__hull_login_status__ = null;
	        return _this.onAuthComplete(hash);
	      };
	    })(this);
	  };
	
	  Auth.prototype.popupAuthWindow = function(path, opts) {
	    var height, openerString, ref, ref1, w, width;
	    if (opts == null) {
	      opts = {};
	    }
	    ref = opts.provider === 'facebook' && opts.params.display === 'popup' ? [500, 400] : [1030, 550], width = ref[0], height = ref[1];
	    openerString = "location=0,status=0,width=" + width + ",height=" + height;
	    w = window.open(path, "_auth", openerString);
	    if ((ref1 = window.device) != null ? ref1.cordova : void 0) {
	      if (w != null) {
	        w.addEventListener('loadstart', function(event) {
	          var hash;
	          hash = (function() {
	            try {
	              return JSON.parse(Base64.decode(event.url.split('#')[1]));
	            } catch (error1) {}
	          })();
	          if (hash) {
	            window.__hull_login_status__(hash);
	            return w.close();
	          }
	        });
	      }
	    }
	    setTimeout((function(_this) {
	      return function() {
	        return _this.onAuthComplete({
	          success: false,
	          error: {
	            reason: 'timeout',
	            message: 'Timeout for login (after 30 seconds), User never finished the auth'
	          }
	        });
	      };
	    })(this), 90000);
	    return this._popupInterval = (w != null) && setInterval((function(_this) {
	      return function() {
	        if (w != null ? w.closed : void 0) {
	          return _this.onAuthComplete({
	            success: false,
	            error: {
	              reason: 'window_closed',
	              message: 'User closed the window before finishing. He might have canceled'
	            }
	          });
	        }
	      };
	    })(this), 200);
	  };
	
	  Auth.prototype.onAuthComplete = function(hash) {
	    var error, k, ref, ref1, v;
	    if (!this._authenticating) {
	      return;
	    }
	    if (hash.success) {
	      this._authenticating.resolve({});
	    } else {
	      error = new Error("Login failed : " + (hash != null ? (ref = hash.error) != null ? ref.reason : void 0 : void 0));
	      ref1 = hash.error;
	      for (k in ref1) {
	        v = ref1[k];
	        error[k] = v;
	      }
	      this._authenticating.reject(error);
	    }
	    this._authenticating = null;
	    clearInterval(this._popupInterval);
	    this._popupInterval = null;
	    return void 0;
	  };
	
	  Auth.prototype.loginWithProvider = function(opts) {
	    var authUrl, isAuthenticating, promise;
	    isAuthenticating = this.isAuthenticating();
	    if (isAuthenticating) {
	      return isAuthenticating;
	    }
	    this._authenticating = {};
	    promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._authenticating.resolve = resolve;
	        return _this._authenticating.reject = reject;
	      };
	    })(this));
	    if (!~(_.indexOf(this.authServices, opts.provider))) {
	      this._authenticating.reject({
	        message: "No authentication service " + opts.provider + " configured for the app",
	        reason: 'no_such_service'
	      });
	      return promise;
	    }
	    this._authenticating.provider = opts.provider.toLowerCase();
	    authUrl = this.generateAuthUrl(opts);
	    if (opts.strategy === 'redirect') {
	      window.location.href = authUrl;
	    } else {
	      this.popupAuthWindow(authUrl, opts);
	    }
	    return promise;
	  };
	
	  Auth.prototype.login = function() {
	    var callback, errback, msg, op, options, postUrl, promise, provider, ref;
	    if (this.isAuthenticating()) {
	      msg = "Login in progress. Use `Hull.on('hull.user.login', callback)` to call `callback` when done.";
	      logger.info(msg);
	      return Promise.reject({
	        error: {
	          reason: 'in_progress',
	          message: 'Login already in progress'
	        }
	      });
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    if (!(((options != null ? options.provider : void 0) != null) || (options.login != null) || (options.access_token != null))) {
	      if (!((options.login != null) && (options.password != null))) {
	        msg = 'Seems like something is wrong in your Hull.login() call, We need a login and password fields to login. Read up here: http://www.hull.io/docs/references/hull_js/#user-signup-and-login';
	        logger.warn(msg);
	        return Promise.reject({
	          error: {
	            reason: 'missing_parameters',
	            message: 'Empty login or password'
	          }
	        });
	      }
	    }
	    if (options.provider != null) {
	      if (options.access_token != null) {
	        provider = assign({}, options);
	        delete provider.provider;
	        op = {};
	        op[options.provider] = provider;
	        promise = this.api.message('users', 'post', op);
	      } else {
	        promise = this.loginWithProvider(options);
	      }
	    } else {
	      promise = this.api.message('users/login', 'post', _.pick(options, 'login', 'password', 'access_token'));
	      if (options.strategy === 'redirect' || !this.currentConfig.getRemote('cookiesEnabled')) {
	        postUrl = this.currentConfig.get('orgUrl') + '/api/v1/users/login';
	        options.redirect_url || (options.redirect_url = window.location.href);
	        promise = promise.then(function() {
	          return postForm(postUrl, 'post', options);
	        });
	      }
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.logout = function(options, callback, errback) {
	    var b, logoutUrl, promise, redirect_url;
	    if (options == null) {
	      options = {};
	    }
	    this.currentConfig.resetIdentify();
	    this.api.channel.rpc.resetIdentify();
	    promise = this.api.message('logout');
	    if (options.strategy === 'redirect' || !this.currentConfig.getRemote('cookiesEnabled')) {
	      redirect_url = options.redirect_url || document.location.href;
	      b = new Date().getTime();
	      logoutUrl = this.currentConfig.get('orgUrl') + '/api/v1/logout?b=' + b + '&redirect_url=' + encodeURIComponent(redirect_url);
	      promise.then(function() {
	        return document.location = logoutUrl;
	      });
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.resetPassword = function(email, callback, errback) {
	    var promise;
	    if (email == null) {
	      email = this.currentUser.get('email');
	    }
	    promise = this.api.message('/users/request_password_reset', 'post', {
	      email: email
	    });
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.confirmEmail = function(email, callback, errback) {
	    var promise;
	    if (email == null) {
	      email = this.currentUser.get('email');
	    }
	    promise = this.api.message('/users/request_confirmation_email', 'post', {
	      email: email
	    });
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.signup = function(attrs, callback, errback) {
	    var postUrl, promise;
	    promise = this.api.message('users', 'POST', attrs);
	    if (!this.currentConfig.getRemote('cookiesEnabled')) {
	      postUrl = this.currentConfig.get('orgUrl') + '/api/v1/users/login';
	      promise = promise.then(function(user) {
	        var params;
	        params = {
	          redirect_url: window.location.href,
	          access_token: user.access_token
	        };
	        return postForm(postUrl, 'post', params);
	      });
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	
	  /**
	   * link an Identity to a Hull User
	   * @param  {options} An options Hash
	   * @param  {callback} Success callback
	   * @param  {errback} error callback
	   * @return {Promise} A promise
	   */
	
	  Auth.prototype.linkIdentity = function() {
	    var callback, errback, options, ref;
	    if (!getUser()) {
	      return getNoUserPromise();
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    options.params.mode = 'connect';
	    return this.login(options, callback, errback);
	  };
	
	
	  /**
	   * unlink an Identity from a Hull User
	   * @param  {options} An options Hash
	   * @param  {callback} Success callback
	   * @param  {errback} error callback
	   * @return {Promise} A promise
	   *
	   */
	
	  Auth.prototype.unlinkIdentity = function() {
	    var callback, errback, options, promise, ref;
	    if (!getUser()) {
	      return getNoUserPromise();
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    promise = this.api.message("me/identities/" + options.provider, 'delete');
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.completeLoginPromiseChain = function(promise, callback, errback) {
	    var p;
	    if (promise && promise.then) {
	      callback = callback || function() {};
	      errback = errback || function() {};
	      p = promise.then(this.api.refreshUser, this.emitLoginFailure);
	      p.then(callback, errback);
	      return p;
	    }
	  };
	
	  Auth.prototype.emitLoginFailure = function(err) {
	    EventBus.emit("hull.user.fail", err);
	    err;
	    throw err;
	  };
	
	  return Auth;
	
	})();
	
	module.exports = Auth;


/***/ }),
/* 139 */
/*!******************************************!*\
  !*** ./src/client/current-config.coffee ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64, CurrentConfig, EventBus, Promise, _, assign, checkConfig, clone, extractDomainFromUrl, extractUtmTags, formatTrackConfig, getKey, getReferralContext, getRemoteUrl, localstorage, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	localstorage = __webpack_require__(/*! putainde-localstorage */ 326);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	clone = __webpack_require__(/*! ../utils/clone */ 11);
	
	throwErr = __webpack_require__(/*! ../utils/throw */ 26);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 15);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	getKey = __webpack_require__(/*! ../utils/get-key */ 82);
	
	getReferralContext = function() {
	  return {
	    initial_url: document.location.href,
	    initial_referrer: document.referrer || '$direct',
	    initial_referring_domain: extractDomainFromUrl(document.referrer) || '$direct',
	    initial_utm_tags: extractUtmTags(),
	    first_seen_at: new Date().getTime()
	  };
	};
	
	getRemoteUrl = function(config, identifiers) {
	  var url;
	  url = config.orgUrl + "/api/v1/" + config.appId + "/remote.html?v=" + ("0.11.0");
	  url += "&r=" + (encodeURIComponent(document.referrer));
	  if (config.jsUrl) {
	    url += "&js=" + config.jsUrl;
	  }
	  if (config.uid) {
	    url += "&uid=" + config.uid;
	  }
	  if (config.debugRemote) {
	    url += "&debug_remote=true";
	  }
	  if (config.accessToken != null) {
	    url += "&access_token=" + config.accessToken;
	  }
	  if (config.userHash !== void 0) {
	    url += "&user_hash=" + config.userHash;
	  }
	  if (identifiers != null ? identifiers.bid : void 0) {
	    url += "&_bid=" + identifiers.bid;
	  }
	  if (identifiers != null ? identifiers.sid : void 0) {
	    url += "&_sid=" + identifiers.sid;
	  }
	  if (config.ravenDsn) {
	    url += "&ravenDsn=" + config.ravenDsn;
	  }
	  return url;
	};
	
	formatTrackConfig = function(config) {
	  var m;
	  if (config == null) {
	    config = {};
	  }
	  switch ((Object.prototype.toString.call(config).match(/^\[object (.*)\]$/)[1])) {
	    case "Object":
	      if (config.only != null) {
	        config = {
	          only: (function() {
	            var i, len, ref, results;
	            ref = config.only;
	            results = [];
	            for (i = 0, len = ref.length; i < len; i++) {
	              m = ref[i];
	              results.push(m.toString());
	            }
	            return results;
	          })()
	        };
	      } else if (config.ignore != null) {
	        config = {
	          ignore: (function() {
	            var i, len, ref, results;
	            ref = config.ignore;
	            results = [];
	            for (i = 0, len = ref.length; i < len; i++) {
	              m = ref[i];
	              results.push(m.toString());
	            }
	            return results;
	          })()
	        };
	      } else {
	        config;
	      }
	      break;
	    case "RegExp":
	      config = {
	        only: config.toString()
	      };
	      break;
	    case "Array":
	      config = {
	        only: (function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = config.length; i < len; i++) {
	            m = config[i];
	            results.push(m.toString());
	          }
	          return results;
	        })()
	      };
	  }
	  if (typeof document !== "undefined" && document !== null ? document.referrer : void 0) {
	    config.referrer = document.referrer;
	  }
	  return config;
	};
	
	checkConfig = function(config) {
	  var promise;
	  config = clone(config);
	  config.track = formatTrackConfig(config.track);
	  promise = new Promise((function(_this) {
	    return function(resolve, reject) {
	      var msg, readMore;
	      msg = "You need to pass some keys to Hull to start it: ";
	      readMore = "Read more about this here : http://www.hull.io/docs/references/hull_js/#hull-init-params-cb-errb";
	      if (config.orgUrl && config.appId) {
	        if (config.orgUrl.match(/^\/\//)) {
	          reject(new Error(" You specified orgUrl as " + config.orgUrl + ". We do not support protocol-relative URLs in organization URLs yet."));
	        }
	        if (!config.orgUrl.match(/^http[s]?:\/\//)) {
	          config.orgUrl = "https://" + config.orgUrl;
	        }
	        return resolve(config);
	      } else {
	        if (!config.orgUrl) {
	          reject(new Error(msg + " We couldn't find `orgUrl` in the config object you passed to `Hull.init`\n " + readMore));
	        }
	        if (!config.appId) {
	          return reject(new Error(msg + " We couldn't find `platformId` in the config object you passed to `Hull.init`\n " + readMore));
	        }
	      }
	    };
	  })(this));
	  promise.then(null, throwErr);
	  return promise;
	};
	
	extractDomainFromUrl = function(url) {
	  var u;
	  if (!(url && url.length)) {
	    return;
	  }
	  u = url.match(/^(https?:\/\/)?([\da-z\.-]+)([\/\w \.-]*)*\/?/);
	  if (u) {
	    return u[2];
	  }
	};
	
	extractUtmTags = function() {
	  return _.reduce(document.location.search.slice(1).split('&'), function(tags, t) {
	    var k, ref, v;
	    ref = t.split('=', 2), k = ref[0], v = ref[1];
	    if (/^utm_/.test(k)) {
	      tags[k.replace(/^utm_/, '')] = v;
	    }
	    return tags;
	  }, {});
	};
	
	CurrentConfig = (function() {
	  function CurrentConfig() {
	    this.onUpdate = bind(this.onUpdate, this);
	    this.identify = bind(this.identify, this);
	    this.storageGet = bind(this.storageGet, this);
	    this.storageSet = bind(this.storageSet, this);
	    this.identifyBrowser = bind(this.identifyBrowser, this);
	    this.identifySession = bind(this.identifySession, this);
	    this.getRemoteUrl = bind(this.getRemoteUrl, this);
	    this.get = bind(this.get, this);
	  }
	
	  CurrentConfig.prototype.init = function(config) {
	    this._remoteConfig = {};
	    this._clientConfig = {};
	    return checkConfig(config).then((function(_this) {
	      return function(config) {
	        var ns, org;
	        org = extractDomainFromUrl(config.orgUrl);
	        ns = ['hull'].concat(org.split('.')).join('_');
	        _this.storage = localstorage.create({
	          namespace: ns
	        });
	        _this._clientConfig = config;
	        return _this;
	      };
	    })(this), throwErr);
	  };
	
	  CurrentConfig.prototype.initRemote = function(cfg) {
	    if (cfg == null) {
	      cfg = {};
	    }
	    this.identifyBrowser(cfg.identify.browser, {
	      count: true
	    });
	    this.identifySession(cfg.identify.session, {
	      count: true
	    });
	    return this._remoteConfig = cfg;
	  };
	
	  CurrentConfig.prototype.set = function(config, key) {
	    if (key != null) {
	      return this._clientConfig[key] = config;
	    } else {
	      return this._clientConfig = config;
	    }
	  };
	
	  CurrentConfig.prototype.setSettings = function() {};
	
	  CurrentConfig.prototype.setRemote = function(hash, key) {
	    var previousConfig;
	    if (key) {
	      previousConfig = this._remoteConfig[key];
	      this._remoteConfig[key] = assign({}, this._remoteConfig[key], hash);
	    } else {
	      previousConfig = this._remoteConfig;
	      this._remoteConfig = assign({}, this._remoteConfig, hash);
	    }
	    if (!_.isEqual(previousConfig, hash)) {
	      return this.onUpdate();
	    }
	  };
	
	  CurrentConfig.prototype.get = function(key) {
	    var hash;
	    hash = clone(this._clientConfig);
	    hash.services = clone(this._remoteConfig.services);
	    return getKey(hash, key);
	  };
	
	  CurrentConfig.prototype.getRemote = function(key) {
	    return getKey(this._remoteConfig, key);
	  };
	
	  CurrentConfig.prototype.getRemoteUrl = function() {
	    var browser, session;
	    browser = this.identifyBrowser(this._clientConfig.anonymousId || this._clientConfig.browserId);
	    session = this.identifySession(this._clientConfig.sessionId);
	    return getRemoteUrl(this._clientConfig, {
	      bid: browser.id,
	      sid: session.id
	    });
	  };
	
	  CurrentConfig.prototype.identifySession = function(id, options) {
	    var session;
	    if (options == null) {
	      options = {};
	    }
	    session = this.identify('session', id, assign({}, options, {
	      expires: 60 * 1000 * 30
	    }));
	    this._clientConfig.sessionId = session.id;
	    return session;
	  };
	
	  CurrentConfig.prototype.identifyBrowser = function(id, options) {
	    var browser;
	    if (options == null) {
	      options = {};
	    }
	    browser = this.identify('browser', id, options);
	    this._clientConfig.browserId = browser.id;
	    this._clientConfig.anonymousId = browser.id;
	    return browser;
	  };
	
	  CurrentConfig.prototype.storageSet = function(key, value) {
	    var e;
	    try {
	      return this.storage.set(key, value);
	    } catch (error) {
	      e = error;
	      return null;
	    }
	  };
	
	  CurrentConfig.prototype.storageGet = function(key) {
	    var e;
	    try {
	      return this.storage.get(key);
	    } catch (error) {
	      e = error;
	      return null;
	    }
	  };
	
	  CurrentConfig.prototype.resetIdentify = function() {
	    try {
	      return this.storage.clear();
	    } catch (error) {}
	  };
	
	  CurrentConfig.prototype.identify = function(key, id, options) {
	    var ident, now;
	    if (options == null) {
	      options = {};
	    }
	    ident = this.storageGet(key);
	    now = new Date().getTime();
	    if (options.expires) {
	      if (!ident || ident.expires_at < now) {
	        ident = getReferralContext();
	      }
	      ident.expires_at = now + options.expires;
	    } else {
	      if (ident == null) {
	        ident = getReferralContext();
	      }
	    }
	    if (id != null) {
	      ident.id = id;
	    }
	    if (options.count) {
	      ident.inits_count = (ident.inits_count || 0) + 1;
	    }
	    this.storageSet(key, ident);
	    return ident;
	  };
	
	  CurrentConfig.prototype.onUpdate = function() {
	    return EventBus.emit('hull.config.update', this.get());
	  };
	
	  return CurrentConfig;
	
	})();
	
	module.exports = CurrentConfig;


/***/ }),
/* 140 */
/*!****************************************!*\
  !*** ./src/client/current-user.coffee ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64, CurrentUser, EventBus, Raven, _, clone, cookies, fixCookies, getKey, setUserContext,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 31);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 15);
	
	clone = __webpack_require__(/*! ../utils/clone */ 11);
	
	getKey = __webpack_require__(/*! ../utils/get-key */ 82);
	
	Raven = __webpack_require__(/*! ../utils/raven */ 32);
	
	fixCookies = function(userSig) {
	  var e;
	  try {
	    if (window.jQuery && _.isFunction(window.jQuery.fn.ajaxSend)) {
	      return window.jQuery(document).ajaxSend(function(e, xhr, opts) {
	        if (userSig && !opts.crossDomain) {
	          return xhr.setRequestHeader('Hull-User-Sig', userSig);
	        }
	      });
	    }
	  } catch (error) {
	    e = error;
	  }
	};
	
	setUserContext = function(user) {
	  var e;
	  try {
	    if (user && user.id) {
	      return Raven.setUserContext({
	        id: user.id,
	        email: user.email
	      });
	    }
	  } catch (error) {
	    e = error;
	  }
	};
	
	CurrentUser = (function() {
	  function CurrentUser() {
	    this.set = bind(this.set, this);
	    this.init = bind(this.init, this);
	    this.setLoginStatus = bind(this.setLoginStatus, this);
	    this.hasIdentity = bind(this.hasIdentity, this);
	    this.clear = bind(this.clear, this);
	    this.get = bind(this.get, this);
	    this.clear();
	  }
	
	  CurrentUser.prototype.get = function(key) {
	    if (!key && !this.me) {
	      return null;
	    }
	    return getKey(this.me, key);
	  };
	
	  CurrentUser.prototype.clear = function() {
	    return this.me = null;
	  };
	
	  CurrentUser.prototype.hasIdentity = function(identity) {
	    var identities, ref;
	    if (identity == null) {
	      return false;
	    }
	    identities = (ref = this.me) != null ? ref.identities : void 0;
	    identity = identity.toLowerCase();
	    if (!(identities && identity)) {
	      return false;
	    }
	    return _.some(identities, function(i) {
	      return i.provider.toLowerCase() === identity;
	    });
	  };
	
	  CurrentUser.prototype.setLoginStatus = function(me, provider) {
	    var ref;
	    this.me = me;
	    if ((me != null ? (ref = me.stats) != null ? ref.sign_in_count : void 0 : void 0) == null) {
	      EventBus.emit('hull.user.create', me);
	    }
	    return EventBus.emit('hull.user.login', me, provider);
	  };
	
	  CurrentUser.prototype.init = function(me) {
	    this.me = me;
	    setUserContext(me);
	    return me;
	  };
	
	  CurrentUser.prototype.set = function(me) {
	    var prevId, prevUpdatedAt, ref, ref1;
	    prevUpdatedAt = (ref = this.me) != null ? ref.updated_at : void 0;
	    prevId = (ref1 = this.me) != null ? ref1.id : void 0;
	    this.me = me;
	    setUserContext(me);
	    if (prevUpdatedAt !== (me != null ? me.updated_at : void 0)) {
	      EventBus.emit('hull.user.update', me);
	    }
	    if (me != null ? me.id : void 0) {
	      if (prevId !== me.id) {
	        this.setLoginStatus(me);
	      }
	    } else {
	      if (prevId) {
	        EventBus.emit('hull.user.logout');
	      }
	    }
	    return me;
	  };
	
	  CurrentUser.prototype.setCookies = function(headers, appId) {
	    var cookieName, val;
	    if (headers == null) {
	      headers = {};
	    }
	    cookieName = "hull_" + appId;
	    if (headers && headers['Hull-User-Id'] && headers['Hull-User-Sig']) {
	      val = Base64.encode(JSON.stringify(headers));
	      this.signature = val;
	      fixCookies(val);
	      return cookies.set(cookieName, val, {
	        path: "/"
	      });
	    } else {
	      this.signature = false;
	      return cookies.remove(cookieName, {
	        path: "/"
	      });
	    }
	  };
	
	  return CurrentUser;
	
	})();
	
	module.exports = CurrentUser;


/***/ }),
/* 141 */
/*!*********************************************!*\
  !*** ./src/client/embeds/deployment.coffee ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Deployment, JSDeploymentStrategy, Promise, _, assign, clone, deploymentRegistry, getDeployment, getDeployments, logger, resetDeployments, shipRegistry, throwErr,
	  hasProp = {}.hasOwnProperty,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../../utils/clone */ 11);
	
	throwErr = __webpack_require__(/*! ../../utils/throw */ 26);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 4);
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 5);
	
	JSDeploymentStrategy = __webpack_require__(/*! ./strategies/js */ 143);
	
	deploymentRegistry = {};
	
	shipRegistry = {};
	
	resetDeployments = function() {
	  var deployment, key;
	  for (key in deploymentRegistry) {
	    if (!hasProp.call(deploymentRegistry, key)) continue;
	    deployment = deploymentRegistry[key];
	    deployment.destroy();
	  }
	  shipRegistry = {};
	  return deploymentRegistry = {};
	};
	
	getDeployment = function(id) {
	  return deploymentRegistry[id];
	};
	
	getDeployments = function(id) {
	  return _.values(shipRegistry[id]);
	};
	
	Deployment = (function() {
	  Deployment.resetDeployments = resetDeployments;
	
	  Deployment.getDeployment = getDeployment;
	
	  Deployment.getDeployments = getDeployments;
	
	  function Deployment(dpl, context) {
	    this.destroy = bind(this.destroy, this);
	    this.onEmbed = bind(this.onEmbed, this);
	    this.boot = bind(this.boot, this);
	    this.embed = bind(this.embed, this);
	    this.getDeploymentStrategy = bind(this.getDeploymentStrategy, this);
	    this.getPublicData = bind(this.getPublicData, this);
	    var name;
	    if (deploymentRegistry[dpl.id]) {
	      return deploymentRegistry[dpl.id];
	    }
	    deploymentRegistry[dpl.id] = this;
	    this.id = dpl.id;
	    this.name = dpl.ship.name;
	    this.organization = assign({}, context.org);
	    this.platform = dpl.platform;
	    this.ship = dpl.ship;
	    shipRegistry[name = dpl.ship.id] || (shipRegistry[name] = {});
	    shipRegistry[dpl.ship.id][dpl.id] = this;
	    this.onUpdate = dpl.onUpdate;
	    this.settings = dpl.settings;
	  }
	
	
	  /**
	   * Fetches all targets specified in a deployment
	   * @param  {object} opts options object. opts.refresh = true|false // Force Refresh
	   * @return {Nodes Array} A memoized array of Nodes matching the Query Selector (this.targets)
	   */
	
	  Deployment.prototype.getTargets = function(opts) {
	    var target, targets;
	    if (opts == null) {
	      opts = {};
	    }
	    if (this.targets && !opts.refresh) {
	      return this.targets;
	    }
	    if (!this.settings._selector) {
	      return [];
	    }
	    targets = this.settings._multi ? document.querySelectorAll(this.settings._selector) : (target = document.querySelector(this.settings._selector), target ? [target] : []);
	    if (!targets.length) {
	      logger.info("No deployment targets for selector " + this.settings._selector, this);
	    }
	    return targets;
	  };
	
	  Deployment.prototype.getPublicData = function() {
	    return assign(clone({
	      ship: this.ship,
	      organization: this.organization,
	      platform: this.platform,
	      settings: this.settings
	    }), {
	      onUpdate: this.onUpdate || function() {}
	    });
	  };
	
	  Deployment.prototype.getDeploymentStrategy = function() {
	    if (this.deploymentStrategy != null) {
	      return this.deploymentStrategy;
	    }
	    this.deploymentStrategy = new JSDeploymentStrategy(this);
	    return this.deploymentStrategy;
	  };
	
	  Deployment.prototype.embed = function(opts) {
	    var ds;
	    if (opts == null) {
	      opts = {};
	    }
	    this.targets = this.getTargets(opts);
	    ds = this.getDeploymentStrategy();
	    if (this.targets.length) {
	      return ds.embed(this.targets, opts).then((function(_this) {
	        return function() {
	          return _this.onEmbed();
	        };
	      })(this), throwErr)["catch"](throwErr);
	    } else {
	      return Promise.resolve();
	    }
	  };
	
	  Deployment.prototype.boot = function() {
	    var ref;
	    if ((ref = this.targets) != null ? ref.length : void 0) {
	      return this.getDeploymentStrategy().boot();
	    }
	  };
	
	  Deployment.prototype.onEmbed = function(callback) {
	    var ref;
	    if ((ref = this.targets) != null ? ref.length : void 0) {
	      return this.getDeploymentStrategy().onEmbed(callback);
	    }
	  };
	
	  Deployment.prototype.destroy = function() {
	    if (this.targets.length) {
	      this.getDeploymentStrategy().destroy();
	      return this.deploymentStrategy = null;
	    }
	  };
	
	  return Deployment;
	
	})();
	
	module.exports = Deployment;


/***/ }),
/* 142 */
/*!******************************************!*\
  !*** ./src/client/embeds/sandbox.coffee ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Sandbox, _, assign, clone, findUrl, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	findUrl = __webpack_require__(/*! ../../utils/find-url */ 50);
	
	clone = __webpack_require__(/*! ../../utils/clone */ 11);
	
	throwErr = __webpack_require__(/*! ../../utils/throw */ 26);
	
	Sandbox = (function() {
	  function Sandbox(deployment) {
	    this.destroy = bind(this.destroy, this);
	    this.getShipClassName = bind(this.getShipClassName, this);
	    this.getDocument = bind(this.getDocument, this);
	    this.share = bind(this.share, this);
	    this.track = bind(this.track, this);
	    this.ship = deployment.ship;
	    this.shipClassName = ".ship-" + this.ship.id;
	    this.deployment = deployment;
	    this.callbacks = [];
	    this._scopes = [];
	    this.hull = assign({}, window.Hull, {
	      getDocument: this.getDocument,
	      getShipClassName: this.getShipClassName,
	      track: this.track,
	      share: this.share
	    });
	  }
	
	
	  /**
	   * Performs a track that has the `ship_id` field set correctly
	   * @param  {[type]} name       [description]
	   * @param  {[type]} event={} [description]
	   * @return {[type]}            [description]
	   */
	
	  Sandbox.prototype.track = function(name, event) {
	    if (event == null) {
	      event = {};
	    }
	    event.ship_id = this.ship.id;
	    return Hull.track(name, event);
	  };
	
	  Sandbox.prototype.share = function(opts, event) {
	    if (opts == null) {
	      opts = {};
	    }
	    if (event == null) {
	      event = {};
	    }
	    opts.params = assign({}, opts.params, {
	      ship_id: this.ship.id
	    });
	    return Hull.share(opts, event);
	  };
	
	  Sandbox.prototype.setDocument = function(doc) {
	    if (doc == null) {
	      return;
	    }
	    return this._document = doc;
	  };
	
	  Sandbox.prototype.getDocument = function() {
	    return this._document;
	  };
	
	  Sandbox.prototype.getShipClassName = function() {
	    return this.shipClassName;
	  };
	
	  Sandbox.prototype.get = function() {
	    return this.hull;
	  };
	
	  Sandbox.prototype.destroy = function() {
	    return this._scopes = [];
	  };
	
	  return Sandbox;
	
	})();
	
	module.exports = Sandbox;


/***/ }),
/* 143 */
/*!************************************************!*\
  !*** ./src/client/embeds/strategies/js.coffee ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var JSDeploymentStrategy, Promise, Sandbox, _, getScript, logger, scriptLoader, scripts, setScript, setStyle, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	Promise = __webpack_require__(/*! ../../../utils/promises */ 5);
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	setStyle = __webpack_require__(/*! ../../../utils/set-style */ 166);
	
	logger = __webpack_require__(/*! ../../../utils/logger */ 4);
	
	throwErr = __webpack_require__(/*! ../../../utils/throw */ 26);
	
	scriptLoader = __webpack_require__(/*! ../../../utils/script-loader */ 51);
	
	Sandbox = __webpack_require__(/*! ../sandbox */ 142);
	
	scripts = {};
	
	getScript = function(deployment) {
	  return scripts[deployment.ship.id];
	};
	
	setScript = function(deployment, sc) {
	  return scripts[deployment.ship.id] = sc;
	};
	
	JSDeploymentStrategy = (function() {
	  JSDeploymentStrategy.prototype.scopeStyles = false;
	
	  function JSDeploymentStrategy(deployment) {
	    this.onEmbed = bind(this.onEmbed, this);
	    this.addInsertion = bind(this.addInsertion, this);
	    this.destroy = bind(this.destroy, this);
	    this.deployment = deployment;
	    this.sandbox = new Sandbox(deployment);
	    this.ready = {};
	    this.insertions = [];
	    this.ready.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this.ready.resolve = resolve;
	        return _this.ready.reject = reject;
	      };
	    })(this));
	  }
	
	  JSDeploymentStrategy.prototype.addShipClasses = function(el) {
	    el.className = el.className + (" ship-" + this.deployment.ship.id + " ship-deployment-" + this.deployment.id);
	    el.setAttribute('data-hull-deployment', this.deployment.id);
	    return el.setAttribute('data-hull-ship', this.deployment.ship.id);
	  };
	
	
	  /**
	   * Insert an element at the right position relative to a target.
	   * @param  {Node} el     The element to insert
	   * @param  {Node} target The target where to insert the content
	   * @return {Node}        el
	   */
	
	  JSDeploymentStrategy.prototype.insert = function(el, target) {
	    this.addShipClasses(el);
	    setStyle(el, {
	      width: this.deployment.settings._width || '100%',
	      height: this.deployment.settings.height
	    });
	    switch (this.deployment.settings._placement) {
	      case 'before':
	        target.parentNode.insertBefore(el, target);
	        break;
	      case 'after':
	        target.parentNode.insertBefore(el, target.nextSibling);
	        break;
	      case 'top':
	        target.insertBefore(el, target.firstChild);
	        break;
	      case 'replace':
	        if (target.nodeName === 'IMG') {
	          target.parentNode.replaceChild(el, target);
	        } else {
	          while (target.firstChild) {
	            target.removeChild(target.firstChild);
	          }
	          target.appendChild(el);
	        }
	        break;
	      default:
	        target.appendChild(el);
	    }
	    return el;
	  };
	
	  JSDeploymentStrategy.prototype.destroy = function() {
	    _.map(this.insertions, function(insertion) {
	      var ref, ref1;
	      return (ref = insertion.el) != null ? (ref1 = ref.parentNode) != null ? ref1.removeChild(insertion.el) : void 0 : void 0;
	    });
	    return this.insertions = [];
	  };
	
	
	  /**
	   * Embeds a Script in the page
	   * @return {promise} a promise for the onLoad event
	   */
	
	  JSDeploymentStrategy.prototype.embed = function(targets) {
	    var attributes, el, i, len, sc, target;
	    this.elements = [];
	    for (i = 0, len = targets.length; i < len; i++) {
	      target = targets[i];
	      el = document.createElement('div');
	      this.addInsertion(this.insert(el, target));
	    }
	    sc = document.querySelector("[data-hull-ship-script=\"" + this.deployment.ship.id + "\"]");
	    if (!getScript(this.deployment)) {
	      setScript(this.deployment, true);
	      attributes = {
	        'data-hull-deployment': this.deployment.id,
	        'data-hull-ship-script': this.deployment.ship.id
	      };
	      return scriptLoader({
	        src: this.deployment.ship.index,
	        attributes: attributes
	      }).then((function(_this) {
	        return function() {
	          var args, ref;
	          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          return (ref = _this.ready).resolve.apply(ref, args);
	        };
	      })(this))["catch"]((function(_this) {
	        return function(err) {
	          _this.ready.reject(err);
	          return throwErr(err);
	        };
	      })(this));
	    } else {
	      return new Promise((function(_this) {
	        return function(resolve, reject) {
	          _this.ready.resolve();
	          return resolve();
	        };
	      })(this));
	    }
	  };
	
	  JSDeploymentStrategy.prototype.addInsertion = function(el) {
	    return this.insertions.push(el);
	  };
	
	  JSDeploymentStrategy.prototype.onEmbed = function(callback) {
	    if (callback) {
	      return this.ready.promise.then((function(_this) {
	        return function() {
	          return _.map(_this.insertions, function(insertion) {
	            return callback(insertion, _this.deployment.getPublicData(), _this.sandbox.hull);
	          });
	        };
	      })(this))["catch"](throwErr);
	    }
	  };
	
	  return JSDeploymentStrategy;
	
	})();
	
	module.exports = JSDeploymentStrategy;


/***/ }),
/* 144 */
/*!**************************************!*\
  !*** ./src/client/flag/index.coffee ***!
  \**************************************/
/***/ (function(module, exports) {

	module.exports = function(api) {
	  return function(id) {
	    return api({
	      provider: "hull",
	      path: [id, 'flag'].join('/')
	    }, 'post');
	  };
	};


/***/ }),
/* 145 */
/*!*********************************!*\
  !*** ./src/client/index.coffee ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Api, Auth, Client, Entity, EventBus, Flag, QueryString, Sharer, Tracker, Traits, _, clone, findUrl, logger, utils,
	  slice = [].slice;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../utils/clone */ 11);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	Entity = __webpack_require__(/*! ../utils/entity */ 163);
	
	findUrl = __webpack_require__(/*! ../utils/find-url */ 50);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	Api = __webpack_require__(/*! ./api */ 78);
	
	Auth = __webpack_require__(/*! ./auth */ 138);
	
	Flag = __webpack_require__(/*! ./flag/index */ 144);
	
	Tracker = __webpack_require__(/*! ./track/index */ 150);
	
	Traits = __webpack_require__(/*! ./traits/index */ 151);
	
	Sharer = __webpack_require__(/*! ./sharer/index */ 149);
	
	QueryString = __webpack_require__(/*! ./querystring/index */ 147);
	
	utils = __webpack_require__(/*! ../utils/utils */ 134);
	
	Client = (function() {
	  function Client(channel, currentUser, currentConfig) {
	    var alias, api, auth, flag, qs, sharer, tracker, traits;
	    this.currentConfig = currentConfig;
	    api = new Api(channel, currentUser, currentConfig);
	    alias = function(id) {
	      return api.message({
	        path: "/me/alias"
	      }, "post", {
	        anonymous_id: id
	      });
	    };
	    auth = new Auth(api, currentUser, currentConfig);
	    tracker = new Tracker(api);
	    sharer = new Sharer(currentConfig);
	    flag = new Flag(api);
	    traits = Traits(api);
	    qs = new QueryString(traits, tracker.track, alias);
	    if (this.currentConfig.get('debug.enabled')) {
	      EventBus.on('hull.**', function() {
	        var args;
	        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        return logger.log.apply(logger, ["--HULL EVENT--[" + this.event + "]--"].concat(slice.call(args)));
	      });
	    }
	    this.hull = {
	      config: this.currentConfig.get,
	      utils: utils,
	      api: api.message,
	      currentUser: currentUser.get,
	      entity: Entity,
	      signup: auth.signup,
	      logout: auth.logout,
	      login: auth.login,
	      resetPassword: auth.resetPassword,
	      confirmEmail: auth.confirmEmail,
	      linkIdentity: auth.linkIdentity,
	      unlinkIdentity: auth.unlinkIdentity,
	      track: tracker.track,
	      trackForm: tracker.trackForm,
	      alias: alias,
	      flag: flag,
	      identify: traits,
	      traits: traits,
	      share: sharer.share,
	      findUrl: findUrl,
	      parseQueryString: qs.parse
	    };
	    this.hull;
	  }
	
	  return Client;
	
	})();
	
	module.exports = Client;


/***/ }),
/* 146 */
/*!**************************************!*\
  !*** ./src/client/parse-opts.coffee ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, _objectDescription, _stringDescription, assign, defaultProvider, parse;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	
	/*
	 * Parses the parameters for an API call. At this point, they can have two forms
	 * * [String, ...] where the String is an uri. The request will be made to the default provider
	 * * [Object, ...] where the Object describes more completely the request. It must provide a "path" key, can provide a "provider" key as well as some default parameters in the "params" key
	 * In the second form, the optional params can be overridden through parameters at data.api calls
	 *
	 * The normalized form is the first one.
	 *
	 * @param {Array} the parameters for the API calls
	 * @return {Array} The normalized form of parameters
	 */
	
	defaultProvider = 'hull';
	
	_stringDescription = function(desc) {
	  return [desc, defaultProvider, {}];
	};
	
	_objectDescription = function(desc) {
	  var organization, params, path, provider;
	  path = desc.path;
	  if (desc.organization != null) {
	    organization = desc.organization;
	  }
	  provider = desc.provider || defaultProvider;
	  params = desc.params || {};
	  return [path, provider, params, organization];
	};
	
	parse = function(argsArray) {
	  var callback, description, errback, method, next, organization, params, path, provider, ref, ref1, ret, type;
	  description = argsArray.shift();
	  if (_.isString(description)) {
	    ref = _stringDescription(description), path = ref[0], provider = ref[1], params = ref[2];
	  }
	  if (_.isObject(description)) {
	    ref1 = _objectDescription(description), path = ref1[0], provider = ref1[1], params = ref1[2], organization = ref1[3];
	  }
	  if (!path) {
	    throw "Hull cannot find the Path (URI) you want to send your request to.\nCould you check your API Call parameters ? Here's what we have received :\n${JSON.stringify(path)}";
	  }
	  if (path[0] === "/") {
	    path = path.substring(1);
	  }
	  ret = [];
	  if (params != null) {
	    ret.push(params);
	  }
	  ret = ret.concat(argsArray);
	  callback = errback = null;
	  params = {};
	  while ((next = ret.shift())) {
	    type = typeof next;
	    if (type === 'string' && !method) {
	      method = next.toLowerCase();
	    } else if (type === 'function' && (!callback || !errback)) {
	      if (!callback) {
	        callback = next;
	      } else if (!errback) {
	        errback = next;
	      }
	    } else if (type === 'object') {
	      params = assign(params, next);
	    } else {
	      throw new TypeError("Invalid argument passed to Hull.api(): " + next);
	    }
	  }
	  if (method == null) {
	    method = 'get';
	  }
	  callback = callback || function() {};
	  errback = errback || function() {};
	  return {
	    opts: {
	      provider: provider,
	      path: path,
	      method: method,
	      params: params,
	      organization: organization
	    },
	    callback: callback,
	    errback: errback
	  };
	};
	
	module.exports = parse;


/***/ }),
/* 147 */
/*!*********************************************!*\
  !*** ./src/client/querystring/index.coffee ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var QueryString, _, pick, qs,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	qs = __webpack_require__(/*! ../../utils/query-string-encoder */ 20);
	
	pick = function(prefix, obj) {
	  return _.reduce(obj, function(m, v, k) {
	    if (k.indexOf(prefix) === 0) {
	      m[k.replace(prefix, '')] = v;
	    }
	    return m;
	  }, {});
	};
	
	QueryString = (function() {
	  function QueryString(traits, track, alias, currentUser) {
	    this.parse = bind(this.parse, this);
	    this.alias = alias;
	    this.currentUser = currentUser;
	    this.traits = traits;
	    this.track = track;
	    this.parse();
	  }
	
	  QueryString.prototype.getCurrentUserId = function() {
	    return this.currentUser.get('id');
	  };
	
	  QueryString.prototype.parse = function() {
	    var attrs, hjs_aid, hjs_email, hjs_event, hjs_uid, props, q, traits;
	    q = qs.decode();
	    if (!_.size(q)) {
	      return;
	    }
	    hjs_email = q.hjs_email, hjs_uid = q.hjs_uid, hjs_event = q.hjs_event, hjs_aid = q.hjs_aid;
	    if (hjs_aid) {
	      this.alias(hjs_aid);
	    }
	    traits = pick('hjs_trait_', q);
	    if (_.size(traits)) {
	      this.traits(traits);
	    }
	    if (hjs_email) {
	      this.traits({
	        email: {
	          operation: "setIfNull",
	          value: hjs_email
	        }
	      });
	    }
	    attrs = pick('hjs_attr_', q);
	    if (_.size(attrs)) {
	      this.traits(attrs);
	    }
	    props = pick('hjs_prop_', q);
	    if (hjs_event) {
	      return this.tracker.track(hjs_event, props);
	    }
	  };
	
	  return QueryString;
	
	})();
	
	module.exports = QueryString;


/***/ }),
/* 148 */
/*!*********************************************!*\
  !*** ./src/client/script-tag-config.coffee ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, dasherize, getAttribute, getParamValue, httpsRegex, initParams, logger, origin, transform, valid;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	dasherize = function(str) {
	  return str.replace(/[A-Z]/, function(c) {
	    return "-" + c.toLowerCase();
	  });
	};
	
	origin = window.location.origin || window.location.protocol + "//" + window.location.hostname;
	
	if (window.location.port) {
	  origin += ':' + window.location.port;
	}
	
	httpsRegex = /^https:|^\/\//;
	
	valid = {
	  regex: function(reg) {
	    return function(val, key) {
	      var check;
	      check = reg.test(val);
	      if (!check) {
	        logger.error("[Hull.init] invalid format for '" + key + "'. Value '" + val + "' should match " + (reg.toString()));
	      }
	      return check;
	    };
	  },
	  https: function(val, key) {
	    var check;
	    check = httpsRegex.test(val);
	    if (check) {
	      return true;
	    }
	    logger.warn("[Hull.init] " + key + " should be loaded via https. Current value is ", val);
	    return true;
	  }
	};
	
	transform = {
	  url: function(url, key) {
	    var a;
	    if (url && url.length > 0) {
	      a = document.createElement('a');
	      a.href = url;
	      return a.href;
	    }
	  },
	  bool: function(str, key) {
	    switch (str) {
	      case 'true':
	      case true:
	        return true;
	      case 'false':
	      case false:
	        return false;
	      default:
	        return void 0;
	    }
	  }
	};
	
	initParams = {
	  appId: {
	    validation: valid.regex(/^[a-f0-9]{24}$/i),
	    required: true,
	    altKeys: ['shipId', 'platformId']
	  },
	  orgUrl: {
	    validation: valid.https,
	    required: true
	  },
	  jsUrl: {
	    transform: transform.url,
	    validation: valid.https,
	    altKeys: ['src']
	  },
	  callbackUrl: {
	    transform: transform.url,
	    validation: valid.regex(new RegExp("^" + origin + "/"))
	  },
	  debug: {
	    "default": false,
	    transform: transform.bool
	  },
	  verbose: {
	    "default": false,
	    transform: transform.bool
	  },
	  embed: {
	    "default": true,
	    transform: transform.bool
	  },
	  autoStart: {
	    "default": true,
	    transform: transform.bool
	  },
	  accessToken: {
	    "default": null
	  },
	  customerId: {
	    "default": null
	  },
	  anonymousId: {
	    "default": null
	  },
	  sessionId: {
	    "default": null
	  },
	  ravenDsn: {
	    "default": null
	  }
	};
	
	getAttribute = function(el, k) {
	  return el.getAttribute("data-" + dasherize(k)) || el.getAttribute("data-" + k) || el.getAttribute(dasherize(k)) || el.getAttribute(k);
	};
	
	getParamValue = function(el, param, key) {
	  var keys, value;
	  keys = [key].concat(param.altKeys || []);
	  transform = param.transform || function(o) {
	    return o;
	  };
	  value = _.reduce(keys, function(ret, k) {
	    if (ret === null) {
	      value = transform(getAttribute(el, k), key);
	      valid = (value != null) && (!param.validation || param.validation(value, k, el));
	      if (valid) {
	        ret = value;
	      }
	    }
	    return ret;
	  }, null);
	  if (value != null) {
	    return value;
	  } else {
	    return param["default"];
	  }
	};
	
	module.exports = function() {
	  var hull_js_sdk, out;
	  hull_js_sdk = document.getElementById('hull-js-sdk') || document.querySelector('[org-url][platform-id][data-org-url][data-platform-id]');
	  if (!hull_js_sdk) {
	    return;
	  }
	  out = _.reduce(initParams, function(config, param, key) {
	    var value;
	    if (!config) {
	      return;
	    }
	    value = getParamValue(hull_js_sdk, param, key);
	    if (value != null) {
	      config[key] = value;
	    } else if (param.required) {
	      config = false;
	    }
	    return config;
	  }, {});
	  if (out) {
	    if (httpsRegex.test(out.orgUrl) && !httpsRegex.test(out.jsUrl)) {
	      logger.error("[Hull.init] jsUrl NEEDS be loaded via https if orgUrl is https ");
	    }
	  }
	  return out;
	};


/***/ }),
/* 149 */
/*!****************************************!*\
  !*** ./src/client/sharer/index.coffee ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var EventBus, Promise, Sharer, _, assign, domWalker, findUrl, popup, qs,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	findUrl = __webpack_require__(/*! ../../utils/find-url */ 50);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	domWalker = __webpack_require__(/*! ../../utils/dom-walker */ 81);
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 5);
	
	qs = __webpack_require__(/*! ../../utils/query-string-encoder */ 20);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	popup = function(location, opts, params) {
	  var share;
	  if (opts == null) {
	    opts = {};
	  }
	  if (params == null) {
	    params = {};
	  }
	  if (location == null) {
	    return;
	  }
	  share = window.open(location + "?" + (qs.encode(params)), 'hull_share', "location=0,status=0,width=" + opts.width + ",height=" + opts.height);
	  return new Promise(function(resolve, reject) {
	    var interval;
	    return interval = setInterval(function() {
	      var e;
	      try {
	        if ((share == null) || share.closed) {
	          window.clearInterval(interval);
	          return resolve({});
	        }
	      } catch (error) {
	        e = error;
	        return reject(e);
	      }
	    }, 500);
	  });
	};
	
	Sharer = (function() {
	  function Sharer(currentConfig) {
	    this.share = bind(this.share, this);
	    this.currentConfig = currentConfig;
	  }
	
	  Sharer.prototype.share = function(opts, event) {
	    var params, popupUrl, provider, sharePromise;
	    if (event == null) {
	      event = {};
	    }
	    if (!_.isObject(opts)) {
	      throw new Error("You need to pass an options hash to the share method. You passed: " + (JSON.stringify(opts)));
	    } else if (opts.provider == null) {
	      throw new Error("You need specify the provider on which to share. You passed: " + opts.provider);
	    } else if (!_.isObject(opts.params)) {
	      opts.params = {};
	    }
	    opts.params || (opts.params = {});
	    opts.params.url = opts.params.url || opts.params.href;
	    if (!opts.params.url) {
	      opts.params.url = findUrl(event.target);
	      opts.params.title = opts.params.title || domWalker.getMetaValue('og:title') || document.title;
	    }
	    params = assign({
	      platform_id: this.currentConfig.get('appId')
	    }, opts.params);
	    provider = opts.provider;
	    popupUrl = this.currentConfig.get('orgUrl') + "/api/v1/intent/share/" + opts.provider;
	    sharePromise = popup(popupUrl, {
	      width: 550,
	      height: 420
	    }, params);
	    return sharePromise.then((function(_this) {
	      return function(response) {
	        var data;
	        data = assign({
	          url: opts.params.url
	        }, params, {
	          provider: provider
	        });
	        EventBus.emit("hull." + opts.provider + ".share", data);
	        return assign({}, data, {
	          response: response
	        });
	      };
	    })(this), function(err) {
	      throw err;
	    });
	  };
	
	  return Sharer;
	
	})();
	
	module.exports = Sharer;


/***/ }),
/* 150 */
/*!***************************************!*\
  !*** ./src/client/track/index.coffee ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	var EventBus, Tracker, _, assign, bnd, listen, prefix, serialize, unbnd,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	serialize = __webpack_require__(/*! ../../utils/form-serialize */ 131);
	
	bnd = window.addEventListener ? 'addEventListener' : 'attachEvent';
	
	unbnd = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
	
	prefix = bnd !== 'addEventListener' ? 'on' : '';
	
	listen = (function(_this) {
	  return function(el, type, fn, capture) {
	    return el[bnd](prefix + type, fn, capture || false);
	  };
	})(this);
	
	Tracker = (function() {
	  function Tracker(api, currentUser) {
	    this.track = bind(this.track, this);
	    this.trackForm = bind(this.trackForm, this);
	    this.api = api;
	    this.currentUser = currentUser;
	    this.setupTracking();
	  }
	
	  Tracker.prototype.getCurrentUserId = function() {
	    return this.currentUser.get('id');
	  };
	
	  Tracker.prototype.setupTracking = function() {
	    var self;
	    if (this.setup) {
	      return;
	    }
	    this.setup = true;
	    self = this;
	    EventBus.on('hull.*.share', function(res) {
	      return self.track(this.event, res);
	    });
	    EventBus.on('hull.user.create', function(me) {
	      var providers;
	      providers = _.map(me.identities, 'provider');
	      return self.track('hull.user.create', {
	        providers: providers,
	        main_identity: me.main_identity
	      });
	    });
	    EventBus.on('hull.user.update', function(me) {
	      return self.track('hull.user.update', {});
	    });
	    EventBus.on('hull.user.login', function(me, provider) {
	      var providers;
	      providers = _.map(me.identities, 'provider');
	      provider = provider || me.main_identity;
	      return self.track('hull.user.login', {
	        provider: provider,
	        providers: providers,
	        main_identity: me.main_identity
	      });
	    });
	    return EventBus.on('hull.user.logout', function() {
	      return self.track('hull.user.logout');
	    });
	  };
	
	  Tracker.prototype.trackForm = function(forms, eventName, properties, arg) {
	    var formsList, isDynamic, reSubmit, ref, ref1, ref2, ref3, ref4, stopPropagation, submitDelay, trackSubmit, useCapture;
	    ref = arg != null ? arg : {}, stopPropagation = (ref1 = ref.stopPropagation) != null ? ref1 : false, useCapture = (ref2 = ref.useCapture) != null ? ref2 : true, submitDelay = (ref3 = ref.submitDelay) != null ? ref3 : 2000, reSubmit = (ref4 = ref.reSubmit) != null ? ref4 : true;
	    if (!forms) {
	      return false;
	    }
	    isDynamic = _.isString(forms);
	    trackSubmit = (function(_this) {
	      return function(event) {
	        var evtPromise, nodes, propsPromise, submit, timeout;
	        nodes = Array.prototype.slice.call(document.querySelectorAll(forms));
	        if (nodes.indexOf(event.target) === -1) {
	          return;
	        }
	        event.preventDefault();
	        if (stopPropagation) {
	          event.stopPropagation();
	        }
	        evtPromise = _.isFunction(eventName) ? eventName(event.target, serialize(event.target, {
	          hash: true
	        }), event) : eventName;
	        propsPromise = (_.isFunction(properties) ? properties(event.target, serialize(event.target, {
	          hash: true
	        }), event) : properties) || serialize(event.target, {
	          hash: true
	        });
	        timeout = null;
	        submit = function(source) {
	          return function() {
	            var _isSubmitted;
	            console.log("Hull: Submitting Form from", source);
	            if (_isSubmitted) {
	              return;
	            }
	            clearTimeout(timeout);
	            _isSubmitted = true;
	            if (reSubmit) {
	              return event.target.submit();
	            }
	          };
	        };
	        return Promise.all([evtPromise, propsPromise]).then(function(argz) {
	          var _isSubmitted, evt, props;
	          evt = argz[0], props = argz[1];
	          _isSubmitted = false;
	          timeout = setTimeout(submit("Track Timeout"), submitDelay);
	          console.log("Hull: Submitting Form Data:", evt, props);
	          return _this.track(evt, props).then(submit("Track Success"), submit("Track Error"));
	        }, function(err) {
	          console.error("Hull: User Promise Error", err);
	          return submit("User Promise Error");
	        });
	      };
	    })(this);
	    if (isDynamic) {
	      listen(document.body, "submit", trackSubmit, useCapture);
	    } else {
	      if (_.isElement(forms)) {
	        formsList = [forms];
	      }
	      _.map(formsList, (function(_this) {
	        return function(form) {
	          var $;
	          if (!_.isElement(form)) {
	            return console.log("Not an HTML element", form);
	          }
	          $ = window.jQuery || window.Zepto;
	          if ($) {
	            return $(form).submit(trackSubmit);
	          } else {
	            return listen(form, 'submit', trackSubmit);
	          }
	        };
	      })(this));
	    }
	    return true;
	  };
	
	  Tracker.prototype.track = function(event, payload, success, failure) {
	    return this.api.message({
	      provider: 'track',
	      path: event
	    }, 'post', {
	      payload: payload,
	      url: document.location.href,
	      referer: document.referrer
	    });
	  };
	
	  return Tracker;
	
	})();
	
	module.exports = Tracker;


/***/ }),
/* 151 */
/*!****************************************!*\
  !*** ./src/client/traits/index.coffee ***!
  \****************************************/
/***/ (function(module, exports) {

	module.exports = function(api) {
	  return function(traits) {
	    Hull.emit('hull.traits', traits);
	    Hull.emit('hull.identify', traits);
	    return api.message('me/traits', 'put', traits);
	  };
	};


/***/ }),
/* 152 */
/*!********************************!*\
  !*** ./src/hull-remote.coffee ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Channel, ClientConfigStore, EventBus, Gateway, Hull, Raven, RemoteActions, RemoteConfigStore, RemoteConstants, RemoteHeaderStore, RemoteUserStore, Services, captureException, configNormalize, hull, locationOrigin, logger, qs;
	
	__webpack_require__(/*! ./utils/load-polyfills */ 84);
	
	Raven = __webpack_require__(/*! ./utils/raven */ 32);
	
	EventBus = __webpack_require__(/*! ./utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ./utils/logger */ 4);
	
	configNormalize = __webpack_require__(/*! ./utils/config-normalizer */ 160);
	
	locationOrigin = __webpack_require__(/*! ./utils/location-origin */ 164);
	
	qs = __webpack_require__(/*! ./utils/query-string-encoder */ 20);
	
	Services = __webpack_require__(/*! ./remote/services */ 155);
	
	Gateway = __webpack_require__(/*! ./remote/gateway */ 154);
	
	Channel = __webpack_require__(/*! ./remote/channel */ 153);
	
	ClientConfigStore = __webpack_require__(/*! ./flux/stores/ClientConfigStore */ 127);
	
	RemoteHeaderStore = __webpack_require__(/*! ./flux/stores/RemoteHeaderStore */ 49);
	
	RemoteUserStore = __webpack_require__(/*! ./flux/stores/RemoteUserStore */ 25);
	
	RemoteConfigStore = __webpack_require__(/*! ./flux/stores/RemoteConfigStore */ 30);
	
	RemoteActions = __webpack_require__(/*! ./flux/actions/RemoteActions */ 74);
	
	RemoteConstants = __webpack_require__(/*! ./flux/constants/RemoteConstants */ 14);
	
	captureException = function(err, ctx) {
	  return Raven.captureException(err, ctx);
	};
	
	hull = void 0;
	
	Hull = function(remoteConfig) {
	  var channel, config, gateway, hideOnClick, request, services, subscribeToEvents;
	  if (hull) {
	    return hull;
	  }
	  config = configNormalize(remoteConfig);
	  Raven.init(config.queryParams.ravenDsn, {
	    runtime: 'hull-remote',
	    orgUrl: locationOrigin(),
	    appId: config.appId
	  });
	  RemoteActions.updateRemoteConfig(config);
	  hull = {
	    config: config
	  };
	  gateway = new Gateway(config);
	  services = new Services(config, gateway);
	  channel = new Channel(config, services);
	  ClientConfigStore.addChangeListener((function(_this) {
	    return function(change) {
	      return logger.init((ClientConfigStore.getState() || {}).debug);
	    };
	  })(this));
	  RemoteConfigStore.addChangeListener((function(_this) {
	    return function(change) {
	      switch (change) {
	        case RemoteConstants.UPDATE_REMOTE_CONFIG:
	        case RemoteConstants.UPDATE_SETTINGS:
	          channel.rpc.configUpdate(RemoteConfigStore.getState());
	          break;
	      }
	    };
	  })(this));
	  RemoteUserStore.addChangeListener((function(_this) {
	    return function(change) {
	      switch (change) {
	        case RemoteConstants.UPDATE_USER:
	        case RemoteConstants.CLEAR_USER:
	          channel.rpc.userUpdate(RemoteUserStore.getState().user);
	          break;
	      }
	    };
	  })(this));
	  request = services.services.hull.request;
	  hideOnClick = function(e) {
	    return channel.rpc.hide();
	  };
	  subscribeToEvents = function(clientConfig) {
	    if (document.addEventListener) {
	      document.addEventListener('click', hideOnClick);
	    } else if (document.attachEvent) {
	      document.attachEvent('onclick', hideOnClick);
	    }
	    EventBus.on('remote.iframe.show', function() {
	      return channel.rpc.show();
	    });
	    EventBus.on('remote.iframe.hide', function() {
	      return channel.rpc.hide();
	    });
	    EventBus.on('remote.track', function(payload) {
	      return services.services.track.request({
	        params: payload.params,
	        path: payload.event
	      });
	    });
	    EventBus.on('remote.tracked', function(payload) {
	      return channel.rpc.track(payload);
	    });
	    return clientConfig;
	  };
	  return channel.promise.then(subscribeToEvents).then(function(clientConfig) {
	    return RemoteActions.updateClientConfig(clientConfig);
	  })["catch"](function(err) {
	    captureException(err);
	    return console.error("Could not initialize Hull: " + err.message);
	  });
	};
	
	Hull.version = ("0.11.0");
	
	module.exports = Hull;


/***/ }),
/* 153 */
/*!***********************************!*\
  !*** ./src/remote/channel.coffee ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Channel, Promise, catchAll, xdm;
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	xdm = __webpack_require__(/*! ../utils/xdm */ 77);
	
	catchAll = function(res) {
	  return res;
	};
	
	Channel = (function() {
	  function Channel(config, services) {
	    var domains, e, local, whitelisted;
	    this._ready = {};
	    this.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._ready.resolve = resolve;
	        return _this._ready.reject = reject;
	      };
	    })(this));
	    this.rpc = null;
	    try {
	      local = services.getMethods();
	      this.rpc = new xdm.Rpc({
	        acl: config.appDomains
	      }, {
	        remote: {
	          ready: {},
	          message: {},
	          userUpdate: {},
	          configUpdate: {},
	          getClientConfig: {},
	          track: {},
	          show: {},
	          hide: {}
	        },
	        local: local
	      });
	      this.rpc.ready(config);
	      this.rpc.getClientConfig(this._ready.resolve);
	    } catch (error) {
	      e = error;
	      try {
	        domains = (config.appDomains || []).toString();
	        whitelisted = domains.replace(/\(\:\[0-9\]\+\)\?\$/g, '').replace(/\^\(https\?\:\/\/\)\?/g, '').replace(/\\/g, '');
	        e = new Error(e.message + ", You should whitelist this domain. The following domains are authorized : \n" + whitelisted);
	        this._ready.reject(e);
	        this.rpc = new xdm.Rpc({}, {
	          local: {},
	          remote: {
	            loadError: {}
	          }
	        });
	        this.rpc.loadError(e.message);
	      } catch (error) {
	        e = error;
	        throw new Error("Unable to establish communication between Hull Remote and your page. " + e.message);
	      }
	    }
	  }
	
	  return Channel;
	
	})();
	
	module.exports = Channel;


/***/ }),
/* 154 */
/*!***********************************!*\
  !*** ./src/remote/gateway.coffee ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var API_PATH, API_PATH_REGEXP, Base64, EventBus, Gateway, Promise, QSEncoder, RESPONSE_HEADERS, RemoteHeaderStore, TRACKING_PATHS, _, assign, batchable, clone, cookies, logger, normalizePath, reduceHeaders, resolveResponse, superagent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 31);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 15);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	clone = __webpack_require__(/*! ../utils/clone */ 11);
	
	RemoteHeaderStore = __webpack_require__(/*! ../flux/stores/RemoteHeaderStore */ 49);
	
	QSEncoder = __webpack_require__(/*! ../utils/query-string-encoder */ 20);
	
	superagent = __webpack_require__(/*! superagent */ 47);
	
	API_PATH = '/api/v1/';
	
	API_PATH_REGEXP = /^\/?api\/v1\//;
	
	RESPONSE_HEADERS = ['Hull-Auth-Scope', 'Hull-Track', 'Hull-User-Id', 'Hull-User-Sig', 'X-Hits-Count', 'Link'];
	
	TRACKING_PATHS = ["/api/v1/t", "/api/v1/me/traits", "/api/v1/me/alias"];
	
	normalizePath = function(path) {
	  if (API_PATH_REGEXP.test(path)) {
	    return path.replace(API_PATH_REGEXP, API_PATH);
	  }
	  if (path[0] === '/') {
	    path = path.substring(1);
	  }
	  return API_PATH + path;
	};
	
	batchable = function(threshold, callback) {
	  var args, timeout;
	  timeout = null;
	  args = [];
	  return function() {
	    var delayed;
	    args.push(Array.prototype.slice.call(arguments));
	    clearTimeout(timeout);
	    delayed = (function(_this) {
	      return function() {
	        callback.call(_this, args);
	        timeout = null;
	        return args = [];
	      };
	    })(this);
	    return timeout = setTimeout(delayed, threshold);
	  };
	};
	
	reduceHeaders = function(headers) {
	  var _headers;
	  _headers = _.reduce(headers, function(memo, value, key) {
	    memo[key.toLowerCase()] = value;
	    return memo;
	  }, {});
	  return _.reduce(RESPONSE_HEADERS, function(memo, name) {
	    var value;
	    value = _headers[name.toLowerCase()];
	    if (value != null) {
	      memo[name] = value;
	    }
	    return memo;
	  }, {});
	};
	
	resolveResponse = function(request, response, resolve, reject) {
	  var h, headers;
	  if (response == null) {
	    response = {};
	  }
	  headers = reduceHeaders(response.headers);
	  h = {
	    body: response.body,
	    status: response.status,
	    headers: headers,
	    request: request
	  };
	  return resolve(h);
	};
	
	Gateway = (function() {
	  function Gateway(config) {
	    if (config == null) {
	      config = {};
	    }
	    this.before = bind(this.before, this);
	    this.after = bind(this.after, this);
	    this.fetch = bind(this.fetch, this);
	    this.apiEndpoint = config.apiEndpoint;
	    this.trackingEndpoint = config.trackingEndpoint;
	    this.identify = config.identify;
	    this.queue = batchable(10, function(requests) {
	      return this.flush(requests);
	    });
	  }
	
	  Gateway.prototype.identifyBrowserAndSession = function() {
	    var ident;
	    ident = {};
	    ident['Hull-Bid'] = this.identify.browser;
	    ident['Hull-Sid'] = this.identify.session;
	    return ident;
	  };
	
	  Gateway.prototype.resetIdentify = function() {
	    return this.identify = {};
	  };
	
	  Gateway.prototype.fetch = function(options) {
	    var endpoint, headers, method, params, path, s;
	    if (options == null) {
	      options = {};
	    }
	    method = options.method, headers = options.headers, path = options.path, params = options.params;
	    method = (method || 'get').toUpperCase();
	    headers = assign(this.identifyBrowserAndSession(), RemoteHeaderStore.getState(), headers);
	    if (this.trackingEndpoint && TRACKING_PATHS.includes(path)) {
	      endpoint = [this.trackingEndpoint, path].join('');
	    } else if (this.apiEndpoint) {
	      endpoint = [this.apiEndpoint, path].join('');
	    } else {
	      endpoint = path;
	    }
	    s = superagent(method, endpoint).set(headers);
	    if ((params != null) && method === 'GET') {
	      s.query(QSEncoder.encode(params));
	    } else {
	      s.send(params);
	    }
	    return new Promise(function(resolve, reject) {
	      logger.verbose(">", method, path, params, headers);
	      return s.end((function(_this) {
	        return function(err, response) {
	          var h;
	          if (response == null) {
	            response = {};
	          }
	          logger.verbose("<", method, path, response);
	          h = {
	            body: response.body,
	            headers: response.headers,
	            status: response.status
	          };
	          return resolve(h);
	        };
	      })(this));
	    });
	  };
	
	  Gateway.prototype.flush = function(requests) {
	    var ref, reject, request, resolve, results;
	    results = [];
	    while (requests.length) {
	      ref = requests.pop(), request = ref[0], resolve = ref[1], reject = ref[2];
	      results.push(this.handleOne(request, resolve, reject));
	    }
	    return results;
	  };
	
	  Gateway.prototype.after_middlewares = [];
	
	  Gateway.prototype.before_middlewares = [];
	
	  Gateway.prototype.after = function(cb) {
	    if (!((cb != null) && _.isFunction(cb))) {
	      return;
	    }
	    this.after_middlewares.push(cb);
	    return cb;
	  };
	
	  Gateway.prototype.before = function(cb) {
	    if (!((cb != null) && _.isFunction(cb))) {
	      return;
	    }
	    this.before_middlewares.push(cb);
	    return cb;
	  };
	
	  Gateway.prototype.handle = function(request) {
	    var promise;
	    request.path = normalizePath(request.path);
	    promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _.each(_this.before_middlewares, function(middleware) {
	          return middleware(request);
	        });
	        return _this.queue(request, resolve, reject);
	      };
	    })(this));
	    if (!request.nocallback) {
	      _.each(this.after_middlewares, function(middleware) {
	        return promise = promise.then(middleware);
	      });
	    }
	    return promise["catch"](function(err) {
	      throw err;
	    });
	  };
	
	  Gateway.prototype.handleOne = function(request, resolve, reject) {
	    var error, success;
	    success = function(response) {
	      return resolveResponse(request, response, resolve, reject);
	    };
	    error = function(error) {
	      var response;
	      response = error.body;
	      return reject({
	        response: response,
	        request: request,
	        headers: {}
	      });
	    };
	    return this.fetch(request).then(success, error);
	  };
	
	  return Gateway;
	
	})();
	
	module.exports = Gateway;


/***/ }),
/* 155 */
/*!************************************!*\
  !*** ./src/remote/services.coffee ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Promise, RemoteActions, RemoteConfigStore, RemoteConstants, RemoteHeaderStore, RemoteUserStore, ServiceList, Services, _, assign, cookies, handleSpecialRoutes, logger, maybeUpdateUser,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 4);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 5);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 3);
	
	ServiceList = __webpack_require__(/*! ./services/list */ 158);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 31);
	
	RemoteHeaderStore = __webpack_require__(/*! ../flux/stores/RemoteHeaderStore */ 49);
	
	RemoteUserStore = __webpack_require__(/*! ../flux/stores/RemoteUserStore */ 25);
	
	RemoteConfigStore = __webpack_require__(/*! ../flux/stores/RemoteConfigStore */ 30);
	
	RemoteActions = __webpack_require__(/*! ../flux/actions/RemoteActions */ 74);
	
	RemoteConstants = __webpack_require__(/*! ../flux/constants/RemoteConstants */ 14);
	
	handleSpecialRoutes = function(request) {
	  switch (request.path) {
	    case '/api/v1/logout':
	      request.nocallback = true;
	      RemoteActions.logoutUser();
	      break;
	  }
	  return request;
	};
	
	maybeUpdateUser = function(response) {
	  RemoteActions.updateUserIfMe(response);
	  return response;
	};
	
	Services = (function() {
	  function Services(remoteConfig, gateway) {
	    this.onMessage = bind(this.onMessage, this);
	    this.handleAdminCall = bind(this.handleAdminCall, this);
	    this.onRefreshUser = bind(this.onRefreshUser, this);
	    this.onResetIdentify = bind(this.onResetIdentify, this);
	    if (remoteConfig.data.me) {
	      RemoteActions.updateUser(remoteConfig.data.me);
	    }
	    this.gateway = gateway;
	    gateway.before(handleSpecialRoutes);
	    gateway.after(maybeUpdateUser);
	    this.services = _.reduce(ServiceList, function(memo, Service, key) {
	      memo[key] = new Service(remoteConfig, gateway);
	      return memo;
	    }, {});
	    RemoteHeaderStore.addChangeListener((function(_this) {
	      return function(change) {
	        var user, userHeaderId;
	        switch (change) {
	          case RemoteConstants.UPDATE_USER:
	            userHeaderId = RemoteHeaderStore.getHeader('Hull-User-Id');
	            user = RemoteUserStore.getState().user;
	            if (userHeaderId !== (user != null ? user.id : void 0)) {
	              _this.onRefreshUser();
	            }
	            break;
	        }
	      };
	    })(this));
	  }
	
	  Services.prototype.getMethods = function() {
	    return {
	      ready: this.onReady,
	      message: this.onMessage,
	      refreshUser: this.onRefreshUser,
	      resetIdentify: this.onResetIdentify
	    };
	  };
	
	  Services.prototype.onResetIdentify = function(xdmCallback, xdmErrback) {
	    cookies.remove('_bid', {
	      path: '/',
	      domain: document.location.host
	    });
	    cookies.remove('_sid', {
	      path: '/',
	      domain: document.location.host
	    });
	    return this.gateway.resetIdentify();
	  };
	
	  Services.prototype.onReady = function(req, xdmCallback, xdmErrback) {};
	
	  Services.prototype.onRefreshUser = function(xdmCallback, xdmErrback) {
	    var me, onError, onSuccess, settings;
	    if (xdmCallback == null) {
	      xdmCallback = function() {};
	    }
	    if (xdmErrback == null) {
	      xdmErrback = function() {};
	    }
	    me = this.services.hull.request({
	      path: 'me',
	      nocallback: true
	    });
	    settings = this.services.hull.request({
	      path: 'app/settings',
	      nocallback: true
	    });
	    onSuccess = (function(_this) {
	      return function(res) {
	        var services;
	        me = res[0].body;
	        services = res[1].body;
	        RemoteActions.updateUser(me, {
	          silent: true
	        });
	        RemoteActions.updateServices(services, {
	          silent: true
	        });
	        xdmCallback({
	          me: me,
	          services: services,
	          headers: res[0].headers
	        });
	        return void 0;
	      };
	    })(this);
	    onError = function(res) {
	      var error, ref;
	      if (res == null) {
	        res = {};
	      }
	      xdmErrback(res.response || res);
	      error = new Error((res != null ? (ref = res.response) != null ? ref.message : void 0 : void 0) || (res != null ? res.response : void 0) || res);
	      logger.error('Failed refreshing User', error.message, error.stack);
	      throw error;
	    };
	    Promise.all([me, settings]).then(onSuccess, onError);
	    return void 0;
	  };
	
	  Services.prototype.handleAdminCall = function(request, callback, errback) {};
	
	  Services.prototype.onMessage = function(request, xdmCallback, xdmErrback) {
	    var service;
	    if (xdmCallback == null) {
	      xdmCallback = function() {};
	    }
	    if (xdmErrback == null) {
	      xdmErrback = function() {};
	    }
	    if (!request.path) {
	      throw new Error("Path not recognized " + (JSON.stringify(request, null, 2)));
	    }
	    service = this.services[request.provider];
	    if (_.isFunction(service.request)) {
	      service.request(request, xdmCallback, xdmErrback);
	      return void 0;
	    } else {
	      xdmErrback(request);
	    }
	    return void 0;
	  };
	
	  return Services;
	
	})();
	
	module.exports = Services;


/***/ }),
/* 156 */
/*!******************************************!*\
  !*** ./src/remote/services/admin.coffee ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var GenericService, HullAdminService, QSEncoder, RemoteConfigStore, logger, superagent,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	superagent = __webpack_require__(/*! superagent */ 47);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 80);
	
	QSEncoder = __webpack_require__(/*! ../../utils/query-string-encoder */ 20);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 4);
	
	RemoteConfigStore = __webpack_require__(/*! ../../flux/stores/RemoteConfigStore */ 30);
	
	HullAdminService = (function(superClass) {
	  extend(HullAdminService, superClass);
	
	  HullAdminService.prototype.name = 'hull';
	
	  function HullAdminService(config, gateway) {}
	
	  HullAdminService.prototype.request = function(request, callback, errback) {
	    var headers, method, organization, params, path, protocol, s, token, top_domain, url;
	    method = request.method, path = request.path, params = request.params, organization = request.organization;
	    if (organization == null) {
	      throw new Error('No organization defined');
	    }
	    method = method.toUpperCase();
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    top_domain = document.location.host.split('.');
	    top_domain.shift();
	    top_domain = top_domain.join('.');
	    protocol = document.location.protocol;
	    url = protocol + "//" + organization + "." + top_domain + "/api/v1/" + path;
	    headers = {};
	    token = RemoteConfigStore.getHullToken();
	    if (token) {
	      headers['AccessToken'] = token;
	    }
	    s = superagent(method, url).set(headers);
	    if (method === 'GET' && (params != null)) {
	      s.query(QSEncoder.encode(params));
	    } else {
	      s.send(params);
	    }
	    return s.end(function(err, response) {
	      if (response == null) {
	        response = {};
	      }
	      if (err || response.error) {
	        return errback(response.body, response.error);
	      }
	      return callback({
	        provider: 'admin',
	        body: response.body
	      });
	    });
	  };
	
	  return HullAdminService;
	
	})(GenericService);
	
	module.exports = HullAdminService;


/***/ }),
/* 157 */
/*!*****************************************!*\
  !*** ./src/remote/services/hull.coffee ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64, EventBus, HullService, Promise, RECAPTCHA_ONLOAD, RECAPTCHA_SRC, TrackEventMatcher, _, _loadRecaptchaScriptPromise, addEvent, assign, displayBanner, getWrappedRequest, loadRecaptchaScript, ref, removeBanner, removeEvent, scriptLoader, stopEventPropagation, trackResponse,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 5);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	Base64 = __webpack_require__(/*! ../../utils/base64 */ 15);
	
	getWrappedRequest = __webpack_require__(/*! ../wrapped-request */ 75);
	
	scriptLoader = __webpack_require__(/*! ../../utils/script-loader */ 51);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	displayBanner = __webpack_require__(/*! ../../utils/ui/display-banner */ 85);
	
	ref = __webpack_require__(/*! ../../utils/dom-events */ 129), addEvent = ref.addEvent, removeEvent = ref.removeEvent;
	
	RECAPTCHA_ONLOAD = '___recaptcha___';
	
	RECAPTCHA_SRC = "https://www.google.com/recaptcha/api.js?onload=" + RECAPTCHA_ONLOAD + "&render=explicit";
	
	_loadRecaptchaScriptPromise = null;
	
	loadRecaptchaScript = function() {
	  if ((_loadRecaptchaScriptPromise != null)) {
	    return _loadRecaptchaScriptPromise;
	  }
	  _loadRecaptchaScriptPromise = new Promise(function(resolve) {
	    window[RECAPTCHA_ONLOAD] = resolve;
	    scriptLoader({
	      src: RECAPTCHA_SRC
	    });
	    return null;
	  });
	  return _loadRecaptchaScriptPromise;
	};
	
	TrackEventMatcher = (function() {
	  function TrackEventMatcher(config) {
	    if (config === false || ((config != null ? config.ignore : void 0) != null)) {
	      this.mode = 'ignore';
	      this._initMatchers(config.ignore);
	    } else if (config == null) {
	      this.mode = 'match_all';
	    } else {
	      this.mode = 'match';
	      this._initMatchers((config != null ? config.only : void 0) || config);
	    }
	  }
	
	  TrackEventMatcher.prototype._initMatchers = function(m) {
	    if (_.isString(m)) {
	      m = [m];
	    }
	    return this.matchers = _.map(_.compact(m), function(c) {
	      var _c;
	      _c = c.toString();
	      if (/^\/.*\/$/.test(_c)) {
	        return new RegExp(_c.slice(1, -1));
	      } else {
	        return _c;
	      }
	    });
	  };
	
	  TrackEventMatcher.prototype.isTracked = function(event) {
	    var ret;
	    if (event == null) {
	      return false;
	    }
	    if (this.mode === 'match_all') {
	      return true;
	    }
	    ret = _.some(_.map(this.matchers, function(m) {
	      if (_.isFunction(m.test)) {
	        return m.test(event);
	      } else {
	        return m === event;
	      }
	    }));
	    if (this.mode === 'ignore') {
	      return !ret;
	    } else {
	      return ret;
	    }
	  };
	
	  return TrackEventMatcher;
	
	})();
	
	trackResponse = (function(_this) {
	  return function(response) {
	    var error, eventName, payload, ref1, ref2, track;
	    if (response == null) {
	      response = {};
	    }
	    if (track = (ref1 = response.headers) != null ? ref1['Hull-Track'] : void 0) {
	      try {
	        ref2 = JSON.parse(Base64.decode(track)), eventName = ref2[0], payload = ref2[1];
	        EventBus.emit('remote.track', {
	          event: eventName,
	          params: {
	            payload: payload,
	            url: document.referrer
	          }
	        });
	      } catch (error1) {
	        error = error1;
	        "Invalid Tracking header : ${JSON.stringify(errror,null,2)}";
	      }
	    }
	    return response;
	  };
	})(this);
	
	stopEventPropagation = function(e) {
	  return e.stopPropagation();
	};
	
	removeBanner = function(banner) {
	  removeEvent(banner, 'click', stopEventPropagation);
	  return banner.remove();
	};
	
	HullService = (function() {
	  function HullService(config, gateway) {
	    this.ensureIsHuman = bind(this.ensureIsHuman, this);
	    var middlewares;
	    this.config = config;
	    middlewares = [this.ensureIsHuman, trackResponse];
	    this.request = getWrappedRequest({
	      name: 'hull',
	      path: null
	    }, gateway, middlewares);
	    this.trackMatcher = new TrackEventMatcher(config.track);
	  }
	
	  HullService.prototype.ensureIsHuman = function(response) {
	    var banner, performRequest, ref1, sitekey, stoken;
	    if (response.body == null) {
	      return response;
	    }
	    ref1 = response.body, sitekey = ref1.sitekey, stoken = ref1.stoken;
	    if (response.status !== 429 || (sitekey == null) || (stoken == null)) {
	      return response;
	    }
	    banner = this._getCaptchaBanner();
	    performRequest = this.request;
	    return new Promise(function(resolve, reject) {
	      return loadRecaptchaScript().then(function() {
	        grecaptcha.render(banner.querySelector('.hull-captcha-container'), {
	          sitekey: sitekey,
	          stoken: stoken,
	          callback: function(captchaResponse) {
	            var requestWithCaptcha;
	            EventBus.emit('remote.iframe.hide');
	            removeBanner(banner);
	            requestWithCaptcha = assign({}, response.request, {
	              headers: assign({}, response.request.headers, {
	                'X-Captcha-Response': captchaResponse
	              })
	            });
	            return performRequest(requestWithCaptcha).then(resolve, reject);
	          }
	        });
	        document.body.appendChild(banner);
	        return EventBus.emit('remote.iframe.show');
	      });
	    });
	  };
	
	  HullService.prototype._getCaptchaBanner = function() {
	    if (this._banner) {
	      removeBanner(this._banner);
	    }
	    this._banner = displayBanner('captcha', false);
	    addEvent(this._banner, 'click', stopEventPropagation);
	    return this._banner;
	  };
	
	  return HullService;
	
	})();
	
	module.exports = HullService;


/***/ }),
/* 158 */
/*!*****************************************!*\
  !*** ./src/remote/services/list.coffee ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  admin: __webpack_require__(/*! ./admin */ 156),
	  track: __webpack_require__(/*! ./track */ 159),
	  hull: __webpack_require__(/*! ./hull */ 157)
	};


/***/ }),
/* 159 */
/*!******************************************!*\
  !*** ./src/remote/services/track.coffee ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64, EventBus, GenericService, HullTrackService, Identity, LeakyBucket, MarketingProps, RemoteUserStore, StructuredEventProps, TopLevelProps, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	LeakyBucket = __webpack_require__(/*! ../../utils/leaky-bucket */ 133);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 3);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	RemoteUserStore = __webpack_require__(/*! ../../flux/stores/RemoteUserStore */ 25);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 80);
	
	Base64 = __webpack_require__(/*! ../../utils/base64 */ 15);
	
	StructuredEventProps = ['category', 'action', 'label', 'property', 'value'];
	
	MarketingProps = ['campaign', 'source', 'medium', 'term', 'content'];
	
	TopLevelProps = ['hull_ship_id'].concat(StructuredEventProps);
	
	Identity = function(o) {
	  return o;
	};
	
	HullTrackService = (function(superClass) {
	  extend(HullTrackService, superClass);
	
	  HullTrackService.prototype.name = 'hull';
	
	  function HullTrackService(config, gateway) {
	    this._sendRequest = bind(this._sendRequest, this);
	    this.request = bind(this.request, this);
	    HullTrackService.__super__.constructor.call(this, config, gateway);
	    this._request = this.wrappedRequest;
	    if (config.trackRateLimit && config.trackRateLimit.capacity) {
	      this.rateLimitter = new LeakyBucket(config.trackRateLimit);
	    } else {
	      this.rateLimitter = false;
	    }
	    RemoteUserStore.addChangeListener((function(_this) {
	      return function(change) {
	        var currentUser, currentUserId;
	        currentUser = RemoteUserStore.getState().user;
	        return currentUserId = currentUser != null ? currentUser.id : void 0;
	      };
	    })(this));
	  }
	
	  HullTrackService.prototype.request = function(opts, callback, errback) {
	    if (this.rateLimitter) {
	      return this.rateLimitter.throttle().then((function(_this) {
	        return function() {
	          return _this._sendRequest(opts, callback, errback);
	        };
	      })(this));
	    } else {
	      return this._sendRequest(opts, callback, errback);
	    }
	  };
	
	  HullTrackService.prototype._sendRequest = function(opts, callback, errback) {
	    var event, params, path;
	    params = opts.params, path = opts.path;
	    event = path;
	    EventBus.emit('remote.tracked', {
	      event: event,
	      params: params.payload
	    });
	    return this._request({
	      path: 't',
	      method: 'post',
	      params: {
	        event: event,
	        properties: params.payload,
	        url: params.url,
	        referer: params.referer || ""
	      },
	      nocallback: true
	    }).then((function(_this) {
	      return function(response) {
	        response.provider = 'track';
	        return response;
	      };
	    })(this)).then(callback || Identity, errback || Identity);
	  };
	
	  return HullTrackService;
	
	})(GenericService);
	
	module.exports = HullTrackService;


/***/ }),
/* 160 */
/*!********************************************!*\
  !*** ./src/utils/config-normalizer.coffee ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, applyUserCredentials, clone, cookies, flattenSettings, qs, sortServicesByType;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../utils/clone */ 11);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 31);
	
	qs = __webpack_require__(/*! ../utils/query-string-encoder */ 20);
	
	flattenSettings = function(settings, name) {
	  var nameArray;
	  nameArray = name.split('_');
	  if (nameArray.length > 1) {
	    nameArray.pop();
	  }
	  return [nameArray.join('_'), settings[name] || {}];
	};
	
	applyUserCredentials = function(config, creds) {
	  if (creds == null) {
	    creds = {};
	  }
	  _.each(creds, function(c, k) {
	    if (!_.keys(c).length) {
	      return;
	    }
	    if (config != null) {
	      if (config[k] == null) {
	        config[k] = {};
	      }
	    }
	    return config != null ? config[k].credentials = c : void 0;
	  });
	  return config;
	};
	
	sortServicesByType = function(settings, types) {
	  var ret;
	  ret = _.map(types, function(names, type) {
	    var typeSettings;
	    typeSettings = _.fromPairs(_.map(names, function(name) {
	      return flattenSettings(settings, name);
	    }));
	    return [type, typeSettings];
	  });
	  return _.fromPairs(ret);
	};
	
	module.exports = function(_config) {
	  var config, services;
	  if (_config == null) {
	    _config = {};
	  }
	  config = clone(_config);
	  if (config.debug == null) {
	    config.debug = false;
	  }
	  services = sortServicesByType(config.services.settings, config.services.types);
	  if (services.auth == null) {
	    services.auth = {};
	  }
	  services.auth = applyUserCredentials(services.auth, config.data.credentials);
	  config.services = services;
	  config.cookiesEnabled = cookies.enabled();
	  config.queryParams = qs.decode() || {};
	  return config;
	};


/***/ }),
/* 161 */
/*!***************************************!*\
  !*** ./src/utils/console-shim.coffee ***!
  \***************************************/
/***/ (function(module, exports) {

	var log, methods,
	  slice = [].slice;
	
	methods = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "markTimeline", "table", "time", "timeEnd", "timeStamp", "trace", "warn"];
	
	if (!(window.console && console.log)) {
	  (function() {
	    var console, i, len, method, noop, results;
	    noop = function() {};
	    console = window.console = {};
	    results = [];
	    for (i = 0, len = methods.length; i < len; i++) {
	      method = methods[i];
	      results.push(console[method] = noop);
	    }
	    return results;
	  })();
	} else if (typeof console.log === 'object') {
	  log = console.log;
	  console.log = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return log(args);
	  };
	}


/***/ }),
/* 162 */
/*!**************************************!*\
  !*** ./src/utils/decode-hash.coffee ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64;
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 15);
	
	module.exports = function() {
	  var e, h, hash;
	  try {
	    h = document.location.hash.replace('#', '');
	    if (!!h) {
	      hash = JSON.parse(Base64.decode(h));
	    }
	  } catch (error) {
	    e = error;
	    hash = null;
	  }
	  return hash;
	};


/***/ }),
/* 163 */
/*!*********************************!*\
  !*** ./src/utils/entity.coffee ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Base64;
	
	Base64 = __webpack_require__(/*! ./base64.js */ 15);
	
	module.exports = {
	  decode: function(input) {
	    if (!/^~[a-z0-9_\-\+\/\=]+$/i.test(input)) {
	      throw "'" + input + "' cannot be decoded because it has not been correctly encoded";
	    }
	    return Base64.decodeURL(input.substr(1));
	  },
	  encode: function(input) {
	    return "~" + (Base64.encodeURL(input));
	  }
	};


/***/ }),
/* 164 */
/*!******************************************!*\
  !*** ./src/utils/location-origin.coffee ***!
  \******************************************/
/***/ (function(module, exports) {

	module.exports = function() {
	  var origin, port;
	  if (window.location.origin) {
	    return window.location.origin;
	  }
	  port = '';
	  if (window.location.port) {
	    port = ':' + window.location.port;
	  }
	  origin = window.location.protocol + "//" + window.location.hostname + port;
	  return origin;
	};


/***/ }),
/* 165 */
/*!*******************************!*\
  !*** ./src/utils/pool.coffee ***!
  \*******************************/
/***/ (function(module, exports) {

	var _pool, createPool, deletePool, run,
	  slice = [].slice;
	
	_pool = _pool || {};
	
	createPool = function(name) {
	  if (_pool[name] == null) {
	    _pool[name] = [];
	  }
	  return function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return _pool[name].push(args);
	  };
	};
	
	deletePool = function(name) {
	  return delete _pool[name];
	};
	
	run = function(name, obj) {
	  var data, i, len, ref;
	  ref = _pool[name];
	  for (i = 0, len = ref.length; i < len; i++) {
	    data = ref[i];
	    obj[name].apply(obj, data);
	  }
	  return deletePool(name);
	};
	
	module.exports = {
	  create: createPool,
	  "delete": deletePool,
	  run: run
	};


/***/ }),
/* 166 */
/*!************************************!*\
  !*** ./src/utils/set-style.coffee ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var _, getDocHeight, setDimension;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	getDocHeight = function(doc) {
	  var body, html;
	  if (!doc) {
	    return;
	  }
	  body = doc.body;
	  html = doc.documentElement;
	  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	};
	
	setDimension = function(el, dim, val) {
	  if (val != null) {
	    if (/[0-9]+$/.test(val.toString())) {
	      val = val + "px";
	    }
	    return el.style[dim] = val;
	  }
	};
	
	module.exports = function(el, style) {
	  if (!_.isObject(style)) {
	    return;
	  }
	  return _.map(style, function(value, key) {
	    return setDimension(el, key, value);
	  });
	};


/***/ }),
/* 167 */
/*!**************************************!*\
  !*** ./~/component-emitter/index.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 168 */
/*!********************************************************!*\
  !*** ./~/currentscript/dist/document.currentScript.js ***!
  \********************************************************/
/***/ (function(module, exports) {

	/*!
	 * document.currentScript
	 * Polyfill for `document.currentScript`.
	 * Copyright (c) 2016 James M. Greene
	 * Licensed MIT
	 * https://github.com/JamesMGreene/document.currentScript
	 * v1.1.0
	 */
	(function() {
	
	
	// Live NodeList collection
	var scripts = document.getElementsByTagName("script");
	
	// Check if the browser supports the `readyState` property on `script` elements
	var supportsScriptReadyState = "readyState" in (scripts[0] || document.createElement("script"));
	
	// Lousy browser detection for [not] Opera
	var isNotOpera = !window.opera || window.opera.toString() !== "[object Opera]";
	
	// Guaranteed accurate in IE 6-10.
	// Not supported in any other browsers. =(
	var canPolyfill = supportsScriptReadyState && isNotOpera;
	
	
	// Attempt to retrieve the native `document.currentScript` accessor method
	var nativeCurrentScriptFn = (function(doc) {
	  /*jshint proto:true */
	
	  var hasNativeMethod = "currentScript" in doc;
	  var canGetDescriptor = typeof Object.getOwnPropertyDescriptor === "function";
	  var canGetPrototype = typeof Object.getPrototypeOf === "function";
	  var canUseDunderProto = typeof "test".__proto__ === "object";
	
	
	  function _invokeNativeCurrentScriptMethod() {
	    var des,
	        csFnIsNotOurs = true;
	
	    if (canGetDescriptor) {
	      des = Object.getOwnPropertyDescriptor(doc, "currentScript") || undefined;
	      if (des && typeof des.get === "function" && des.get === _currentEvaluatingScript) {
	        csFnIsNotOurs = false;
	      }
	    }
	
	    // Potentially dangerous hack...
	    return csFnIsNotOurs ? doc.currentScript : null;
	  }
	
	  function _getProto(obj) {
	    var proto;
	    if (obj != null) {
	      proto = (
	        canGetPrototype ? Object.getPrototypeOf(obj) :
	          canUseDunderProto ? obj.__proto__ :
	            obj.constructor != null ? obj.constructor.prototype :
	              undefined
	      );
	    }
	    return proto;
	  }
	
	  var nativeFn = (function _getCurrentScriptDef(docSelfOrAncestor, doc) {
	    var des, cs;
	
	    if (
	      hasNativeMethod && canGetDescriptor &&
	      docSelfOrAncestor && docSelfOrAncestor !== Object.prototype &&
	      doc && doc !== Object.prototype
	    ) {
	      if (canGetDescriptor) {
	        des = Object.getOwnPropertyDescriptor(docSelfOrAncestor, "currentScript") || undefined;
	        if (des && typeof des.get === "function") {
	          cs = des.get;
	        }
	      }
	      if (!cs) {
	        cs = _getCurrentScriptDef(_getProto(docSelfOrAncestor), doc);
	      }
	    }
	
	    if (!cs) {
	      cs = _invokeNativeCurrentScriptMethod;
	    }
	    else if (cs === _currentEvaluatingScript) {
	      cs = undefined;
	    }
	
	    return cs;
	  })(doc, doc);
	
	  return nativeFn;
	})(document);
	
	
	
	// Top-level API (compliant with `document.currentScript` specifications)
	//
	// Get the currently "executing" (i.e. EVALUATING) `script` DOM
	// element, per the spec requirements for `document.currentScript`.
	//
	// IMPORTANT: This polyfill CANNOT achieve 100% accurate results
	//            cross-browser. ;_;
	function _currentEvaluatingScript() {
	  // Yes, this IS possible, i.e. if a script removes other scripts (or itself)
	  if (scripts.length === 0) {
	    return null;
	  }
	
	  // Guaranteed accurate in IE 6-10.
	  // Not supported in any other browsers. =(
	  if (canPolyfill) {
	    for (var i = scripts.length; i--; ) {
	      if (scripts[i] && scripts[i].readyState === "interactive") {
	        return scripts[i];
	      }
	    }
	  }
	
	  // If the native method exists, defer to that as a last-ditch effort
	  if (
	    typeof nativeCurrentScriptFn === "function" &&
	    _currentEvaluatingScript.doNotDeferToNativeMethod !== true
	  ) {
	    return nativeCurrentScriptFn.call(document) || null;
	  }
	
	  // Any other attempts cannot be guaranteed and, as such, should be left out
	  // from this "Strict Mode" behavior.
	  // Alas, returning `null` here is not necessarily accurate either.
	  // We could return `undefined` instead but that would not comply with the spec
	  // in cases where it should correctly be returning `null`.
	  return null;
	}
	
	// Allow a last-ditch effort to use the native `document.currentScript` accessor
	// method (if it exists and can be retrieved)?
	_currentEvaluatingScript.doNotDeferToNativeMethod = false;
	
	
	
	// Inspect the polyfill-ability of this browser
	var needsPolyfill = !("currentScript" in document);
	var canDefineProp = typeof Object.defineProperty === "function" &&
	  (function() {
	    var result;
	    try {
	      Object.defineProperty(document, "_xyz", {
	        get: function() {
	          return "blah";
	        },
	        configurable: true
	      });
	      result = document._xyz === "blah";
	      delete document._xyz;
	    }
	    catch (e) {
	      result = false;
	    }
	    return result;
	  })();
	
	
	// Add the "private" property for testing, even if the real property can be polyfilled
	document._currentScript = _currentEvaluatingScript;
	
	// Polyfill it!
	if (needsPolyfill && canDefineProp && typeof canPolyfill !== "undefined" && canPolyfill) {
	  Object.defineProperty(document, "currentScript", {
	    get: _currentEvaluatingScript
	  });
	}
	
	})();


/***/ }),
/* 169 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/invariant.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ }),
/* 170 */
/*!*************************!*\
  !*** ./~/flux/index.js ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(/*! ./lib/Dispatcher */ 171);


/***/ }),
/* 171 */
/*!**********************************!*\
  !*** ./~/flux/lib/Dispatcher.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 169);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ }),
/* 172 */
/*!***************************************************!*\
  !*** ./~/html-loader!./src/utils/ui/captcha.html ***!
  \***************************************************/
/***/ (function(module, exports) {

	module.exports = "<div class=hull-captcha-banner-container> <h3 class=hull-banner-title>A lot of users have been created with your IP!</h3> <p class=hull-banner-text>Please prove us that you are a Human.</p> <div class=hull-captcha-container></div> </div> ";

/***/ }),
/* 173 */
/*!****************************************************!*\
  !*** ./~/html-loader!./src/utils/ui/platform.html ***!
  \****************************************************/
/***/ (function(module, exports) {

	module.exports = "<div class=hull-banner-container> <h3 class=hull-banner-title>Congratulations! Hull is ready.</h3> <p class=hull-banner-text>Your snippet is correctly installed and configured <br/> <i>This banner is only visible to you.</i></p> <a class=hull-banner-button data-hull-intent=hull.snippet.success href=#>Close Window</a> </div> ";

/***/ }),
/* 174 */
/*!*******************************!*\
  !*** ./~/lodash/_DataView.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19),
	    root = __webpack_require__(/*! ./_root */ 8);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 175 */
/*!***************************!*\
  !*** ./~/lodash/_Hash.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(/*! ./_hashClear */ 245),
	    hashDelete = __webpack_require__(/*! ./_hashDelete */ 246),
	    hashGet = __webpack_require__(/*! ./_hashGet */ 247),
	    hashHas = __webpack_require__(/*! ./_hashHas */ 248),
	    hashSet = __webpack_require__(/*! ./_hashSet */ 249);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 176 */
/*!******************************!*\
  !*** ./~/lodash/_Promise.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19),
	    root = __webpack_require__(/*! ./_root */ 8);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 177 */
/*!******************************!*\
  !*** ./~/lodash/_WeakMap.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ./_getNative */ 19),
	    root = __webpack_require__(/*! ./_root */ 8);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 178 */
/*!**********************************!*\
  !*** ./~/lodash/_addMapEntry.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 179 */
/*!**********************************!*\
  !*** ./~/lodash/_addSetEntry.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 180 */
/*!**************************************!*\
  !*** ./~/lodash/_arrayAggregator.js ***!
  \**************************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),
/* 181 */
/*!*********************************!*\
  !*** ./~/lodash/_arrayEvery.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 182 */
/*!************************************!*\
  !*** ./~/lodash/_arrayIncludes.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ 59);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 183 */
/*!****************************************!*\
  !*** ./~/lodash/_arrayIncludesWith.js ***!
  \****************************************/
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 184 */
/*!********************************!*\
  !*** ./~/lodash/_asciiSize.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(/*! ./_baseProperty */ 99);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ }),
/* 185 */
/*!***********************************!*\
  !*** ./~/lodash/_asciiToArray.js ***!
  \***********************************/
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 186 */
/*!*************************************!*\
  !*** ./~/lodash/_baseAggregator.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./_baseEach */ 17);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),
/* 187 */
/*!*********************************!*\
  !*** ./~/lodash/_baseAssign.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 188 */
/*!***********************************!*\
  !*** ./~/lodash/_baseAssignIn.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    keysIn = __webpack_require__(/*! ./keysIn */ 71);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 189 */
/*!********************************!*\
  !*** ./~/lodash/_baseClone.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(/*! ./_Stack */ 54),
	    arrayEach = __webpack_require__(/*! ./_arrayEach */ 92),
	    assignValue = __webpack_require__(/*! ./_assignValue */ 58),
	    baseAssign = __webpack_require__(/*! ./_baseAssign */ 187),
	    baseAssignIn = __webpack_require__(/*! ./_baseAssignIn */ 188),
	    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ 221),
	    copyArray = __webpack_require__(/*! ./_copyArray */ 102),
	    copySymbols = __webpack_require__(/*! ./_copySymbols */ 228),
	    copySymbolsIn = __webpack_require__(/*! ./_copySymbolsIn */ 229),
	    getAllKeys = __webpack_require__(/*! ./_getAllKeys */ 107),
	    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 108),
	    getTag = __webpack_require__(/*! ./_getTag */ 27),
	    initCloneArray = __webpack_require__(/*! ./_initCloneArray */ 250),
	    initCloneByTag = __webpack_require__(/*! ./_initCloneByTag */ 251),
	    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ 252),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isBuffer = __webpack_require__(/*! ./isBuffer */ 44),
	    isObject = __webpack_require__(/*! ./isObject */ 7),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 190 */
/*!*********************************!*\
  !*** ./~/lodash/_baseCreate.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 191 */
/*!********************************!*\
  !*** ./~/lodash/_baseEvery.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./_baseEach */ 17);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ }),
/* 192 */
/*!**********************************!*\
  !*** ./~/lodash/_baseFlatten.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(/*! ./_arrayPush */ 56),
	    isFlattenable = __webpack_require__(/*! ./_isFlattenable */ 253);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 193 */
/*!******************************!*\
  !*** ./~/lodash/_baseFor.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(/*! ./_createBaseFor */ 234);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 194 */
/*!*********************************!*\
  !*** ./~/lodash/_baseForOwn.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(/*! ./_baseFor */ 193),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 195 */
/*!********************************!*\
  !*** ./~/lodash/_baseHasIn.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 196 */
/*!**************************************!*\
  !*** ./~/lodash/_baseIsArguments.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 197 */
/*!**************************************!*\
  !*** ./~/lodash/_baseIsEqualDeep.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(/*! ./_Stack */ 54),
	    equalArrays = __webpack_require__(/*! ./_equalArrays */ 104),
	    equalByTag = __webpack_require__(/*! ./_equalByTag */ 239),
	    equalObjects = __webpack_require__(/*! ./_equalObjects */ 240),
	    getTag = __webpack_require__(/*! ./_getTag */ 27),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isBuffer = __webpack_require__(/*! ./isBuffer */ 44),
	    isTypedArray = __webpack_require__(/*! ./isTypedArray */ 70);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 198 */
/*!**********************************!*\
  !*** ./~/lodash/_baseIsMatch.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(/*! ./_Stack */ 54),
	    baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ 60);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 199 */
/*!********************************!*\
  !*** ./~/lodash/_baseIsNaN.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 200 */
/*!***********************************!*\
  !*** ./~/lodash/_baseIsNative.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(/*! ./isFunction */ 68),
	    isMasked = __webpack_require__(/*! ./_isMasked */ 255),
	    isObject = __webpack_require__(/*! ./isObject */ 7),
	    toSource = __webpack_require__(/*! ./_toSource */ 116);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 201 */
/*!***************************************!*\
  !*** ./~/lodash/_baseIsTypedArray.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 18),
	    isLength = __webpack_require__(/*! ./isLength */ 69),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 202 */
/*!*********************************!*\
  !*** ./~/lodash/_baseKeysIn.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7),
	    isPrototype = __webpack_require__(/*! ./_isPrototype */ 40),
	    nativeKeysIn = __webpack_require__(/*! ./_nativeKeysIn */ 269);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 203 */
/*!******************************!*\
  !*** ./~/lodash/_baseMap.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./_baseEach */ 17),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 204 */
/*!**********************************!*\
  !*** ./~/lodash/_baseMatches.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(/*! ./_baseIsMatch */ 198),
	    getMatchData = __webpack_require__(/*! ./_getMatchData */ 241),
	    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ 112);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 205 */
/*!******************************************!*\
  !*** ./~/lodash/_baseMatchesProperty.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ 60),
	    get = __webpack_require__(/*! ./get */ 300),
	    hasIn = __webpack_require__(/*! ./hasIn */ 117),
	    isKey = __webpack_require__(/*! ./_isKey */ 66),
	    isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ 111),
	    matchesStrictComparable = __webpack_require__(/*! ./_matchesStrictComparable */ 112),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 206 */
/*!*******************************!*\
  !*** ./~/lodash/_basePick.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(/*! ./_basePickBy */ 207),
	    hasIn = __webpack_require__(/*! ./hasIn */ 117);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 207 */
/*!*********************************!*\
  !*** ./~/lodash/_basePickBy.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./_baseGet */ 37),
	    baseSet = __webpack_require__(/*! ./_baseSet */ 210),
	    castPath = __webpack_require__(/*! ./_castPath */ 21);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 208 */
/*!***************************************!*\
  !*** ./~/lodash/_basePropertyDeep.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./_baseGet */ 37);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 209 */
/*!*********************************!*\
  !*** ./~/lodash/_baseReduce.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 210 */
/*!******************************!*\
  !*** ./~/lodash/_baseSet.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(/*! ./_assignValue */ 58),
	    castPath = __webpack_require__(/*! ./_castPath */ 21),
	    isIndex = __webpack_require__(/*! ./_isIndex */ 39),
	    isObject = __webpack_require__(/*! ./isObject */ 7),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 211 */
/*!**************************************!*\
  !*** ./~/lodash/_baseSetToString.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(/*! ./constant */ 289),
	    defineProperty = __webpack_require__(/*! ./_defineProperty */ 103),
	    identity = __webpack_require__(/*! ./identity */ 42);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 212 */
/*!********************************!*\
  !*** ./~/lodash/_baseSlice.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 213 */
/*!*******************************!*\
  !*** ./~/lodash/_baseSome.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./_baseEach */ 17);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 214 */
/*!********************************!*\
  !*** ./~/lodash/_baseTimes.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 215 */
/*!***********************************!*\
  !*** ./~/lodash/_baseToString.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16),
	    arrayMap = __webpack_require__(/*! ./_arrayMap */ 35),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isSymbol = __webpack_require__(/*! ./isSymbol */ 46);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 216 */
/*!********************************!*\
  !*** ./~/lodash/_baseUnary.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 217 */
/*!*******************************!*\
  !*** ./~/lodash/_baseUniq.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(/*! ./_SetCache */ 89),
	    arrayIncludes = __webpack_require__(/*! ./_arrayIncludes */ 182),
	    arrayIncludesWith = __webpack_require__(/*! ./_arrayIncludesWith */ 183),
	    cacheHas = __webpack_require__(/*! ./_cacheHas */ 101),
	    createSet = __webpack_require__(/*! ./_createSet */ 236),
	    setToArray = __webpack_require__(/*! ./_setToArray */ 28);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 218 */
/*!********************************!*\
  !*** ./~/lodash/_baseUnset.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(/*! ./_castPath */ 21),
	    last = __webpack_require__(/*! ./last */ 306),
	    parent = __webpack_require__(/*! ./_parent */ 272),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 219 */
/*!*********************************!*\
  !*** ./~/lodash/_baseValues.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(/*! ./_arrayMap */ 35);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 220 */
/*!***********************************!*\
  !*** ./~/lodash/_castFunction.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(/*! ./identity */ 42);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 221 */
/*!**********************************!*\
  !*** ./~/lodash/_cloneBuffer.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ 8);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 48)(module)))

/***/ }),
/* 222 */
/*!************************************!*\
  !*** ./~/lodash/_cloneDataView.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 62);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 223 */
/*!*******************************!*\
  !*** ./~/lodash/_cloneMap.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(/*! ./_addMapEntry */ 178),
	    arrayReduce = __webpack_require__(/*! ./_arrayReduce */ 57),
	    mapToArray = __webpack_require__(/*! ./_mapToArray */ 67);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 224 */
/*!**********************************!*\
  !*** ./~/lodash/_cloneRegExp.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 225 */
/*!*******************************!*\
  !*** ./~/lodash/_cloneSet.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(/*! ./_addSetEntry */ 179),
	    arrayReduce = __webpack_require__(/*! ./_arrayReduce */ 57),
	    setToArray = __webpack_require__(/*! ./_setToArray */ 28);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 226 */
/*!**********************************!*\
  !*** ./~/lodash/_cloneSymbol.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 227 */
/*!**************************************!*\
  !*** ./~/lodash/_cloneTypedArray.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 62);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 228 */
/*!**********************************!*\
  !*** ./~/lodash/_copySymbols.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    getSymbols = __webpack_require__(/*! ./_getSymbols */ 64);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 229 */
/*!************************************!*\
  !*** ./~/lodash/_copySymbolsIn.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 109);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 230 */
/*!*********************************!*\
  !*** ./~/lodash/_coreJsData.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(/*! ./_root */ 8);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 231 */
/*!***************************************!*\
  !*** ./~/lodash/_createAggregator.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(/*! ./_arrayAggregator */ 180),
	    baseAggregator = __webpack_require__(/*! ./_baseAggregator */ 186),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),
/* 232 */
/*!*************************************!*\
  !*** ./~/lodash/_createAssigner.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(/*! ./_baseRest */ 100),
	    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 65);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 233 */
/*!*************************************!*\
  !*** ./~/lodash/_createBaseEach.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 234 */
/*!************************************!*\
  !*** ./~/lodash/_createBaseFor.js ***!
  \************************************/
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 235 */
/*!*********************************!*\
  !*** ./~/lodash/_createFind.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 236 */
/*!********************************!*\
  !*** ./~/lodash/_createSet.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(/*! ./_Set */ 88),
	    noop = __webpack_require__(/*! ./noop */ 310),
	    setToArray = __webpack_require__(/*! ./_setToArray */ 28);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 237 */
/*!*********************************************!*\
  !*** ./~/lodash/_customDefaultsAssignIn.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(/*! ./eq */ 29);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ }),
/* 238 */
/*!**************************************!*\
  !*** ./~/lodash/_customOmitClone.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(/*! ./isPlainObject */ 118);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 239 */
/*!*********************************!*\
  !*** ./~/lodash/_equalByTag.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16),
	    Uint8Array = __webpack_require__(/*! ./_Uint8Array */ 90),
	    eq = __webpack_require__(/*! ./eq */ 29),
	    equalArrays = __webpack_require__(/*! ./_equalArrays */ 104),
	    mapToArray = __webpack_require__(/*! ./_mapToArray */ 67),
	    setToArray = __webpack_require__(/*! ./_setToArray */ 28);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 240 */
/*!***********************************!*\
  !*** ./~/lodash/_equalObjects.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(/*! ./_getAllKeys */ 107);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 241 */
/*!***********************************!*\
  !*** ./~/lodash/_getMatchData.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(/*! ./_isStrictComparable */ 111),
	    keys = __webpack_require__(/*! ./keys */ 13);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 242 */
/*!********************************!*\
  !*** ./~/lodash/_getRawTag.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 243 */
/*!*******************************!*\
  !*** ./~/lodash/_getValue.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 244 */
/*!******************************!*\
  !*** ./~/lodash/_hasPath.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(/*! ./_castPath */ 21),
	    isArguments = __webpack_require__(/*! ./isArguments */ 43),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isIndex = __webpack_require__(/*! ./_isIndex */ 39),
	    isLength = __webpack_require__(/*! ./isLength */ 69),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 245 */
/*!********************************!*\
  !*** ./~/lodash/_hashClear.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ 41);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 246 */
/*!*********************************!*\
  !*** ./~/lodash/_hashDelete.js ***!
  \*********************************/
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 247 */
/*!******************************!*\
  !*** ./~/lodash/_hashGet.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ 41);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 248 */
/*!******************************!*\
  !*** ./~/lodash/_hashHas.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ 41);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 249 */
/*!******************************!*\
  !*** ./~/lodash/_hashSet.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ 41);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 250 */
/*!*************************************!*\
  !*** ./~/lodash/_initCloneArray.js ***!
  \*************************************/
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 251 */
/*!*************************************!*\
  !*** ./~/lodash/_initCloneByTag.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 62),
	    cloneDataView = __webpack_require__(/*! ./_cloneDataView */ 222),
	    cloneMap = __webpack_require__(/*! ./_cloneMap */ 223),
	    cloneRegExp = __webpack_require__(/*! ./_cloneRegExp */ 224),
	    cloneSet = __webpack_require__(/*! ./_cloneSet */ 225),
	    cloneSymbol = __webpack_require__(/*! ./_cloneSymbol */ 226),
	    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ 227);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 252 */
/*!**************************************!*\
  !*** ./~/lodash/_initCloneObject.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(/*! ./_baseCreate */ 190),
	    getPrototype = __webpack_require__(/*! ./_getPrototype */ 63),
	    isPrototype = __webpack_require__(/*! ./_isPrototype */ 40);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 253 */
/*!************************************!*\
  !*** ./~/lodash/_isFlattenable.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16),
	    isArguments = __webpack_require__(/*! ./isArguments */ 43),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 254 */
/*!********************************!*\
  !*** ./~/lodash/_isKeyable.js ***!
  \********************************/
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 255 */
/*!*******************************!*\
  !*** ./~/lodash/_isMasked.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(/*! ./_coreJsData */ 230);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 256 */
/*!**************************************!*\
  !*** ./~/lodash/_iteratorToArray.js ***!
  \**************************************/
/***/ (function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ }),
/* 257 */
/*!*************************************!*\
  !*** ./~/lodash/_listCacheClear.js ***!
  \*************************************/
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 258 */
/*!**************************************!*\
  !*** ./~/lodash/_listCacheDelete.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ 36);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 259 */
/*!***********************************!*\
  !*** ./~/lodash/_listCacheGet.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ 36);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 260 */
/*!***********************************!*\
  !*** ./~/lodash/_listCacheHas.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ 36);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 261 */
/*!***********************************!*\
  !*** ./~/lodash/_listCacheSet.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ 36);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 262 */
/*!************************************!*\
  !*** ./~/lodash/_mapCacheClear.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(/*! ./_Hash */ 175),
	    ListCache = __webpack_require__(/*! ./_ListCache */ 34),
	    Map = __webpack_require__(/*! ./_Map */ 52);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 263 */
/*!*************************************!*\
  !*** ./~/lodash/_mapCacheDelete.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(/*! ./_getMapData */ 38);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 264 */
/*!**********************************!*\
  !*** ./~/lodash/_mapCacheGet.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(/*! ./_getMapData */ 38);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 265 */
/*!**********************************!*\
  !*** ./~/lodash/_mapCacheHas.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(/*! ./_getMapData */ 38);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 266 */
/*!**********************************!*\
  !*** ./~/lodash/_mapCacheSet.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(/*! ./_getMapData */ 38);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 267 */
/*!************************************!*\
  !*** ./~/lodash/_memoizeCapped.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(/*! ./memoize */ 308);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 268 */
/*!*********************************!*\
  !*** ./~/lodash/_nativeKeys.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(/*! ./_overArg */ 113);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 269 */
/*!***********************************!*\
  !*** ./~/lodash/_nativeKeysIn.js ***!
  \***********************************/
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 270 */
/*!*******************************!*\
  !*** ./~/lodash/_nodeUtil.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ 106);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 48)(module)))

/***/ }),
/* 271 */
/*!*************************************!*\
  !*** ./~/lodash/_objectToString.js ***!
  \*************************************/
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 272 */
/*!*****************************!*\
  !*** ./~/lodash/_parent.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./_baseGet */ 37),
	    baseSlice = __webpack_require__(/*! ./_baseSlice */ 212);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 273 */
/*!**********************************!*\
  !*** ./~/lodash/_setCacheAdd.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 274 */
/*!**********************************!*\
  !*** ./~/lodash/_setCacheHas.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 275 */
/*!*******************************!*\
  !*** ./~/lodash/_shortOut.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 276 */
/*!*********************************!*\
  !*** ./~/lodash/_stackClear.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(/*! ./_ListCache */ 34);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 277 */
/*!**********************************!*\
  !*** ./~/lodash/_stackDelete.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 278 */
/*!*******************************!*\
  !*** ./~/lodash/_stackGet.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 279 */
/*!*******************************!*\
  !*** ./~/lodash/_stackHas.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 280 */
/*!*******************************!*\
  !*** ./~/lodash/_stackSet.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(/*! ./_ListCache */ 34),
	    Map = __webpack_require__(/*! ./_Map */ 52),
	    MapCache = __webpack_require__(/*! ./_MapCache */ 53);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 281 */
/*!************************************!*\
  !*** ./~/lodash/_strictIndexOf.js ***!
  \************************************/
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 282 */
/*!*********************************!*\
  !*** ./~/lodash/_stringSize.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(/*! ./_asciiSize */ 184),
	    hasUnicode = __webpack_require__(/*! ./_hasUnicode */ 110),
	    unicodeSize = __webpack_require__(/*! ./_unicodeSize */ 285);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ }),
/* 283 */
/*!************************************!*\
  !*** ./~/lodash/_stringToArray.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(/*! ./_asciiToArray */ 185),
	    hasUnicode = __webpack_require__(/*! ./_hasUnicode */ 110),
	    unicodeToArray = __webpack_require__(/*! ./_unicodeToArray */ 286);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 284 */
/*!***********************************!*\
  !*** ./~/lodash/_stringToPath.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(/*! ./_memoizeCapped */ 267);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 285 */
/*!**********************************!*\
  !*** ./~/lodash/_unicodeSize.js ***!
  \**********************************/
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ }),
/* 286 */
/*!*************************************!*\
  !*** ./~/lodash/_unicodeToArray.js ***!
  \*************************************/
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 287 */
/*!**********************************!*\
  !*** ./~/lodash/assignInWith.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    createAssigner = __webpack_require__(/*! ./_createAssigner */ 232),
	    keysIn = __webpack_require__(/*! ./keysIn */ 71);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 288 */
/*!*****************************!*\
  !*** ./~/lodash/compact.js ***!
  \*****************************/
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 289 */
/*!******************************!*\
  !*** ./~/lodash/constant.js ***!
  \******************************/
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 290 */
/*!******************************!*\
  !*** ./~/lodash/debounce.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7),
	    now = __webpack_require__(/*! ./now */ 311),
	    toNumber = __webpack_require__(/*! ./toNumber */ 120);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 291 */
/*!******************************!*\
  !*** ./~/lodash/defaults.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(/*! ./_apply */ 91),
	    assignInWith = __webpack_require__(/*! ./assignInWith */ 287),
	    baseRest = __webpack_require__(/*! ./_baseRest */ 100),
	    customDefaultsAssignIn = __webpack_require__(/*! ./_customDefaultsAssignIn */ 237);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ }),
/* 292 */
/*!**************************!*\
  !*** ./~/lodash/each.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./forEach */ 298);


/***/ }),
/* 293 */
/*!***************************!*\
  !*** ./~/lodash/every.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(/*! ./_arrayEvery */ 181),
	    baseEvery = __webpack_require__(/*! ./_baseEvery */ 191),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 65);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ }),
/* 294 */
/*!****************************!*\
  !*** ./~/lodash/filter.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ 55),
	    baseFilter = __webpack_require__(/*! ./_baseFilter */ 96),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 295 */
/*!**************************!*\
  !*** ./~/lodash/find.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(/*! ./_createFind */ 235),
	    findIndex = __webpack_require__(/*! ./findIndex */ 296);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 296 */
/*!*******************************!*\
  !*** ./~/lodash/findIndex.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ 97),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    toInteger = __webpack_require__(/*! ./toInteger */ 72);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 297 */
/*!*****************************!*\
  !*** ./~/lodash/flatten.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(/*! ./_baseFlatten */ 192);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 298 */
/*!*****************************!*\
  !*** ./~/lodash/forEach.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(/*! ./_arrayEach */ 92),
	    baseEach = __webpack_require__(/*! ./_baseEach */ 17),
	    castFunction = __webpack_require__(/*! ./_castFunction */ 220),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 299 */
/*!*******************************!*\
  !*** ./~/lodash/fromPairs.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ }),
/* 300 */
/*!*************************!*\
  !*** ./~/lodash/get.js ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./_baseGet */ 37);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 301 */
/*!******************************!*\
  !*** ./~/lodash/includes.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ 59),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    isString = __webpack_require__(/*! ./isString */ 45),
	    toInteger = __webpack_require__(/*! ./toInteger */ 72),
	    values = __webpack_require__(/*! ./values */ 73);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 302 */
/*!*****************************!*\
  !*** ./~/lodash/indexOf.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ 59),
	    toInteger = __webpack_require__(/*! ./toInteger */ 72);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the
	 * offset from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseIndexOf(array, value, index);
	}
	
	module.exports = indexOf;


/***/ }),
/* 303 */
/*!*******************************!*\
  !*** ./~/lodash/isElement.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(/*! ./isObjectLike */ 12),
	    isPlainObject = __webpack_require__(/*! ./isPlainObject */ 118);
	
	/**
	 * Checks if `value` is likely a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	}
	
	module.exports = isElement;


/***/ }),
/* 304 */
/*!*****************************!*\
  !*** ./~/lodash/isEmpty.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(/*! ./_baseKeys */ 61),
	    getTag = __webpack_require__(/*! ./_getTag */ 27),
	    isArguments = __webpack_require__(/*! ./isArguments */ 43),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    isBuffer = __webpack_require__(/*! ./isBuffer */ 44),
	    isPrototype = __webpack_require__(/*! ./_isPrototype */ 40),
	    isTypedArray = __webpack_require__(/*! ./isTypedArray */ 70);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 305 */
/*!*****************************!*\
  !*** ./~/lodash/isEqual.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ 60);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 306 */
/*!**************************!*\
  !*** ./~/lodash/last.js ***!
  \**************************/
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 307 */
/*!*************************!*\
  !*** ./~/lodash/map.js ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(/*! ./_arrayMap */ 35),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    baseMap = __webpack_require__(/*! ./_baseMap */ 203),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 308 */
/*!*****************************!*\
  !*** ./~/lodash/memoize.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(/*! ./_MapCache */ 53);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 309 */
/*!****************************!*\
  !*** ./~/lodash/negate.js ***!
  \****************************/
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 310 */
/*!**************************!*\
  !*** ./~/lodash/noop.js ***!
  \**************************/
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 311 */
/*!*************************!*\
  !*** ./~/lodash/now.js ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(/*! ./_root */ 8);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 312 */
/*!**************************!*\
  !*** ./~/lodash/omit.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(/*! ./_arrayMap */ 35),
	    baseClone = __webpack_require__(/*! ./_baseClone */ 189),
	    baseUnset = __webpack_require__(/*! ./_baseUnset */ 218),
	    castPath = __webpack_require__(/*! ./_castPath */ 21),
	    copyObject = __webpack_require__(/*! ./_copyObject */ 22),
	    customOmitClone = __webpack_require__(/*! ./_customOmitClone */ 238),
	    flatRest = __webpack_require__(/*! ./_flatRest */ 105),
	    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 108);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 313 */
/*!*******************************!*\
  !*** ./~/lodash/partition.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(/*! ./_createAggregator */ 231);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, the second of which
	 * contains elements `predicate` returns falsey for. The predicate is
	 * invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * _.partition(users, function(o) { return o.active; });
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.partition(users, { 'age': 1, 'active': false });
	 * // => objects for [['pebbles'], ['barney', 'fred']]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.partition(users, ['active', false]);
	 * // => objects for [['barney', 'pebbles'], ['fred']]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.partition(users, 'active');
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ }),
/* 314 */
/*!**************************!*\
  !*** ./~/lodash/pick.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(/*! ./_basePick */ 206),
	    flatRest = __webpack_require__(/*! ./_flatRest */ 105);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 315 */
/*!******************************!*\
  !*** ./~/lodash/property.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(/*! ./_baseProperty */ 99),
	    basePropertyDeep = __webpack_require__(/*! ./_basePropertyDeep */ 208),
	    isKey = __webpack_require__(/*! ./_isKey */ 66),
	    toKey = __webpack_require__(/*! ./_toKey */ 23);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 316 */
/*!****************************!*\
  !*** ./~/lodash/reduce.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(/*! ./_arrayReduce */ 57),
	    baseEach = __webpack_require__(/*! ./_baseEach */ 17),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    baseReduce = __webpack_require__(/*! ./_baseReduce */ 209),
	    isArray = __webpack_require__(/*! ./isArray */ 2);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 317 */
/*!****************************!*\
  !*** ./~/lodash/reject.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ 55),
	    baseFilter = __webpack_require__(/*! ./_baseFilter */ 96),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    negate = __webpack_require__(/*! ./negate */ 309);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	module.exports = reject;


/***/ }),
/* 318 */
/*!**************************!*\
  !*** ./~/lodash/size.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(/*! ./_baseKeys */ 61),
	    getTag = __webpack_require__(/*! ./_getTag */ 27),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    isString = __webpack_require__(/*! ./isString */ 45),
	    stringSize = __webpack_require__(/*! ./_stringSize */ 282);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ }),
/* 319 */
/*!**************************!*\
  !*** ./~/lodash/some.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(/*! ./_arraySome */ 94),
	    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 10),
	    baseSome = __webpack_require__(/*! ./_baseSome */ 213),
	    isArray = __webpack_require__(/*! ./isArray */ 2),
	    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 65);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 320 */
/*!*******************************!*\
  !*** ./~/lodash/stubFalse.js ***!
  \*******************************/
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 321 */
/*!******************************!*\
  !*** ./~/lodash/throttle.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(/*! ./debounce */ 290),
	    isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 322 */
/*!*****************************!*\
  !*** ./~/lodash/toArray.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(/*! ./_Symbol */ 16),
	    copyArray = __webpack_require__(/*! ./_copyArray */ 102),
	    getTag = __webpack_require__(/*! ./_getTag */ 27),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 9),
	    isString = __webpack_require__(/*! ./isString */ 45),
	    iteratorToArray = __webpack_require__(/*! ./_iteratorToArray */ 256),
	    mapToArray = __webpack_require__(/*! ./_mapToArray */ 67),
	    setToArray = __webpack_require__(/*! ./_setToArray */ 28),
	    stringToArray = __webpack_require__(/*! ./_stringToArray */ 283),
	    values = __webpack_require__(/*! ./values */ 73);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ }),
/* 323 */
/*!******************************!*\
  !*** ./~/lodash/toFinite.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(/*! ./toNumber */ 120);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 324 */
/*!******************************!*\
  !*** ./~/lodash/toString.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(/*! ./_baseToString */ 215);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 325 */
/*!**************************!*\
  !*** ./~/lodash/uniq.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(/*! ./_baseUniq */ 217);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 326 */
/*!******************************************!*\
  !*** ./~/putainde-localstorage/index.js ***!
  \******************************************/
/***/ (function(module, exports) {

	/**
	 * global variables
	 */
	var namespace = ""
	var cache = {}
	
	function getCache(ns){
	  if(cache[ns] === undefined) {
	    cache[ns] = storageEngine.get(ns) || {}
	  }
	
	  return cache[ns]
	}
	
	function setCache(ns, c){
	  cache[ns] = c
	  return storageEngine.set(ns, cache[ns])
	}
	
	/**
	 * Expose library
	 */
	module.exports = Storage
	
	/**
	 * Constructor
	 * @param {Object} cfg options
	 */
	function Storage(cfg){
	  cfg = cfg || {}
	  this.ns = cfg.namespace || "storage"
	}
	
	/**
	 * nicer constructor
	 * @param  {Object} cfg options
	 * @return {Object} Storage instance
	 */
	Storage.create = function(cfg){
	  return new Storage(cfg)
	}
	
	/**
	 * Storage API
	 * @type {Object}
	 */
	Storage.prototype = {
	  /**
	   * setter
	   *
	   * @param {String|Object} key   key or an {key: value} object
	   * @param {Object} value value if first parameter is a key
	   */
	  set : function(key, value){
	    var c = getCache(this.ns)
	
	    // set({foo: "bar"})
	    if(arguments.length === 1 && typeof key === "object") {
	      Object.keys(key).forEach(function(k){
	        c[k] = key[k]
	      }, this)
	    }
	
	    // set("foo", "bar")
	    else {
	      c[key] = value
	    }
	
	    return setCache(this.ns, c)
	  },
	
	  /**
	   * getter
	   *
	   * @param  {Object} key
	   * @param  {Object} defaultValue
	   * @return {Object} value corresponding to key or all values if no key provided
	   */
	  get : function(key, defaultValue){
	    var c = getCache(this.ns)
	
	    if(arguments.length === 0) {
	      return c
	    }
	
	    return c[key] !== undefined ? c[key] : defaultValue
	  },
	
	  /**
	   * remove value corresponding to the given key
	   * @param  {String} key
	   */
	  remove : function(key){
	    var cache = getCache(this.ns)
	    delete cache[key]
	    setCache(this.ns, cache)
	  },
	
	  /**
	   * remove all values
	   */
	  clear : function(){
	    setCache(this.ns, {})
	  }
	}
	
	/**
	 * localStorage engine
	 * @type {Object}
	 */
	var storageEngine = {
	  get : function(key){
	    var value = window.localStorage.getItem(namespace + key)
	
	    try{
	      value = JSON.parse(value)
	    }
	    catch(e) {
	      if(console && console.warn) console.warn("'" + key + "'" + " isn't valid JSON: " + value)
	    }
	
	    return value || {}
	  },
	
	  set : function(key, value){
	    return window.localStorage.setItem(namespace + key, JSON.stringify(value))
	  },
	
	  remove : function(key){
	    return window.localStorage.removeItem(namespace + key)
	  }
	}


/***/ }),
/* 327 */
/*!***************************!*\
  !*** ./~/qs/lib/index.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(/*! ./stringify */ 329);
	var parse = __webpack_require__(/*! ./parse */ 328);
	var formats = __webpack_require__(/*! ./formats */ 122);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 328 */
/*!***************************!*\
  !*** ./~/qs/lib/parse.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(/*! ./utils */ 123);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 329 */
/*!*******************************!*\
  !*** ./~/qs/lib/stringify.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(/*! ./utils */ 123);
	var formats = __webpack_require__(/*! ./formats */ 122);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 330 */
/*!**************************************************************************!*\
  !*** ./~/raw-loader!./~/inline-style-loader!./src/utils/ui/platform.css ***!
  \**************************************************************************/
/***/ (function(module, exports) {

	module.exports = {".hull-banner-container":"position: fixed; top: 0; left: 0; right: 0; padding: 30px 0; background: white; -webkit-font-smoothing: antialiased; text-align: center",".hull-captcha-banner-container":"position: fixed; top: 0; left: 0; right: 0; height: 100%; padding: 30px 0; background: white; background: rgba(255,255,255,.95)\n  -webkit-font-smoothing: antialiased; text-align: center",".hull-banner-title":"color: #666; margin: 0 0 5px 0; font-size: 24px; font-weight: normal; font-family: 'Helvetica Neue',Helvetica,arial,sans-serif",".hull-banner-text":"font-size: 14px; margin: 0 0 10px 0; color: #838383; font-weight: normal; font-family: 'Helvetica Neue',Helvetica,arial,sans-serif",".hull-banner-button":"-webkit-border-radius: 3px; -moz-border-radius: 3px; -ms-border-radius: 3px; -o-border-radius: 3px; border-radius: 3px; margin: 0; background: white; color: #33ADEC; border: 1px solid #33ADEC; padding: 10px 30px; font-size: 14px; line-height: 50px; font-weight: normal",".hull-captcha-container":"width: 304px; margin: 30px auto 0 auto"}

/***/ }),
/* 331 */
/*!*************************************!*\
  !*** ./~/reduce-component/index.js ***!
  \*************************************/
/***/ (function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ }),
/* 332 */
/*!****************************************!*\
  !*** ./~/setimmediate/setImmediate.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(/*! ./../process/browser.js */ 121)))

/***/ }),
/* 333 */
/*!******************************************!*\
  !*** ./~/superagent/lib/request-base.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(/*! ./is-object */ 124);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ }),
/* 334 */
/*!*************************************!*\
  !*** ./~/superagent/lib/request.js ***!
  \*************************************/
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 335 */
/*!*************************************!*\
  !*** ./~/timers-browserify/main.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(/*! setimmediate */ 332);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 336 */
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 337 */
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// hull.js